/*!
 * fastclick.min.js
 */
/*
 FastClick: polyfill to remove click delays on browsers with touch UIs.

 @version 1.0.3
 @codingstandard ftlabs-jsv2
 @copyright The Financial Times Limited [All Rights Reserved]
 @license MIT License (see LICENSE.txt)
*/
!function() {
    "use strict";
    function e(t, i) {
        function r(e, t) {
            return function() { 
                return e.apply(t, arguments)
            }
        }
        var o;
        if (i = i || {},
        this.trackingClick = !1,
        this.trackingClickStart = 0,
        this.targetElement = null,
        this.touchStartX = 0,
        this.touchStartY = 0,
        this.lastTouchIdentifier = 0,
        this.touchBoundary = i.touchBoundary || 10,
        this.layer = t,
        this.tapDelay = i.tapDelay || 200,
        this.tapTimeout = i.tapTimeout || 700,
        !e.notNeeded(t)) {
            for (var s = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], a = this, l = 0, c = s.length; l < c; l++)
                a[s[l]] = r(a[s[l]], a);
            n && (t.addEventListener("mouseover", this.onMouse, !0),
            t.addEventListener("mousedown", this.onMouse, !0),
            t.addEventListener("mouseup", this.onMouse, !0)),
            t.addEventListener("click", this.onClick, !0),
            t.addEventListener("touchstart", this.onTouchStart, !1),
            t.addEventListener("touchmove", this.onTouchMove, !1),
            t.addEventListener("touchend", this.onTouchEnd, !1),
            t.addEventListener("touchcancel", this.onTouchCancel, !1),
            Event.prototype.stopImmediatePropagation || (t.removeEventListener = function(e, n, i) {
                var r = Node.prototype.removeEventListener;
                "click" === e ? r.call(t, e, n.hijacked || n, i) : r.call(t, e, n, i)
            }
            ,
            t.addEventListener = function(e, n, i) {
                var r = Node.prototype.addEventListener;
                "click" === e ? r.call(t, e, n.hijacked || (n.hijacked = function(e) {
                    e.propagationStopped || n(e)
                }
                ), i) : r.call(t, e, n, i)
            }
            ),
            "function" == typeof t.onclick && (o = t.onclick,
            t.addEventListener("click", function(e) {
                o(e)
            }, !1),
            t.onclick = null)
        }
    }
    var t = navigator.userAgent.indexOf("Windows Phone") >= 0
      , n = navigator.userAgent.indexOf("Android") > 0 && !t
      , i = /iP(ad|hone|od)/.test(navigator.userAgent) && !t
      , r = i && /OS 4_\d(_\d)?/.test(navigator.userAgent)
      , o = i && /OS ([6-9]|\d{2})_\d/.test(navigator.userAgent)
      , s = navigator.userAgent.indexOf("BB10") > 0;
    e.prototype.needsClick = function(e) {
        switch (e.nodeName.toLowerCase()) {
        case "button":
        case "select":
        case "textarea":
            if (e.disabled)
                return !0;
            break;
        case "input":
            if (i && "file" === e.type || e.disabled)
                return !0;
            break;
        case "label":
        case "iframe":
        case "video":
            return !0
        }
        return /\bneedsclick\b/.test(e.className)
    }
    ,
    e.prototype.needsFocus = function(e) {
        switch (e.nodeName.toLowerCase()) {
        case "textarea":
            return !0;
        case "select":
            return !n;
        case "input":
            switch (e.type) {
            case "button":
            case "checkbox":
            case "file":
            case "image":
            case "radio":
            case "submit":
                return !1
            }
            return !e.disabled && !e.readOnly;
        default:
            return /\bneedsfocus\b/.test(e.className)
        }
    }
    ,
    e.prototype.sendClick = function(e, t) {
        var n, i;
        document.activeElement && document.activeElement !== e && document.activeElement.blur(),
        i = t.changedTouches[0],
        n = document.createEvent("MouseEvents"),
        n.initMouseEvent(this.determineEventType(e), !0, !0, window, 1, i.screenX, i.screenY, i.clientX, i.clientY, !1, !1, !1, !1, 0, null),
        n.forwardedTouchEvent = !0,
        e.dispatchEvent(n)
    }
    ,
    e.prototype.determineEventType = function(e) {
        return n && "select" === e.tagName.toLowerCase() ? "mousedown" : "click"
    }
    ,
    e.prototype.focus = function(e) {
        var t;
        i && e.setSelectionRange && 0 !== e.type.indexOf("date") && "time" !== e.type && "month" !== e.type ? (t = e.value.length,
        e.setSelectionRange(t, t)) : e.focus()
    }
    ,
    e.prototype.updateScrollParent = function(e) {
        var t, n;
        if (t = e.fastClickScrollParent,
        !t || !t.contains(e)) {
            n = e;
            do {
                if (n.scrollHeight > n.offsetHeight) {
                    t = n,
                    e.fastClickScrollParent = n;
                    break
                }
                n = n.parentElement
            } while (n)
        }
        t && (t.fastClickLastScrollTop = t.scrollTop)
    }
    ,
    e.prototype.getTargetElementFromEventTarget = function(e) {
        return e.nodeType === Node.TEXT_NODE ? e.parentNode : e
    }
    ,
    e.prototype.onTouchStart = function(e) {
        var t, n, o;
        if (e.targetTouches.length > 1)
            return !0;
        if (t = this.getTargetElementFromEventTarget(e.target),
        n = e.targetTouches[0],
        i) {
            if (o = window.getSelection(),
            o.rangeCount && !o.isCollapsed)
                return !0;
            if (!r) {
                if (n.identifier && n.identifier === this.lastTouchIdentifier)
                    return e.preventDefault(),
                    !1;
                this.lastTouchIdentifier = n.identifier,
                this.updateScrollParent(t)
            }
        }
        return this.trackingClick = !0,
        this.trackingClickStart = e.timeStamp,
        this.targetElement = t,
        this.touchStartX = n.pageX,
        this.touchStartY = n.pageY,
        e.timeStamp - this.lastClickTime < this.tapDelay,
        !0
    }
    ,
    e.prototype.touchHasMoved = function(e) {
        var t = e.changedTouches[0]
          , n = this.touchBoundary;
        return Math.abs(t.pageX - this.touchStartX) > n || Math.abs(t.pageY - this.touchStartY) > n
    }
    ,
    e.prototype.onTouchMove = function(e) {
        return !this.trackingClick || ((this.targetElement !== this.getTargetElementFromEventTarget(e.target) || this.touchHasMoved(e)) && (this.trackingClick = !1,
        this.targetElement = null),
        !0)
    }
    ,
    e.prototype.findControl = function(e) {
        return void 0 !== e.control ? e.control : e.htmlFor ? document.getElementById(e.htmlFor) : e.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")
    }
    ,
    e.prototype.onTouchEnd = function(e) {
        var t, s, a, l, c, u = this.targetElement;
        if (!this.trackingClick)
            return !0;
        if (e.timeStamp - this.lastClickTime < this.tapDelay)
            return this.cancelNextClick = !0,
            !0;
        if (e.timeStamp - this.trackingClickStart > this.tapTimeout)
            return !0;
        if (this.cancelNextClick = !1,
        this.lastClickTime = e.timeStamp,
        s = this.trackingClickStart,
        this.trackingClick = !1,
        this.trackingClickStart = 0,
        o && (c = e.changedTouches[0],
        u = document.elementFromPoint(c.pageX - window.pageXOffset, c.pageY - window.pageYOffset) || u,
        u.fastClickScrollParent = this.targetElement.fastClickScrollParent),
        a = u.tagName.toLowerCase(),
        "label" === a) {
            if (t = this.findControl(u)) {
                if (this.focus(u),
                n)
                    return !1;
                u = t
            }
        } else if (this.needsFocus(u))
            return e.timeStamp - s > 100 || i && window.top !== window && "input" === a ? (this.targetElement = null,
            !1) : (this.focus(u),
            this.sendClick(u, e),
            i && "select" === a || (this.targetElement = null,
            e.preventDefault()),
            !1);
        return !(!i || r || (l = u.fastClickScrollParent,
        !l || l.fastClickLastScrollTop === l.scrollTop)) || (this.needsClick(u) || (e.preventDefault(),
        this.sendClick(u, e)),
        !1)
    }
    ,
    e.prototype.onTouchCancel = function() {
        this.trackingClick = !1,
        this.targetElement = null
    }
    ,
    e.prototype.onMouse = function(e) {
        return !this.targetElement || (!!e.forwardedTouchEvent || (!e.cancelable || (!(!this.needsClick(this.targetElement) || this.cancelNextClick) || (e.stopImmediatePropagation ? e.stopImmediatePropagation() : e.propagationStopped = !0,
        e.stopPropagation(),
        e.preventDefault(),
        !1))))
    }
    ,
    e.prototype.onClick = function(e) {
        var t;
        return this.trackingClick ? (this.targetElement = null,
        this.trackingClick = !1,
        !0) : "submit" === e.target.type && 0 === e.detail || (t = this.onMouse(e),
        t || (this.targetElement = null),
        t)
    }
    ,
    e.prototype.destroy = function() {
        var e = this.layer;
        n && (e.removeEventListener("mouseover", this.onMouse, !0),
        e.removeEventListener("mousedown", this.onMouse, !0),
        e.removeEventListener("mouseup", this.onMouse, !0)),
        e.removeEventListener("click", this.onClick, !0),
        e.removeEventListener("touchstart", this.onTouchStart, !1),
        e.removeEventListener("touchmove", this.onTouchMove, !1),
        e.removeEventListener("touchend", this.onTouchEnd, !1),
        e.removeEventListener("touchcancel", this.onTouchCancel, !1)
    }
    ,
    e.notNeeded = function(e) {
        var t, i, r;
        if ("undefined" == typeof window.ontouchstart)
            return !0;
        if (i = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]) {
            if (!n)
                return !0;
            if (t = document.querySelector("meta[name=viewport]")) {
                if (t.content.indexOf("user-scalable=no") !== -1)
                    return !0;
                if (i > 31 && document.documentElement.scrollWidth <= window.outerWidth)
                    return !0
            }
        }
        if (s && (r = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/),
        r[1] >= 10 && r[2] >= 3 && (t = document.querySelector("meta[name=viewport]")))) {
            if (t.content.indexOf("user-scalable=no") !== -1)
                return !0;
            if (document.documentElement.scrollWidth <= window.outerWidth)
                return !0
        }
        return "none" === e.style.msTouchAction || "none" === e.style.touchAction
    }
    ,
    e.attach = function(t, n) {
        return new e(t,n)
    }
    ,
    "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return e
    }) : "undefined" != typeof module && module.exports ? (module.exports = e.attach,
    module.exports.FastClick = e) : window.FastClick = e
}();
/*!
 * handlebars.min.js
 */
/*!
handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
var Handlebars = function() {
    var e = function() {
        "use strict";
        function e(e) {
            this.string = e
        }
        var t;
        return e.prototype.toString = function() {
            return "" + this.string
        }
        ,
        t = e
    }()
      , t = function(e) {
        "use strict";
        function t(e) {
            return a[e] || "&"
        }
        function n(e, t) {
            for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
        }
        function i(e) {
            return e instanceof s ? e.toString() : e || 0 === e ? (e = "" + e,
            c.test(e) ? e.replace(l, t) : e) : ""
        }
        function r(e) {
            return !e && 0 !== e || !(!h(e) || 0 !== e.length)
        }
        var o = {}
          , s = e
          , a = {
            "&": "&",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        }
          , l = /[&<>"'`]/g
          , c = /[&<>"'`]/;
        o.extend = n;
        var u = Object.prototype.toString;
        o.toString = u;
        var p = function(e) {
            return "function" == typeof e
        };
        p(/x/) && (p = function(e) {
            return "function" == typeof e && "[object Function]" === u.call(e)
        }
        );
        var p;
        o.isFunction = p;
        var h = Array.isArray || function(e) {
            return !(!e || "object" != typeof e) && "[object Array]" === u.call(e)
        }
        ;
        return o.isArray = h,
        o.escapeExpression = i,
        o.isEmpty = r,
        o
    }(e)
      , n = function() {
        "use strict";
        function e(e, t) {
            var i;
            t && t.firstLine && (i = t.firstLine,
            e += " - " + i + ":" + t.firstColumn);
            for (var r = Error.prototype.constructor.call(this, e), o = 0; o < n.length; o++)
                this[n[o]] = r[n[o]];
            i && (this.lineNumber = i,
            this.column = t.firstColumn)
        }
        var t, n = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
        return e.prototype = new Error,
        t = e
    }()
      , i = function(e, t) {
        "use strict";
        function n(e, t) {
            this.helpers = e || {},
            this.partials = t || {},
            i(this)
        }
        function i(e) {
            e.registerHelper("helperMissing", function(e) {
                if (2 !== arguments.length)
                    throw new a("Missing helper: '" + e + "'")
            }),
            e.registerHelper("blockHelperMissing", function(t, n) {
                var i = n.inverse || function() {}
                  , r = n.fn;
                return h(t) && (t = t.call(this)),
                t === !0 ? r(this) : t === !1 || null == t ? i(this) : p(t) ? t.length > 0 ? e.helpers.each(t, n) : i(this) : r(t)
            }),
            e.registerHelper("each", function(e, t) {
                var n, i = t.fn, r = t.inverse, o = 0, s = "";
                if (h(e) && (e = e.call(this)),
                t.data && (n = v(t.data)),
                e && "object" == typeof e)
                    if (p(e))
                        for (var a = e.length; o < a; o++)
                            n && (n.index = o,
                            n.first = 0 === o,
                            n.last = o === e.length - 1),
                            s += i(e[o], {
                                data: n
                            });
                    else
                        for (var l in e)
                            e.hasOwnProperty(l) && (n && (n.key = l,
                            n.index = o,
                            n.first = 0 === o),
                            s += i(e[l], {
                                data: n
                            }),
                            o++);
                return 0 === o && (s = r(this)),
                s
            }),
            e.registerHelper("if", function(e, t) {
                return h(e) && (e = e.call(this)),
                !t.hash.includeZero && !e || s.isEmpty(e) ? t.inverse(this) : t.fn(this)
            }),
            e.registerHelper("unless", function(t, n) {
                return e.helpers.if.call(this, t, {
                    fn: n.inverse,
                    inverse: n.fn,
                    hash: n.hash
                })
            }),
            e.registerHelper("with", function(e, t) {
                if (h(e) && (e = e.call(this)),
                !s.isEmpty(e))
                    return t.fn(e)
            }),
            e.registerHelper("log", function(t, n) {
                var i = n.data && null != n.data.level ? parseInt(n.data.level, 10) : 1;
                e.log(i, t)
            })
        }
        function r(e, t) {
            m.log(e, t)
        }
        var o = {}
          , s = e
          , a = t
          , l = "1.3.0";
        o.VERSION = l;
        var c = 4;
        o.COMPILER_REVISION = c;
        var u = {
            1: "<= 1.0.rc.2",
            2: "== 1.0.0-rc.3",
            3: "== 1.0.0-rc.4",
            4: ">= 1.0.0"
        };
        o.REVISION_CHANGES = u;
        var p = s.isArray
          , h = s.isFunction
          , f = s.toString
          , d = "[object Object]";
        o.HandlebarsEnvironment = n,
        n.prototype = {
            constructor: n,
            logger: m,
            log: r,
            registerHelper: function(e, t, n) {
                if (f.call(e) === d) {
                    if (n || t)
                        throw new a("Arg not supported with multiple helpers");
                    s.extend(this.helpers, e)
                } else
                    n && (t.not = n),
                    this.helpers[e] = t
            },
            registerPartial: function(e, t) {
                f.call(e) === d ? s.extend(this.partials, e) : this.partials[e] = t
            }
        };
        var m = {
            methodMap: {
                0: "debug",
                1: "info",
                2: "warn",
                3: "error"
            },
            DEBUG: 0,
            INFO: 1,
            WARN: 2,
            ERROR: 3,
            level: 3,
            log: function(e, t) {
                if (m.level <= e) {
                    var n = m.methodMap[e];
                    "undefined" != typeof console && console[n] && console[n].call(console, t)
                }
            }
        };
        o.logger = m,
        o.log = r;
        var v = function(e) {
            var t = {};
            return s.extend(t, e),
            t
        };
        return o.createFrame = v,
        o
    }(t, n)
      , r = function(e, t, n) {
        "use strict";
        function i(e) {
            var t = e && e[0] || 1
              , n = h;
            if (t !== n) {
                if (t < n) {
                    var i = f[n]
                      , r = f[t];
                    throw new p("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + i + ") or downgrade your runtime to an older version (" + r + ").")
                }
                throw new p("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").")
            }
        }
        function r(e, t) {
            if (!t)
                throw new p("No environment passed to template");
            var n = function(e, n, i, r, o, s) {
                var a = t.VM.invokePartial.apply(this, arguments);
                if (null != a)
                    return a;
                if (t.compile) {
                    var l = {
                        helpers: r,
                        partials: o,
                        data: s
                    };
                    return o[n] = t.compile(e, {
                        data: void 0 !== s
                    }, t),
                    o[n](i, l)
                }
                throw new p("The partial " + n + " could not be compiled when running in runtime-only mode")
            }
              , i = {
                escapeExpression: u.escapeExpression,
                invokePartial: n,
                programs: [],
                program: function(e, t, n) {
                    var i = this.programs[e];
                    return n ? i = s(e, t, n) : i || (i = this.programs[e] = s(e, t)),
                    i
                },
                merge: function(e, t) {
                    var n = e || t;
                    return e && t && e !== t && (n = {},
                    u.extend(n, t),
                    u.extend(n, e)),
                    n
                },
                programWithDepth: t.VM.programWithDepth,
                noop: t.VM.noop,
                compilerInfo: null
            };
            return function(n, r) {
                r = r || {};
                var o, s, a = r.partial ? r : t;
                r.partial || (o = r.helpers,
                s = r.partials);
                var l = e.call(i, a, n, o, s, r.data);
                return r.partial || t.VM.checkRevision(i.compilerInfo),
                l
            }
        }
        function o(e, t, n) {
            var i = Array.prototype.slice.call(arguments, 3)
              , r = function(e, r) {
                return r = r || {},
                t.apply(this, [e, r.data || n].concat(i))
            };
            return r.program = e,
            r.depth = i.length,
            r
        }
        function s(e, t, n) {
            var i = function(e, i) {
                return i = i || {},
                t(e, i.data || n)
            };
            return i.program = e,
            i.depth = 0,
            i
        }
        function a(e, t, n, i, r, o) {
            var s = {
                partial: !0,
                helpers: i,
                partials: r,
                data: o
            };
            if (void 0 === e)
                throw new p("The partial " + t + " could not be found");
            if (e instanceof Function)
                return e(n, s)
        }
        function l() {
            return ""
        }
        var c = {}
          , u = e
          , p = t
          , h = n.COMPILER_REVISION
          , f = n.REVISION_CHANGES;
        return c.checkRevision = i,
        c.template = r,
        c.programWithDepth = o,
        c.program = s,
        c.invokePartial = a,
        c.noop = l,
        c
    }(t, n, i)
      , o = function(e, t, n, i, r) {
        "use strict";
        var o, s = e, a = t, l = n, c = i, u = r, p = function() {
            var e = new s.HandlebarsEnvironment;
            return c.extend(e, s),
            e.SafeString = a,
            e.Exception = l,
            e.Utils = c,
            e.VM = u,
            e.template = function(t) {
                return u.template(t, e)
            }
            ,
            e
        }, h = p();
        return h.create = p,
        o = h
    }(i, e, n, t, r)
      , s = function(e) {
        "use strict";
        function t(e) {
            e = e || {},
            this.firstLine = e.first_line,
            this.firstColumn = e.first_column,
            this.lastColumn = e.last_column,
            this.lastLine = e.last_line
        }
        var n, i = e, r = {
            ProgramNode: function(e, n, i, o) {
                var s, a;
                3 === arguments.length ? (o = i,
                i = null) : 2 === arguments.length && (o = n,
                n = null),
                t.call(this, o),
                this.type = "program",
                this.statements = e,
                this.strip = {},
                i ? (a = i[0],
                a ? (s = {
                    first_line: a.firstLine,
                    last_line: a.lastLine,
                    last_column: a.lastColumn,
                    first_column: a.firstColumn
                },
                this.inverse = new r.ProgramNode(i,n,s)) : this.inverse = new r.ProgramNode(i,n),
                this.strip.right = n.left) : n && (this.strip.left = n.right)
            },
            MustacheNode: function(e, n, i, o, s) {
                if (t.call(this, s),
                this.type = "mustache",
                this.strip = o,
                null != i && i.charAt) {
                    var a = i.charAt(3) || i.charAt(2);
                    this.escaped = "{" !== a && "&" !== a
                } else
                    this.escaped = !!i;
                e instanceof r.SexprNode ? this.sexpr = e : this.sexpr = new r.SexprNode(e,n),
                this.sexpr.isRoot = !0,
                this.id = this.sexpr.id,
                this.params = this.sexpr.params,
                this.hash = this.sexpr.hash,
                this.eligibleHelper = this.sexpr.eligibleHelper,
                this.isHelper = this.sexpr.isHelper
            },
            SexprNode: function(e, n, i) {
                t.call(this, i),
                this.type = "sexpr",
                this.hash = n;
                var r = this.id = e[0]
                  , o = this.params = e.slice(1)
                  , s = this.eligibleHelper = r.isSimple;
                this.isHelper = s && (o.length || n)
            },
            PartialNode: function(e, n, i, r) {
                t.call(this, r),
                this.type = "partial",
                this.partialName = e,
                this.context = n,
                this.strip = i
            },
            BlockNode: function(e, n, r, o, s) {
                if (t.call(this, s),
                e.sexpr.id.original !== o.path.original)
                    throw new i(e.sexpr.id.original + " doesn't match " + o.path.original,this);
                this.type = "block",
                this.mustache = e,
                this.program = n,
                this.inverse = r,
                this.strip = {
                    left: e.strip.left,
                    right: o.strip.right
                },
                (n || r).strip.left = e.strip.right,
                (r || n).strip.right = o.strip.left,
                r && !n && (this.isInverse = !0)
            },
            ContentNode: function(e, n) {
                t.call(this, n),
                this.type = "content",
                this.string = e
            },
            HashNode: function(e, n) {
                t.call(this, n),
                this.type = "hash",
                this.pairs = e
            },
            IdNode: function(e, n) {
                t.call(this, n),
                this.type = "ID";
                for (var r = "", o = [], s = 0, a = 0, l = e.length; a < l; a++) {
                    var c = e[a].part;
                    if (r += (e[a].separator || "") + c,
                    ".." === c || "." === c || "this" === c) {
                        if (o.length > 0)
                            throw new i("Invalid path: " + r,this);
                        ".." === c ? s++ : this.isScoped = !0
                    } else
                        o.push(c)
                }
                this.original = r,
                this.parts = o,
                this.string = o.join("."),
                this.depth = s,
                this.isSimple = 1 === e.length && !this.isScoped && 0 === s,
                this.stringModeValue = this.string
            },
            PartialNameNode: function(e, n) {
                t.call(this, n),
                this.type = "PARTIAL_NAME",
                this.name = e.original
            },
            DataNode: function(e, n) {
                t.call(this, n),
                this.type = "DATA",
                this.id = e
            },
            StringNode: function(e, n) {
                t.call(this, n),
                this.type = "STRING",
                this.original = this.string = this.stringModeValue = e
            },
            IntegerNode: function(e, n) {
                t.call(this, n),
                this.type = "INTEGER",
                this.original = this.integer = e,
                this.stringModeValue = Number(e)
            },
            BooleanNode: function(e, n) {
                t.call(this, n),
                this.type = "BOOLEAN",
                this.bool = e,
                this.stringModeValue = "true" === e
            },
            CommentNode: function(e, n) {
                t.call(this, n),
                this.type = "comment",
                this.comment = e
            }
        };
        return n = r
    }(n)
      , a = function() {
        "use strict";
        var e, t = function() {
            function e(e, t) {
                return {
                    left: "~" === e.charAt(2),
                    right: "~" === t.charAt(0) || "~" === t.charAt(1)
                }
            }
            function t() {
                this.yy = {}
            }
            var n = {
                trace: function() {},
                yy: {},
                symbols_: {
                    error: 2,
                    root: 3,
                    statements: 4,
                    EOF: 5,
                    program: 6,
                    simpleInverse: 7,
                    statement: 8,
                    openInverse: 9,
                    closeBlock: 10,
                    openBlock: 11,
                    mustache: 12,
                    partial: 13,
                    CONTENT: 14,
                    COMMENT: 15,
                    OPEN_BLOCK: 16,
                    sexpr: 17,
                    CLOSE: 18,
                    OPEN_INVERSE: 19,
                    OPEN_ENDBLOCK: 20,
                    path: 21,
                    OPEN: 22,
                    OPEN_UNESCAPED: 23,
                    CLOSE_UNESCAPED: 24,
                    OPEN_PARTIAL: 25,
                    partialName: 26,
                    partial_option0: 27,
                    sexpr_repetition0: 28,
                    sexpr_option0: 29,
                    dataName: 30,
                    param: 31,
                    STRING: 32,
                    INTEGER: 33,
                    BOOLEAN: 34,
                    OPEN_SEXPR: 35,
                    CLOSE_SEXPR: 36,
                    hash: 37,
                    hash_repetition_plus0: 38,
                    hashSegment: 39,
                    ID: 40,
                    EQUALS: 41,
                    DATA: 42,
                    pathSegments: 43,
                    SEP: 44,
                    $accept: 0,
                    $end: 1
                },
                terminals_: {
                    2: "error",
                    5: "EOF",
                    14: "CONTENT",
                    15: "COMMENT",
                    16: "OPEN_BLOCK",
                    18: "CLOSE",
                    19: "OPEN_INVERSE",
                    20: "OPEN_ENDBLOCK",
                    22: "OPEN",
                    23: "OPEN_UNESCAPED",
                    24: "CLOSE_UNESCAPED",
                    25: "OPEN_PARTIAL",
                    32: "STRING",
                    33: "INTEGER",
                    34: "BOOLEAN",
                    35: "OPEN_SEXPR",
                    36: "CLOSE_SEXPR",
                    40: "ID",
                    41: "EQUALS",
                    42: "DATA",
                    44: "SEP"
                },
                productions_: [0, [3, 2], [3, 1], [6, 2], [6, 3], [6, 2], [6, 1], [6, 1], [6, 0], [4, 1], [4, 2], [8, 3], [8, 3], [8, 1], [8, 1], [8, 1], [8, 1], [11, 3], [9, 3], [10, 3], [12, 3], [12, 3], [13, 4], [7, 2], [17, 3], [17, 1], [31, 1], [31, 1], [31, 1], [31, 1], [31, 1], [31, 3], [37, 1], [39, 3], [26, 1], [26, 1], [26, 1], [30, 2], [21, 1], [43, 3], [43, 1], [27, 0], [27, 1], [28, 0], [28, 2], [29, 0], [29, 1], [38, 1], [38, 2]],
                performAction: function(t, n, i, r, o, s, a) {
                    var l = s.length - 1;
                    switch (o) {
                    case 1:
                        return new r.ProgramNode(s[l - 1],this._$);
                    case 2:
                        return new r.ProgramNode([],this._$);
                    case 3:
                        this.$ = new r.ProgramNode([],s[l - 1],s[l],this._$);
                        break;
                    case 4:
                        this.$ = new r.ProgramNode(s[l - 2],s[l - 1],s[l],this._$);
                        break;
                    case 5:
                        this.$ = new r.ProgramNode(s[l - 1],s[l],[],this._$);
                        break;
                    case 6:
                        this.$ = new r.ProgramNode(s[l],this._$);
                        break;
                    case 7:
                        this.$ = new r.ProgramNode([],this._$);
                        break;
                    case 8:
                        this.$ = new r.ProgramNode([],this._$);
                        break;
                    case 9:
                        this.$ = [s[l]];
                        break;
                    case 10:
                        s[l - 1].push(s[l]),
                        this.$ = s[l - 1];
                        break;
                    case 11:
                        this.$ = new r.BlockNode(s[l - 2],s[l - 1].inverse,s[l - 1],s[l],this._$);
                        break;
                    case 12:
                        this.$ = new r.BlockNode(s[l - 2],s[l - 1],s[l - 1].inverse,s[l],this._$);
                        break;
                    case 13:
                        this.$ = s[l];
                        break;
                    case 14:
                        this.$ = s[l];
                        break;
                    case 15:
                        this.$ = new r.ContentNode(s[l],this._$);
                        break;
                    case 16:
                        this.$ = new r.CommentNode(s[l],this._$);
                        break;
                    case 17:
                        this.$ = new r.MustacheNode(s[l - 1],null,s[l - 2],e(s[l - 2], s[l]),this._$);
                        break;
                    case 18:
                        this.$ = new r.MustacheNode(s[l - 1],null,s[l - 2],e(s[l - 2], s[l]),this._$);
                        break;
                    case 19:
                        this.$ = {
                            path: s[l - 1],
                            strip: e(s[l - 2], s[l])
                        };
                        break;
                    case 20:
                        this.$ = new r.MustacheNode(s[l - 1],null,s[l - 2],e(s[l - 2], s[l]),this._$);
                        break;
                    case 21:
                        this.$ = new r.MustacheNode(s[l - 1],null,s[l - 2],e(s[l - 2], s[l]),this._$);
                        break;
                    case 22:
                        this.$ = new r.PartialNode(s[l - 2],s[l - 1],e(s[l - 3], s[l]),this._$);
                        break;
                    case 23:
                        this.$ = e(s[l - 1], s[l]);
                        break;
                    case 24:
                        this.$ = new r.SexprNode([s[l - 2]].concat(s[l - 1]),s[l],this._$);
                        break;
                    case 25:
                        this.$ = new r.SexprNode([s[l]],null,this._$);
                        break;
                    case 26:
                        this.$ = s[l];
                        break;
                    case 27:
                        this.$ = new r.StringNode(s[l],this._$);
                        break;
                    case 28:
                        this.$ = new r.IntegerNode(s[l],this._$);
                        break;
                    case 29:
                        this.$ = new r.BooleanNode(s[l],this._$);
                        break;
                    case 30:
                        this.$ = s[l];
                        break;
                    case 31:
                        s[l - 1].isHelper = !0,
                        this.$ = s[l - 1];
                        break;
                    case 32:
                        this.$ = new r.HashNode(s[l],this._$);
                        break;
                    case 33:
                        this.$ = [s[l - 2], s[l]];
                        break;
                    case 34:
                        this.$ = new r.PartialNameNode(s[l],this._$);
                        break;
                    case 35:
                        this.$ = new r.PartialNameNode(new r.StringNode(s[l],this._$),this._$);
                        break;
                    case 36:
                        this.$ = new r.PartialNameNode(new r.IntegerNode(s[l],this._$));
                        break;
                    case 37:
                        this.$ = new r.DataNode(s[l],this._$);
                        break;
                    case 38:
                        this.$ = new r.IdNode(s[l],this._$);
                        break;
                    case 39:
                        s[l - 2].push({
                            part: s[l],
                            separator: s[l - 1]
                        }),
                        this.$ = s[l - 2];
                        break;
                    case 40:
                        this.$ = [{
                            part: s[l]
                        }];
                        break;
                    case 43:
                        this.$ = [];
                        break;
                    case 44:
                        s[l - 1].push(s[l]);
                        break;
                    case 47:
                        this.$ = [s[l]];
                        break;
                    case 48:
                        s[l - 1].push(s[l])
                    }
                },
                table: [{
                    3: 1,
                    4: 2,
                    5: [1, 3],
                    8: 4,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    1: [3]
                }, {
                    5: [1, 16],
                    8: 17,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    1: [2, 2]
                }, {
                    5: [2, 9],
                    14: [2, 9],
                    15: [2, 9],
                    16: [2, 9],
                    19: [2, 9],
                    20: [2, 9],
                    22: [2, 9],
                    23: [2, 9],
                    25: [2, 9]
                }, {
                    4: 20,
                    6: 18,
                    7: 19,
                    8: 4,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 21],
                    20: [2, 8],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    4: 20,
                    6: 22,
                    7: 19,
                    8: 4,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 21],
                    20: [2, 8],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    5: [2, 13],
                    14: [2, 13],
                    15: [2, 13],
                    16: [2, 13],
                    19: [2, 13],
                    20: [2, 13],
                    22: [2, 13],
                    23: [2, 13],
                    25: [2, 13]
                }, {
                    5: [2, 14],
                    14: [2, 14],
                    15: [2, 14],
                    16: [2, 14],
                    19: [2, 14],
                    20: [2, 14],
                    22: [2, 14],
                    23: [2, 14],
                    25: [2, 14]
                }, {
                    5: [2, 15],
                    14: [2, 15],
                    15: [2, 15],
                    16: [2, 15],
                    19: [2, 15],
                    20: [2, 15],
                    22: [2, 15],
                    23: [2, 15],
                    25: [2, 15]
                }, {
                    5: [2, 16],
                    14: [2, 16],
                    15: [2, 16],
                    16: [2, 16],
                    19: [2, 16],
                    20: [2, 16],
                    22: [2, 16],
                    23: [2, 16],
                    25: [2, 16]
                }, {
                    17: 23,
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    17: 29,
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    17: 30,
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    17: 31,
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    21: 33,
                    26: 32,
                    32: [1, 34],
                    33: [1, 35],
                    40: [1, 28],
                    43: 26
                }, {
                    1: [2, 1]
                }, {
                    5: [2, 10],
                    14: [2, 10],
                    15: [2, 10],
                    16: [2, 10],
                    19: [2, 10],
                    20: [2, 10],
                    22: [2, 10],
                    23: [2, 10],
                    25: [2, 10]
                }, {
                    10: 36,
                    20: [1, 37]
                }, {
                    4: 38,
                    8: 4,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    20: [2, 7],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    7: 39,
                    8: 17,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 21],
                    20: [2, 6],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    17: 23,
                    18: [1, 40],
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    10: 41,
                    20: [1, 37]
                }, {
                    18: [1, 42]
                }, {
                    18: [2, 43],
                    24: [2, 43],
                    28: 43,
                    32: [2, 43],
                    33: [2, 43],
                    34: [2, 43],
                    35: [2, 43],
                    36: [2, 43],
                    40: [2, 43],
                    42: [2, 43]
                }, {
                    18: [2, 25],
                    24: [2, 25],
                    36: [2, 25]
                }, {
                    18: [2, 38],
                    24: [2, 38],
                    32: [2, 38],
                    33: [2, 38],
                    34: [2, 38],
                    35: [2, 38],
                    36: [2, 38],
                    40: [2, 38],
                    42: [2, 38],
                    44: [1, 44]
                }, {
                    21: 45,
                    40: [1, 28],
                    43: 26
                }, {
                    18: [2, 40],
                    24: [2, 40],
                    32: [2, 40],
                    33: [2, 40],
                    34: [2, 40],
                    35: [2, 40],
                    36: [2, 40],
                    40: [2, 40],
                    42: [2, 40],
                    44: [2, 40]
                }, {
                    18: [1, 46]
                }, {
                    18: [1, 47]
                }, {
                    24: [1, 48]
                }, {
                    18: [2, 41],
                    21: 50,
                    27: 49,
                    40: [1, 28],
                    43: 26
                }, {
                    18: [2, 34],
                    40: [2, 34]
                }, {
                    18: [2, 35],
                    40: [2, 35]
                }, {
                    18: [2, 36],
                    40: [2, 36]
                }, {
                    5: [2, 11],
                    14: [2, 11],
                    15: [2, 11],
                    16: [2, 11],
                    19: [2, 11],
                    20: [2, 11],
                    22: [2, 11],
                    23: [2, 11],
                    25: [2, 11]
                }, {
                    21: 51,
                    40: [1, 28],
                    43: 26
                }, {
                    8: 17,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    20: [2, 3],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    4: 52,
                    8: 4,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    20: [2, 5],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    14: [2, 23],
                    15: [2, 23],
                    16: [2, 23],
                    19: [2, 23],
                    20: [2, 23],
                    22: [2, 23],
                    23: [2, 23],
                    25: [2, 23]
                }, {
                    5: [2, 12],
                    14: [2, 12],
                    15: [2, 12],
                    16: [2, 12],
                    19: [2, 12],
                    20: [2, 12],
                    22: [2, 12],
                    23: [2, 12],
                    25: [2, 12]
                }, {
                    14: [2, 18],
                    15: [2, 18],
                    16: [2, 18],
                    19: [2, 18],
                    20: [2, 18],
                    22: [2, 18],
                    23: [2, 18],
                    25: [2, 18]
                }, {
                    18: [2, 45],
                    21: 56,
                    24: [2, 45],
                    29: 53,
                    30: 60,
                    31: 54,
                    32: [1, 57],
                    33: [1, 58],
                    34: [1, 59],
                    35: [1, 61],
                    36: [2, 45],
                    37: 55,
                    38: 62,
                    39: 63,
                    40: [1, 64],
                    42: [1, 27],
                    43: 26
                }, {
                    40: [1, 65]
                }, {
                    18: [2, 37],
                    24: [2, 37],
                    32: [2, 37],
                    33: [2, 37],
                    34: [2, 37],
                    35: [2, 37],
                    36: [2, 37],
                    40: [2, 37],
                    42: [2, 37]
                }, {
                    14: [2, 17],
                    15: [2, 17],
                    16: [2, 17],
                    19: [2, 17],
                    20: [2, 17],
                    22: [2, 17],
                    23: [2, 17],
                    25: [2, 17]
                }, {
                    5: [2, 20],
                    14: [2, 20],
                    15: [2, 20],
                    16: [2, 20],
                    19: [2, 20],
                    20: [2, 20],
                    22: [2, 20],
                    23: [2, 20],
                    25: [2, 20]
                }, {
                    5: [2, 21],
                    14: [2, 21],
                    15: [2, 21],
                    16: [2, 21],
                    19: [2, 21],
                    20: [2, 21],
                    22: [2, 21],
                    23: [2, 21],
                    25: [2, 21]
                }, {
                    18: [1, 66]
                }, {
                    18: [2, 42]
                }, {
                    18: [1, 67]
                }, {
                    8: 17,
                    9: 5,
                    11: 6,
                    12: 7,
                    13: 8,
                    14: [1, 9],
                    15: [1, 10],
                    16: [1, 12],
                    19: [1, 11],
                    20: [2, 4],
                    22: [1, 13],
                    23: [1, 14],
                    25: [1, 15]
                }, {
                    18: [2, 24],
                    24: [2, 24],
                    36: [2, 24]
                }, {
                    18: [2, 44],
                    24: [2, 44],
                    32: [2, 44],
                    33: [2, 44],
                    34: [2, 44],
                    35: [2, 44],
                    36: [2, 44],
                    40: [2, 44],
                    42: [2, 44]
                }, {
                    18: [2, 46],
                    24: [2, 46],
                    36: [2, 46]
                }, {
                    18: [2, 26],
                    24: [2, 26],
                    32: [2, 26],
                    33: [2, 26],
                    34: [2, 26],
                    35: [2, 26],
                    36: [2, 26],
                    40: [2, 26],
                    42: [2, 26]
                }, {
                    18: [2, 27],
                    24: [2, 27],
                    32: [2, 27],
                    33: [2, 27],
                    34: [2, 27],
                    35: [2, 27],
                    36: [2, 27],
                    40: [2, 27],
                    42: [2, 27]
                }, {
                    18: [2, 28],
                    24: [2, 28],
                    32: [2, 28],
                    33: [2, 28],
                    34: [2, 28],
                    35: [2, 28],
                    36: [2, 28],
                    40: [2, 28],
                    42: [2, 28]
                }, {
                    18: [2, 29],
                    24: [2, 29],
                    32: [2, 29],
                    33: [2, 29],
                    34: [2, 29],
                    35: [2, 29],
                    36: [2, 29],
                    40: [2, 29],
                    42: [2, 29]
                }, {
                    18: [2, 30],
                    24: [2, 30],
                    32: [2, 30],
                    33: [2, 30],
                    34: [2, 30],
                    35: [2, 30],
                    36: [2, 30],
                    40: [2, 30],
                    42: [2, 30]
                }, {
                    17: 68,
                    21: 24,
                    30: 25,
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    18: [2, 32],
                    24: [2, 32],
                    36: [2, 32],
                    39: 69,
                    40: [1, 70]
                }, {
                    18: [2, 47],
                    24: [2, 47],
                    36: [2, 47],
                    40: [2, 47]
                }, {
                    18: [2, 40],
                    24: [2, 40],
                    32: [2, 40],
                    33: [2, 40],
                    34: [2, 40],
                    35: [2, 40],
                    36: [2, 40],
                    40: [2, 40],
                    41: [1, 71],
                    42: [2, 40],
                    44: [2, 40]
                }, {
                    18: [2, 39],
                    24: [2, 39],
                    32: [2, 39],
                    33: [2, 39],
                    34: [2, 39],
                    35: [2, 39],
                    36: [2, 39],
                    40: [2, 39],
                    42: [2, 39],
                    44: [2, 39]
                }, {
                    5: [2, 22],
                    14: [2, 22],
                    15: [2, 22],
                    16: [2, 22],
                    19: [2, 22],
                    20: [2, 22],
                    22: [2, 22],
                    23: [2, 22],
                    25: [2, 22]
                }, {
                    5: [2, 19],
                    14: [2, 19],
                    15: [2, 19],
                    16: [2, 19],
                    19: [2, 19],
                    20: [2, 19],
                    22: [2, 19],
                    23: [2, 19],
                    25: [2, 19]
                }, {
                    36: [1, 72]
                }, {
                    18: [2, 48],
                    24: [2, 48],
                    36: [2, 48],
                    40: [2, 48]
                }, {
                    41: [1, 71]
                }, {
                    21: 56,
                    30: 60,
                    31: 73,
                    32: [1, 57],
                    33: [1, 58],
                    34: [1, 59],
                    35: [1, 61],
                    40: [1, 28],
                    42: [1, 27],
                    43: 26
                }, {
                    18: [2, 31],
                    24: [2, 31],
                    32: [2, 31],
                    33: [2, 31],
                    34: [2, 31],
                    35: [2, 31],
                    36: [2, 31],
                    40: [2, 31],
                    42: [2, 31]
                }, {
                    18: [2, 33],
                    24: [2, 33],
                    36: [2, 33],
                    40: [2, 33]
                }],
                defaultActions: {
                    3: [2, 2],
                    16: [2, 1],
                    50: [2, 42]
                },
                parseError: function(e, t) {
                    throw new Error(e)
                },
                parse: function(e) {
                    function t() {
                        var e;
                        return e = n.lexer.lex() || 1,
                        "number" != typeof e && (e = n.symbols_[e] || e),
                        e
                    }
                    var n = this
                      , i = [0]
                      , r = [null]
                      , o = []
                      , s = this.table
                      , a = ""
                      , l = 0
                      , c = 0
                      , u = 0;
                    this.lexer.setInput(e),
                    this.lexer.yy = this.yy,
                    this.yy.lexer = this.lexer,
                    this.yy.parser = this,
                    "undefined" == typeof this.lexer.yylloc && (this.lexer.yylloc = {});
                    var p = this.lexer.yylloc;
                    o.push(p);
                    var h = this.lexer.options && this.lexer.options.ranges;
                    "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                    for (var f, d, m, v, g, y, x, b, w, S = {}; ; ) {
                        if (m = i[i.length - 1],
                        this.defaultActions[m] ? v = this.defaultActions[m] : (null !== f && "undefined" != typeof f || (f = t()),
                        v = s[m] && s[m][f]),
                        "undefined" == typeof v || !v.length || !v[0]) {
                            var C = "";
                            if (!u) {
                                w = [];
                                for (y in s[m])
                                    this.terminals_[y] && y > 2 && w.push("'" + this.terminals_[y] + "'");
                                C = this.lexer.showPosition ? "Parse error on line " + (l + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + w.join(", ") + ", got '" + (this.terminals_[f] || f) + "'" : "Parse error on line " + (l + 1) + ": Unexpected " + (1 == f ? "end of input" : "'" + (this.terminals_[f] || f) + "'"),
                                this.parseError(C, {
                                    text: this.lexer.match,
                                    token: this.terminals_[f] || f,
                                    line: this.lexer.yylineno,
                                    loc: p,
                                    expected: w
                                })
                            }
                        }
                        if (v[0]instanceof Array && v.length > 1)
                            throw new Error("Parse Error: multiple actions possible at state: " + m + ", token: " + f);
                        switch (v[0]) {
                        case 1:
                            i.push(f),
                            r.push(this.lexer.yytext),
                            o.push(this.lexer.yylloc),
                            i.push(v[1]),
                            f = null,
                            d ? (f = d,
                            d = null) : (c = this.lexer.yyleng,
                            a = this.lexer.yytext,
                            l = this.lexer.yylineno,
                            p = this.lexer.yylloc,
                            u > 0 && u--);
                            break;
                        case 2:
                            if (x = this.productions_[v[1]][1],
                            S.$ = r[r.length - x],
                            S._$ = {
                                first_line: o[o.length - (x || 1)].first_line,
                                last_line: o[o.length - 1].last_line,
                                first_column: o[o.length - (x || 1)].first_column,
                                last_column: o[o.length - 1].last_column
                            },
                            h && (S._$.range = [o[o.length - (x || 1)].range[0], o[o.length - 1].range[1]]),
                            g = this.performAction.call(S, a, c, l, this.yy, v[1], r, o),
                            "undefined" != typeof g)
                                return g;
                            x && (i = i.slice(0, -1 * x * 2),
                            r = r.slice(0, -1 * x),
                            o = o.slice(0, -1 * x)),
                            i.push(this.productions_[v[1]][0]),
                            r.push(S.$),
                            o.push(S._$),
                            b = s[i[i.length - 2]][i[i.length - 1]],
                            i.push(b);
                            break;
                        case 3:
                            return !0
                        }
                    }
                    return !0
                }
            }
              , i = function() {
                var e = {
                    EOF: 1,
                    parseError: function(e, t) {
                        if (!this.yy.parser)
                            throw new Error(e);
                        this.yy.parser.parseError(e, t)
                    },
                    setInput: function(e) {
                        return this._input = e,
                        this._more = this._less = this.done = !1,
                        this.yylineno = this.yyleng = 0,
                        this.yytext = this.matched = this.match = "",
                        this.conditionStack = ["INITIAL"],
                        this.yylloc = {
                            first_line: 1,
                            first_column: 0,
                            last_line: 1,
                            last_column: 0
                        },
                        this.options.ranges && (this.yylloc.range = [0, 0]),
                        this.offset = 0,
                        this
                    },
                    input: function() {
                        var e = this._input[0];
                        this.yytext += e,
                        this.yyleng++,
                        this.offset++,
                        this.match += e,
                        this.matched += e;
                        var t = e.match(/(?:\r\n?|\n).*/g);
                        return t ? (this.yylineno++,
                        this.yylloc.last_line++) : this.yylloc.last_column++,
                        this.options.ranges && this.yylloc.range[1]++,
                        this._input = this._input.slice(1),
                        e
                    },
                    unput: function(e) {
                        var t = e.length
                          , n = e.split(/(?:\r\n?|\n)/g);
                        this._input = e + this._input,
                        this.yytext = this.yytext.substr(0, this.yytext.length - t - 1),
                        this.offset -= t;
                        var i = this.match.split(/(?:\r\n?|\n)/g);
                        this.match = this.match.substr(0, this.match.length - 1),
                        this.matched = this.matched.substr(0, this.matched.length - 1),
                        n.length - 1 && (this.yylineno -= n.length - 1);
                        var r = this.yylloc.range;
                        return this.yylloc = {
                            first_line: this.yylloc.first_line,
                            last_line: this.yylineno + 1,
                            first_column: this.yylloc.first_column,
                            last_column: n ? (n.length === i.length ? this.yylloc.first_column : 0) + i[i.length - n.length].length - n[0].length : this.yylloc.first_column - t
                        },
                        this.options.ranges && (this.yylloc.range = [r[0], r[0] + this.yyleng - t]),
                        this
                    },
                    more: function() {
                        return this._more = !0,
                        this
                    },
                    less: function(e) {
                        this.unput(this.match.slice(e))
                    },
                    pastInput: function() {
                        var e = this.matched.substr(0, this.matched.length - this.match.length);
                        return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "")
                    },
                    upcomingInput: function() {
                        var e = this.match;
                        return e.length < 20 && (e += this._input.substr(0, 20 - e.length)),
                        (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "")
                    },
                    showPosition: function() {
                        var e = this.pastInput()
                          , t = new Array(e.length + 1).join("-");
                        return e + this.upcomingInput() + "\n" + t + "^"
                    },
                    next: function() {
                        if (this.done)
                            return this.EOF;
                        this._input || (this.done = !0);
                        var e, t, n, i, r;
                        this._more || (this.yytext = "",
                        this.match = "");
                        for (var o = this._currentRules(), s = 0; s < o.length && (n = this._input.match(this.rules[o[s]]),
                        !n || t && !(n[0].length > t[0].length) || (t = n,
                        i = s,
                        this.options.flex)); s++)
                            ;
                        return t ? (r = t[0].match(/(?:\r\n?|\n).*/g),
                        r && (this.yylineno += r.length),
                        this.yylloc = {
                            first_line: this.yylloc.last_line,
                            last_line: this.yylineno + 1,
                            first_column: this.yylloc.last_column,
                            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
                        },
                        this.yytext += t[0],
                        this.match += t[0],
                        this.matches = t,
                        this.yyleng = this.yytext.length,
                        this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]),
                        this._more = !1,
                        this._input = this._input.slice(t[0].length),
                        this.matched += t[0],
                        e = this.performAction.call(this, this.yy, this, o[i], this.conditionStack[this.conditionStack.length - 1]),
                        this.done && this._input && (this.done = !1),
                        e ? e : void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                            text: "",
                            token: null,
                            line: this.yylineno
                        })
                    },
                    lex: function() {
                        var e = this.next();
                        return "undefined" != typeof e ? e : this.lex()
                    },
                    begin: function(e) {
                        this.conditionStack.push(e)
                    },
                    popState: function() {
                        return this.conditionStack.pop()
                    },
                    _currentRules: function() {
                        return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules
                    },
                    topState: function() {
                        return this.conditionStack[this.conditionStack.length - 2]
                    },
                    pushState: function(e) {
                        this.begin(e)
                    }
                };
                return e.options = {},
                e.performAction = function(e, t, n, i) {
                    function r(e, n) {
                        return t.yytext = t.yytext.substr(e, t.yyleng - n)
                    }
                    switch (n) {
                    case 0:
                        if ("\\\\" === t.yytext.slice(-2) ? (r(0, 1),
                        this.begin("mu")) : "\\" === t.yytext.slice(-1) ? (r(0, 1),
                        this.begin("emu")) : this.begin("mu"),
                        t.yytext)
                            return 14;
                        break;
                    case 1:
                        return 14;
                    case 2:
                        return this.popState(),
                        14;
                    case 3:
                        return r(0, 4),
                        this.popState(),
                        15;
                    case 4:
                        return 35;
                    case 5:
                        return 36;
                    case 6:
                        return 25;
                    case 7:
                        return 16;
                    case 8:
                        return 20;
                    case 9:
                        return 19;
                    case 10:
                        return 19;
                    case 11:
                        return 23;
                    case 12:
                        return 22;
                    case 13:
                        this.popState(),
                        this.begin("com");
                        break;
                    case 14:
                        return r(3, 5),
                        this.popState(),
                        15;
                    case 15:
                        return 22;
                    case 16:
                        return 41;
                    case 17:
                        return 40;
                    case 18:
                        return 40;
                    case 19:
                        return 44;
                    case 20:
                        break;
                    case 21:
                        return this.popState(),
                        24;
                    case 22:
                        return this.popState(),
                        18;
                    case 23:
                        return t.yytext = r(1, 2).replace(/\\"/g, '"'),
                        32;
                    case 24:
                        return t.yytext = r(1, 2).replace(/\\'/g, "'"),
                        32;
                    case 25:
                        return 42;
                    case 26:
                        return 34;
                    case 27:
                        return 34;
                    case 28:
                        return 33;
                    case 29:
                        return 40;
                    case 30:
                        return t.yytext = r(1, 2),
                        40;
                    case 31:
                        return "INVALID";
                    case 32:
                        return 5
                    }
                }
                ,
                e.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:[\s\S]*?--\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{!--)/, /^(?:\{\{![\s\S]*?\}\})/, /^(?:\{\{(~)?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:-?[0-9]+(?=([~}\s)])))/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/, /^(?:\[[^\]]*\])/, /^(?:.)/, /^(?:$)/],
                e.conditions = {
                    mu: {
                        rules: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
                        inclusive: !1
                    },
                    emu: {
                        rules: [2],
                        inclusive: !1
                    },
                    com: {
                        rules: [3],
                        inclusive: !1
                    },
                    INITIAL: {
                        rules: [0, 1, 32],
                        inclusive: !0
                    }
                },
                e
            }();
            return n.lexer = i,
            t.prototype = n,
            n.Parser = t,
            new t
        }();
        return e = t
    }()
      , l = function(e, t) {
        "use strict";
        function n(e) {
            return e.constructor === o.ProgramNode ? e : (r.yy = o,
            r.parse(e))
        }
        var i = {}
          , r = e
          , o = t;
        return i.parser = r,
        i.parse = n,
        i
    }(a, s)
      , c = function(e) {
        "use strict";
        function t() {}
        function n(e, t, n) {
            if (null == e || "string" != typeof e && e.constructor !== n.AST.ProgramNode)
                throw new o("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + e);
            t = t || {},
            "data"in t || (t.data = !0);
            var i = n.parse(e)
              , r = (new n.Compiler).compile(i, t);
            return (new n.JavaScriptCompiler).compile(r, t)
        }
        function i(e, t, n) {
            function i() {
                var i = n.parse(e)
                  , r = (new n.Compiler).compile(i, t)
                  , o = (new n.JavaScriptCompiler).compile(r, t, void 0, !0);
                return n.template(o)
            }
            if (null == e || "string" != typeof e && e.constructor !== n.AST.ProgramNode)
                throw new o("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e);
            t = t || {},
            "data"in t || (t.data = !0);
            var r;
            return function(e, t) {
                return r || (r = i()),
                r.call(this, e, t)
            }
        }
        var r = {}
          , o = e;
        return r.Compiler = t,
        t.prototype = {
            compiler: t,
            disassemble: function() {
                for (var e, t, n, i = this.opcodes, r = [], o = 0, s = i.length; o < s; o++)
                    if (e = i[o],
                    "DECLARE" === e.opcode)
                        r.push("DECLARE " + e.name + "=" + e.value);
                    else {
                        t = [];
                        for (var a = 0; a < e.args.length; a++)
                            n = e.args[a],
                            "string" == typeof n && (n = '"' + n.replace("\n", "\\n") + '"'),
                            t.push(n);
                        r.push(e.opcode + " " + t.join(" "))
                    }
                return r.join("\n")
            },
            equals: function(e) {
                var t = this.opcodes.length;
                if (e.opcodes.length !== t)
                    return !1;
                for (var n = 0; n < t; n++) {
                    var i = this.opcodes[n]
                      , r = e.opcodes[n];
                    if (i.opcode !== r.opcode || i.args.length !== r.args.length)
                        return !1;
                    for (var o = 0; o < i.args.length; o++)
                        if (i.args[o] !== r.args[o])
                            return !1
                }
                if (t = this.children.length,
                e.children.length !== t)
                    return !1;
                for (n = 0; n < t; n++)
                    if (!this.children[n].equals(e.children[n]))
                        return !1;
                return !0
            },
            guid: 0,
            compile: function(e, t) {
                this.opcodes = [],
                this.children = [],
                this.depths = {
                    list: []
                },
                this.options = t;
                var n = this.options.knownHelpers;
                if (this.options.knownHelpers = {
                    helperMissing: !0,
                    blockHelperMissing: !0,
                    each: !0,
                    if: !0,
                    unless: !0,
                    with: !0,
                    log: !0
                },
                n)
                    for (var i in n)
                        this.options.knownHelpers[i] = n[i];
                return this.accept(e)
            },
            accept: function(e) {
                var t, n = e.strip || {};
                return n.left && this.opcode("strip"),
                t = this[e.type](e),
                n.right && this.opcode("strip"),
                t
            },
            program: function(e) {
                for (var t = e.statements, n = 0, i = t.length; n < i; n++)
                    this.accept(t[n]);
                return this.isSimple = 1 === i,
                this.depths.list = this.depths.list.sort(function(e, t) {
                    return e - t
                }),
                this
            },
            compileProgram: function(e) {
                var t, n = (new this.compiler).compile(e, this.options), i = this.guid++;
                this.usePartial = this.usePartial || n.usePartial,
                this.children[i] = n;
                for (var r = 0, o = n.depths.list.length; r < o; r++)
                    t = n.depths.list[r],
                    t < 2 || this.addDepth(t - 1);
                return i
            },
            block: function(e) {
                var t = e.mustache
                  , n = e.program
                  , i = e.inverse;
                n && (n = this.compileProgram(n)),
                i && (i = this.compileProgram(i));
                var r = t.sexpr
                  , o = this.classifySexpr(r);
                "helper" === o ? this.helperSexpr(r, n, i) : "simple" === o ? (this.simpleSexpr(r),
                this.opcode("pushProgram", n),
                this.opcode("pushProgram", i),
                this.opcode("emptyHash"),
                this.opcode("blockValue")) : (this.ambiguousSexpr(r, n, i),
                this.opcode("pushProgram", n),
                this.opcode("pushProgram", i),
                this.opcode("emptyHash"),
                this.opcode("ambiguousBlockValue")),
                this.opcode("append")
            },
            hash: function(e) {
                var t, n, i = e.pairs;
                this.opcode("pushHash");
                for (var r = 0, o = i.length; r < o; r++)
                    t = i[r],
                    n = t[1],
                    this.options.stringParams ? (n.depth && this.addDepth(n.depth),
                    this.opcode("getContext", n.depth || 0),
                    this.opcode("pushStringParam", n.stringModeValue, n.type),
                    "sexpr" === n.type && this.sexpr(n)) : this.accept(n),
                    this.opcode("assignToHash", t[0]);
                this.opcode("popHash")
            },
            partial: function(e) {
                var t = e.partialName;
                this.usePartial = !0,
                e.context ? this.ID(e.context) : this.opcode("push", "depth0"),
                this.opcode("invokePartial", t.name),
                this.opcode("append")
            },
            content: function(e) {
                this.opcode("appendContent", e.string)
            },
            mustache: function(e) {
                this.sexpr(e.sexpr),
                e.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append")
            },
            ambiguousSexpr: function(e, t, n) {
                var i = e.id
                  , r = i.parts[0]
                  , o = null != t || null != n;
                this.opcode("getContext", i.depth),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                this.opcode("invokeAmbiguous", r, o)
            },
            simpleSexpr: function(e) {
                var t = e.id;
                "DATA" === t.type ? this.DATA(t) : t.parts.length ? this.ID(t) : (this.addDepth(t.depth),
                this.opcode("getContext", t.depth),
                this.opcode("pushContext")),
                this.opcode("resolvePossibleLambda")
            },
            helperSexpr: function(e, t, n) {
                var i = this.setupFullMustacheParams(e, t, n)
                  , r = e.id.parts[0];
                if (this.options.knownHelpers[r])
                    this.opcode("invokeKnownHelper", i.length, r);
                else {
                    if (this.options.knownHelpersOnly)
                        throw new o("You specified knownHelpersOnly, but used the unknown helper " + r,e);
                    this.opcode("invokeHelper", i.length, r, e.isRoot)
                }
            },
            sexpr: function(e) {
                var t = this.classifySexpr(e);
                "simple" === t ? this.simpleSexpr(e) : "helper" === t ? this.helperSexpr(e) : this.ambiguousSexpr(e)
            },
            ID: function(e) {
                this.addDepth(e.depth),
                this.opcode("getContext", e.depth);
                var t = e.parts[0];
                t ? this.opcode("lookupOnContext", e.parts[0]) : this.opcode("pushContext");
                for (var n = 1, i = e.parts.length; n < i; n++)
                    this.opcode("lookup", e.parts[n])
            },
            DATA: function(e) {
                if (this.options.data = !0,
                e.id.isScoped || e.id.depth)
                    throw new o("Scoped data references are not supported: " + e.original,e);
                this.opcode("lookupData");
                for (var t = e.id.parts, n = 0, i = t.length; n < i; n++)
                    this.opcode("lookup", t[n])
            },
            STRING: function(e) {
                this.opcode("pushString", e.string)
            },
            INTEGER: function(e) {
                this.opcode("pushLiteral", e.integer)
            },
            BOOLEAN: function(e) {
                this.opcode("pushLiteral", e.bool)
            },
            comment: function() {},
            opcode: function(e) {
                this.opcodes.push({
                    opcode: e,
                    args: [].slice.call(arguments, 1)
                })
            },
            declare: function(e, t) {
                this.opcodes.push({
                    opcode: "DECLARE",
                    name: e,
                    value: t
                })
            },
            addDepth: function(e) {
                0 !== e && (this.depths[e] || (this.depths[e] = !0,
                this.depths.list.push(e)))
            },
            classifySexpr: function(e) {
                var t = e.isHelper
                  , n = e.eligibleHelper
                  , i = this.options;
                if (n && !t) {
                    var r = e.id.parts[0];
                    i.knownHelpers[r] ? t = !0 : i.knownHelpersOnly && (n = !1)
                }
                return t ? "helper" : n ? "ambiguous" : "simple"
            },
            pushParams: function(e) {
                for (var t, n = e.length; n--; )
                    t = e[n],
                    this.options.stringParams ? (t.depth && this.addDepth(t.depth),
                    this.opcode("getContext", t.depth || 0),
                    this.opcode("pushStringParam", t.stringModeValue, t.type),
                    "sexpr" === t.type && this.sexpr(t)) : this[t.type](t)
            },
            setupFullMustacheParams: function(e, t, n) {
                var i = e.params;
                return this.pushParams(i),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                e.hash ? this.hash(e.hash) : this.opcode("emptyHash"),
                i
            }
        },
        r.precompile = n,
        r.compile = i,
        r
    }(n)
      , u = function(e, t) {
        "use strict";
        function n(e) {
            this.value = e
        }
        function i() {}
        var r, o = e.COMPILER_REVISION, s = e.REVISION_CHANGES, a = e.log, l = t;
        i.prototype = {
            nameLookup: function(e, t) {
                var n, r;
                return 0 === e.indexOf("depth") && (n = !0),
                r = /^[0-9]+$/.test(t) ? e + "[" + t + "]" : i.isValidJavaScriptVariableName(t) ? e + "." + t : e + "['" + t + "']",
                n ? "(" + e + " && " + r + ")" : r
            },
            compilerInfo: function() {
                var e = o
                  , t = s[e];
                return "this.compilerInfo = [" + e + ",'" + t + "'];\n"
            },
            appendToBuffer: function(e) {
                return this.environment.isSimple ? "return " + e + ";" : {
                    appendToBuffer: !0,
                    content: e,
                    toString: function() {
                        return "buffer += " + e + ";"
                    }
                }
            },
            initializeBuffer: function() {
                return this.quotedString("")
            },
            namespace: "Handlebars",
            compile: function(e, t, n, i) {
                this.environment = e,
                this.options = t || {},
                a("debug", this.environment.disassemble() + "\n\n"),
                this.name = this.environment.name,
                this.isChild = !!n,
                this.context = n || {
                    programs: [],
                    environments: [],
                    aliases: {}
                },
                this.preamble(),
                this.stackSlot = 0,
                this.stackVars = [],
                this.registers = {
                    list: []
                },
                this.hashes = [],
                this.compileStack = [],
                this.inlineStack = [],
                this.compileChildren(e, t);
                var r, o = e.opcodes;
                this.i = 0;
                for (var s = o.length; this.i < s; this.i++)
                    r = o[this.i],
                    "DECLARE" === r.opcode ? this[r.name] = r.value : this[r.opcode].apply(this, r.args),
                    r.opcode !== this.stripNext && (this.stripNext = !1);
                if (this.pushSource(""),
                this.stackSlot || this.inlineStack.length || this.compileStack.length)
                    throw new l("Compile completed with content left on stack");
                return this.createFunctionContext(i)
            },
            preamble: function() {
                var e = [];
                if (this.isChild)
                    e.push("");
                else {
                    var t = this.namespace
                      , n = "helpers = this.merge(helpers, " + t + ".helpers);";
                    this.environment.usePartial && (n = n + " partials = this.merge(partials, " + t + ".partials);"),
                    this.options.data && (n += " data = data || {};"),
                    e.push(n)
                }
                this.environment.isSimple ? e.push("") : e.push(", buffer = " + this.initializeBuffer()),
                this.lastContext = 0,
                this.source = e
            },
            createFunctionContext: function(e) {
                var t = this.stackVars.concat(this.registers.list);
                if (t.length > 0 && (this.source[1] = this.source[1] + ", " + t.join(", ")),
                !this.isChild)
                    for (var n in this.context.aliases)
                        this.context.aliases.hasOwnProperty(n) && (this.source[1] = this.source[1] + ", " + n + "=" + this.context.aliases[n]);
                this.source[1] && (this.source[1] = "var " + this.source[1].substring(2) + ";"),
                this.isChild || (this.source[1] += "\n" + this.context.programs.join("\n") + "\n"),
                this.environment.isSimple || this.pushSource("return buffer;");
                for (var i = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"], r = 0, o = this.environment.depths.list.length; r < o; r++)
                    i.push("depth" + this.environment.depths.list[r]);
                var s = this.mergeSource();
                if (this.isChild || (s = this.compilerInfo() + s),
                e)
                    return i.push(s),
                    Function.apply(this, i);
                var l = "function " + (this.name || "") + "(" + i.join(",") + ") {\n  " + s + "}";
                return a("debug", l + "\n\n"),
                l
            },
            mergeSource: function() {
                for (var e, t = "", n = 0, i = this.source.length; n < i; n++) {
                    var r = this.source[n];
                    r.appendToBuffer ? e = e ? e + "\n    + " + r.content : r.content : (e && (t += "buffer += " + e + ";\n  ",
                    e = void 0),
                    t += r + "\n  ")
                }
                return t
            },
            blockValue: function() {
                this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
                var e = ["depth0"];
                this.setupParams(0, e),
                this.replaceStack(function(t) {
                    return e.splice(1, 0, t),
                    "blockHelperMissing.call(" + e.join(", ") + ")"
                })
            },
            ambiguousBlockValue: function() {
                this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
                var e = ["depth0"];
                this.setupParams(0, e);
                var t = this.topStack();
                e.splice(1, 0, t),
                this.pushSource("if (!" + this.lastHelper + ") { " + t + " = blockHelperMissing.call(" + e.join(", ") + "); }")
            },
            appendContent: function(e) {
                this.pendingContent && (e = this.pendingContent + e),
                this.stripNext && (e = e.replace(/^\s+/, "")),
                this.pendingContent = e
            },
            strip: function() {
                this.pendingContent && (this.pendingContent = this.pendingContent.replace(/\s+$/, "")),
                this.stripNext = "strip"
            },
            append: function() {
                this.flushInline();
                var e = this.popStack();
                this.pushSource("if(" + e + " || " + e + " === 0) { " + this.appendToBuffer(e) + " }"),
                this.environment.isSimple && this.pushSource("else { " + this.appendToBuffer("''") + " }")
            },
            appendEscaped: function() {
                this.context.aliases.escapeExpression = "this.escapeExpression",
                this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"))
            },
            getContext: function(e) {
                this.lastContext !== e && (this.lastContext = e)
            },
            lookupOnContext: function(e) {
                this.push(this.nameLookup("depth" + this.lastContext, e, "context"))
            },
            pushContext: function() {
                this.pushStackLiteral("depth" + this.lastContext)
            },
            resolvePossibleLambda: function() {
                this.context.aliases.functionType = '"function"',
                this.replaceStack(function(e) {
                    return "typeof " + e + " === functionType ? " + e + ".apply(depth0) : " + e
                })
            },
            lookup: function(e) {
                this.replaceStack(function(t) {
                    return t + " == null || " + t + " === false ? " + t + " : " + this.nameLookup(t, e, "context")
                })
            },
            lookupData: function() {
                this.pushStackLiteral("data")
            },
            pushStringParam: function(e, t) {
                this.pushStackLiteral("depth" + this.lastContext),
                this.pushString(t),
                "sexpr" !== t && ("string" == typeof e ? this.pushString(e) : this.pushStackLiteral(e))
            },
            emptyHash: function() {
                this.pushStackLiteral("{}"),
                this.options.stringParams && (this.push("{}"),
                this.push("{}"))
            },
            pushHash: function() {
                this.hash && this.hashes.push(this.hash),
                this.hash = {
                    values: [],
                    types: [],
                    contexts: []
                }
            },
            popHash: function() {
                var e = this.hash;
                this.hash = this.hashes.pop(),
                this.options.stringParams && (this.push("{" + e.contexts.join(",") + "}"),
                this.push("{" + e.types.join(",") + "}")),
                this.push("{\n    " + e.values.join(",\n    ") + "\n  }")
            },
            pushString: function(e) {
                this.pushStackLiteral(this.quotedString(e))
            },
            push: function(e) {
                return this.inlineStack.push(e),
                e
            },
            pushLiteral: function(e) {
                this.pushStackLiteral(e)
            },
            pushProgram: function(e) {
                null != e ? this.pushStackLiteral(this.programExpression(e)) : this.pushStackLiteral(null)
            },
            invokeHelper: function(e, t, n) {
                this.context.aliases.helperMissing = "helpers.helperMissing",
                this.useRegister("helper");
                var i = this.lastHelper = this.setupHelper(e, t, !0)
                  , r = this.nameLookup("depth" + this.lastContext, t, "context")
                  , o = "helper = " + i.name + " || " + r;
                i.paramsInit && (o += "," + i.paramsInit),
                this.push("(" + o + ",helper ? helper.call(" + i.callParams + ") : helperMissing.call(" + i.helperMissingParams + "))"),
                n || this.flushInline()
            },
            invokeKnownHelper: function(e, t) {
                var n = this.setupHelper(e, t);
                this.push(n.name + ".call(" + n.callParams + ")")
            },
            invokeAmbiguous: function(e, t) {
                this.context.aliases.functionType = '"function"',
                this.useRegister("helper"),
                this.emptyHash();
                var n = this.setupHelper(0, e, t)
                  , i = this.lastHelper = this.nameLookup("helpers", e, "helper")
                  , r = this.nameLookup("depth" + this.lastContext, e, "context")
                  , o = this.nextStack();
                n.paramsInit && this.pushSource(n.paramsInit),
                this.pushSource("if (helper = " + i + ") { " + o + " = helper.call(" + n.callParams + "); }"),
                this.pushSource("else { helper = " + r + "; " + o + " = typeof helper === functionType ? helper.call(" + n.callParams + ") : helper; }")
            },
            invokePartial: function(e) {
                var t = [this.nameLookup("partials", e, "partial"), "'" + e + "'", this.popStack(), "helpers", "partials"];
                this.options.data && t.push("data"),
                this.context.aliases.self = "this",
                this.push("self.invokePartial(" + t.join(", ") + ")")
            },
            assignToHash: function(e) {
                var t, n, i = this.popStack();
                this.options.stringParams && (n = this.popStack(),
                t = this.popStack());
                var r = this.hash;
                t && r.contexts.push("'" + e + "': " + t),
                n && r.types.push("'" + e + "': " + n),
                r.values.push("'" + e + "': (" + i + ")")
            },
            compiler: i,
            compileChildren: function(e, t) {
                for (var n, i, r = e.children, o = 0, s = r.length; o < s; o++) {
                    n = r[o],
                    i = new this.compiler;
                    var a = this.matchExistingProgram(n);
                    null == a ? (this.context.programs.push(""),
                    a = this.context.programs.length,
                    n.index = a,
                    n.name = "program" + a,
                    this.context.programs[a] = i.compile(n, t, this.context),
                    this.context.environments[a] = n) : (n.index = a,
                    n.name = "program" + a)
                }
            },
            matchExistingProgram: function(e) {
                for (var t = 0, n = this.context.environments.length; t < n; t++) {
                    var i = this.context.environments[t];
                    if (i && i.equals(e))
                        return t
                }
            },
            programExpression: function(e) {
                if (this.context.aliases.self = "this",
                null == e)
                    return "self.noop";
                for (var t, n = this.environment.children[e], i = n.depths.list, r = [n.index, n.name, "data"], o = 0, s = i.length; o < s; o++)
                    t = i[o],
                    1 === t ? r.push("depth0") : r.push("depth" + (t - 1));
                return (0 === i.length ? "self.program(" : "self.programWithDepth(") + r.join(", ") + ")"
            },
            register: function(e, t) {
                this.useRegister(e),
                this.pushSource(e + " = " + t + ";")
            },
            useRegister: function(e) {
                this.registers[e] || (this.registers[e] = !0,
                this.registers.list.push(e))
            },
            pushStackLiteral: function(e) {
                return this.push(new n(e))
            },
            pushSource: function(e) {
                this.pendingContent && (this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent))),
                this.pendingContent = void 0),
                e && this.source.push(e)
            },
            pushStack: function(e) {
                this.flushInline();
                var t = this.incrStack();
                return e && this.pushSource(t + " = " + e + ";"),
                this.compileStack.push(t),
                t
            },
            replaceStack: function(e) {
                var t, i, r, o = "", s = this.isInline();
                if (s) {
                    var a = this.popStack(!0);
                    if (a instanceof n)
                        t = a.value,
                        r = !0;
                    else {
                        i = !this.stackSlot;
                        var l = i ? this.incrStack() : this.topStackName();
                        o = "(" + this.push(l) + " = " + a + "),",
                        t = this.topStack()
                    }
                } else
                    t = this.topStack();
                var c = e.call(this, t);
                return s ? (r || this.popStack(),
                i && this.stackSlot--,
                this.push("(" + o + c + ")")) : (/^stack/.test(t) || (t = this.nextStack()),
                this.pushSource(t + " = (" + o + c + ");")),
                t
            },
            nextStack: function() {
                return this.pushStack()
            },
            incrStack: function() {
                return this.stackSlot++,
                this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot),
                this.topStackName()
            },
            topStackName: function() {
                return "stack" + this.stackSlot
            },
            flushInline: function() {
                var e = this.inlineStack;
                if (e.length) {
                    this.inlineStack = [];
                    for (var t = 0, i = e.length; t < i; t++) {
                        var r = e[t];
                        r instanceof n ? this.compileStack.push(r) : this.pushStack(r)
                    }
                }
            },
            isInline: function() {
                return this.inlineStack.length
            },
            popStack: function(e) {
                var t = this.isInline()
                  , i = (t ? this.inlineStack : this.compileStack).pop();
                if (!e && i instanceof n)
                    return i.value;
                if (!t) {
                    if (!this.stackSlot)
                        throw new l("Invalid stack pop");
                    this.stackSlot--
                }
                return i
            },
            topStack: function(e) {
                var t = this.isInline() ? this.inlineStack : this.compileStack
                  , i = t[t.length - 1];
                return !e && i instanceof n ? i.value : i
            },
            quotedString: function(e) {
                return '"' + e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"'
            },
            setupHelper: function(e, t, n) {
                var i = []
                  , r = this.setupParams(e, i, n)
                  , o = this.nameLookup("helpers", t, "helper");
                return {
                    params: i,
                    paramsInit: r,
                    name: o,
                    callParams: ["depth0"].concat(i).join(", "),
                    helperMissingParams: n && ["depth0", this.quotedString(t)].concat(i).join(", ")
                }
            },
            setupOptions: function(e, t) {
                var n, i, r, o = [], s = [], a = [];
                o.push("hash:" + this.popStack()),
                this.options.stringParams && (o.push("hashTypes:" + this.popStack()),
                o.push("hashContexts:" + this.popStack())),
                i = this.popStack(),
                r = this.popStack(),
                (r || i) && (r || (this.context.aliases.self = "this",
                r = "self.noop"),
                i || (this.context.aliases.self = "this",
                i = "self.noop"),
                o.push("inverse:" + i),
                o.push("fn:" + r));
                for (var l = 0; l < e; l++)
                    n = this.popStack(),
                    t.push(n),
                    this.options.stringParams && (a.push(this.popStack()),
                    s.push(this.popStack()));
                return this.options.stringParams && (o.push("contexts:[" + s.join(",") + "]"),
                o.push("types:[" + a.join(",") + "]")),
                this.options.data && o.push("data:data"),
                o
            },
            setupParams: function(e, t, n) {
                var i = "{" + this.setupOptions(e, t).join(",") + "}";
                return n ? (this.useRegister("options"),
                t.push("options"),
                "options=" + i) : (t.push(i),
                "")
            }
        };
        for (var c = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield".split(" "), u = i.RESERVED_WORDS = {}, p = 0, h = c.length; p < h; p++)
            u[c[p]] = !0;
        return i.isValidJavaScriptVariableName = function(e) {
            return !(i.RESERVED_WORDS[e] || !/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e))
        }
        ,
        r = i
    }(i, n)
      , p = function(e, t, n, i, r) {
        "use strict";
        var o, s = e, a = t, l = n.parser, c = n.parse, u = i.Compiler, p = i.compile, h = i.precompile, f = r, d = s.create, m = function() {
            var e = d();
            return e.compile = function(t, n) {
                return p(t, n, e)
            }
            ,
            e.precompile = function(t, n) {
                return h(t, n, e)
            }
            ,
            e.AST = a,
            e.Compiler = u,
            e.JavaScriptCompiler = f,
            e.Parser = l,
            e.parse = c,
            e
        };
        return s = m(),
        s.create = m,
        o = s
    }(o, s, l, c, u);
    return p
}();
/*!
 * jquery-2.2.3.min.js
 */
/*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
!function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    function n(e) {
        var t = !!e && "length"in e && e.length
          , n = oe.type(e);
        return "function" !== n && !oe.isWindow(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }
    function i(e, t, n) {
        if (oe.isFunction(t))
            return oe.grep(e, function(e, i) {
                return !!t.call(e, i, e) !== n
            });
        if (t.nodeType)
            return oe.grep(e, function(e) {
                return e === t !== n
            });
        if ("string" == typeof t) {
            if (me.test(t))
                return oe.filter(t, e, n);
            t = oe.filter(t, e)
        }
        return oe.grep(e, function(e) {
            return J.call(t, e) > -1 !== n
        })
    }
    function r(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; )
            ;
        return e
    }
    function o(e) {
        var t = {};
        return oe.each(e.match(we) || [], function(e, n) {
            t[n] = !0
        }),
        t
    }
    function s() {
        G.removeEventListener("DOMContentLoaded", s),
        e.removeEventListener("load", s),
        oe.ready()
    }
    function a() {
        this.expando = oe.expando + a.uid++
    }
    function l(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(Pe, "-$&").toLowerCase(),
            n = e.getAttribute(i),
            "string" == typeof n) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : Ne.test(n) ? oe.parseJSON(n) : n)
                } catch (e) {}
                Ee.set(e, t, n)
            } else
                n = void 0;
        return n
    }
    function c(e, t, n, i) {
        var r, o = 1, s = 20, a = i ? function() {
            return i.cur()
        }
        : function() {
            return oe.css(e, t, "")
        }
        , l = a(), c = n && n[3] || (oe.cssNumber[t] ? "" : "px"), u = (oe.cssNumber[t] || "px" !== c && +l) && Ie.exec(oe.css(e, t));
        if (u && u[3] !== c) {
            c = c || u[3],
            n = n || [],
            u = +l || 1;
            do
                o = o || ".5",
                u /= o,
                oe.style(e, t, u + c);
            while (o !== (o = a() / l) && 1 !== o && --s)
        }
        return n && (u = +u || +l || 0,
        r = n[1] ? u + (n[1] + 1) * n[2] : +n[2],
        i && (i.unit = c,
        i.start = u,
        i.end = r)),
        r
    }
    function u(e, t) {
        var n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || t && oe.nodeName(e, t) ? oe.merge([e], n) : n
    }
    function p(e, t) {
        for (var n = 0, i = e.length; i > n; n++)
            Te.set(e[n], "globalEval", !t || Te.get(t[n], "globalEval"))
    }
    function h(e, t, n, i, r) {
        for (var o, s, a, l, c, h, f = t.createDocumentFragment(), d = [], m = 0, v = e.length; v > m; m++)
            if (o = e[m],
            o || 0 === o)
                if ("object" === oe.type(o))
                    oe.merge(d, o.nodeType ? [o] : o);
                else if (He.test(o)) {
                    for (s = s || f.appendChild(t.createElement("div")),
                    a = (De.exec(o) || ["", ""])[1].toLowerCase(),
                    l = Me[a] || Me._default,
                    s.innerHTML = l[1] + oe.htmlPrefilter(o) + l[2],
                    h = l[0]; h--; )
                        s = s.lastChild;
                    oe.merge(d, s.childNodes),
                    s = f.firstChild,
                    s.textContent = ""
                } else
                    d.push(t.createTextNode(o));
        for (f.textContent = "",
        m = 0; o = d[m++]; )
            if (i && oe.inArray(o, i) > -1)
                r && r.push(o);
            else if (c = oe.contains(o.ownerDocument, o),
            s = u(f.appendChild(o), "script"),
            c && p(s),
            n)
                for (h = 0; o = s[h++]; )
                    je.test(o.type || "") && n.push(o);
        return f
    }
    function f() {
        return !0
    }
    function d() {
        return !1
    }
    function m() {
        try {
            return G.activeElement
        } catch (e) {}
    }
    function v(e, t, n, i, r, o) {
        var s, a;
        if ("object" == typeof t) {
            "string" != typeof n && (i = i || n,
            n = void 0);
            for (a in t)
                v(e, a, n, i, t[a], o);
            return e
        }
        if (null == i && null == r ? (r = n,
        i = n = void 0) : null == r && ("string" == typeof n ? (r = i,
        i = void 0) : (r = i,
        i = n,
        n = void 0)),
        r === !1)
            r = d;
        else if (!r)
            return e;
        return 1 === o && (s = r,
        r = function(e) {
            return oe().off(e),
            s.apply(this, arguments)
        }
        ,
        r.guid = s.guid || (s.guid = oe.guid++)),
        e.each(function() {
            oe.event.add(this, t, r, i, n)
        })
    }
    function g(e, t) {
        return oe.nodeName(e, "table") && oe.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }
    function y(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function x(e) {
        var t = We.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"),
        e
    }
    function b(e, t) {
        var n, i, r, o, s, a, l, c;
        if (1 === t.nodeType) {
            if (Te.hasData(e) && (o = Te.access(e),
            s = Te.set(t, o),
            c = o.events)) {
                delete s.handle,
                s.events = {};
                for (r in c)
                    for (n = 0,
                    i = c[r].length; i > n; n++)
                        oe.event.add(t, r, c[r][n])
            }
            Ee.hasData(e) && (a = Ee.access(e),
            l = oe.extend({}, a),
            Ee.set(t, l))
        }
    }
    function w(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && Le.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }
    function S(e, t, n, i) {
        t = K.apply([], t);
        var r, o, s, a, l, c, p = 0, f = e.length, d = f - 1, m = t[0], v = oe.isFunction(m);
        if (v || f > 1 && "string" == typeof m && !ie.checkClone && Be.test(m))
            return e.each(function(r) {
                var o = e.eq(r);
                v && (t[0] = m.call(this, r, o.html())),
                S(o, t, n, i)
            });
        if (f && (r = h(t, e[0].ownerDocument, !1, e, i),
        o = r.firstChild,
        1 === r.childNodes.length && (r = o),
        o || i)) {
            for (s = oe.map(u(r, "script"), y),
            a = s.length; f > p; p++)
                l = r,
                p !== d && (l = oe.clone(l, !0, !0),
                a && oe.merge(s, u(l, "script"))),
                n.call(e[p], l, p);
            if (a)
                for (c = s[s.length - 1].ownerDocument,
                oe.map(s, x),
                p = 0; a > p; p++)
                    l = s[p],
                    je.test(l.type || "") && !Te.access(l, "globalEval") && oe.contains(c, l) && (l.src ? oe._evalUrl && oe._evalUrl(l.src) : oe.globalEval(l.textContent.replace(Ve, "")))
        }
        return e
    }
    function C(e, t, n) {
        for (var i, r = t ? oe.filter(t, e) : e, o = 0; null != (i = r[o]); o++)
            n || 1 !== i.nodeType || oe.cleanData(u(i)),
            i.parentNode && (n && oe.contains(i.ownerDocument, i) && p(u(i, "script")),
            i.parentNode.removeChild(i));
        return e
    }
    function k(e, t) {
        var n = oe(t.createElement(e)).appendTo(t.body)
          , i = oe.css(n[0], "display");
        return n.detach(),
        i
    }
    function T(e) {
        var t = G
          , n = Ue[e];
        return n || (n = k(e, t),
        "none" !== n && n || (Xe = (Xe || oe("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement),
        t = Xe[0].contentDocument,
        t.write(),
        t.close(),
        n = k(e, t),
        Xe.detach()),
        Ue[e] = n),
        n
    }
    function E(e, t, n) {
        var i, r, o, s, a = e.style;
        return n = n || Ze(e),
        s = n ? n.getPropertyValue(t) || n[t] : void 0,
        "" !== s && void 0 !== s || oe.contains(e.ownerDocument, e) || (s = oe.style(e, t)),
        n && !ie.pixelMarginRight() && Ge.test(s) && Ye.test(t) && (i = a.width,
        r = a.minWidth,
        o = a.maxWidth,
        a.minWidth = a.maxWidth = a.width = s,
        s = n.width,
        a.width = i,
        a.minWidth = r,
        a.maxWidth = o),
        void 0 !== s ? s + "" : s
    }
    function N(e, t) {
        return {
            get: function() {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments)
            }
        }
    }
    function P(e) {
        if (e in it)
            return e;
        for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--; )
            if (e = nt[n] + t,
            e in it)
                return e
    }
    function _(e, t, n) {
        var i = Ie.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
    }
    function I(e, t, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > o; o += 2)
            "margin" === n && (s += oe.css(e, n + Oe[o], !0, r)),
            i ? ("content" === n && (s -= oe.css(e, "padding" + Oe[o], !0, r)),
            "margin" !== n && (s -= oe.css(e, "border" + Oe[o] + "Width", !0, r))) : (s += oe.css(e, "padding" + Oe[o], !0, r),
            "padding" !== n && (s += oe.css(e, "border" + Oe[o] + "Width", !0, r)));
        return s
    }
    function O(t, n, i) {
        var r = !0
          , o = "width" === n ? t.offsetWidth : t.offsetHeight
          , s = Ze(t)
          , a = "border-box" === oe.css(t, "boxSizing", !1, s);
        if (G.msFullscreenElement && e.top !== e && t.getClientRects().length && (o = Math.round(100 * t.getBoundingClientRect()[n])),
        0 >= o || null == o) {
            if (o = E(t, n, s),
            (0 > o || null == o) && (o = t.style[n]),
            Ge.test(o))
                return o;
            r = a && (ie.boxSizingReliable() || o === t.style[n]),
            o = parseFloat(o) || 0
        }
        return o + I(t, n, i || (a ? "border" : "content"), r, s) + "px"
    }
    function A(e, t) {
        for (var n, i, r, o = [], s = 0, a = e.length; a > s; s++)
            i = e[s],
            i.style && (o[s] = Te.get(i, "olddisplay"),
            n = i.style.display,
            t ? (o[s] || "none" !== n || (i.style.display = ""),
            "" === i.style.display && Ae(i) && (o[s] = Te.access(i, "olddisplay", T(i.nodeName)))) : (r = Ae(i),
            "none" === n && r || Te.set(i, "olddisplay", r ? n : oe.css(i, "display"))));
        for (s = 0; a > s; s++)
            i = e[s],
            i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? o[s] || "" : "none"));
        return e
    }
    function L(e, t, n, i, r) {
        return new L.prototype.init(e,t,n,i,r)
    }
    function D() {
        return e.setTimeout(function() {
            rt = void 0
        }),
        rt = oe.now()
    }
    function j(e, t) {
        var n, i = 0, r = {
            height: e
        };
        for (t = t ? 1 : 0; 4 > i; i += 2 - t)
            n = Oe[i],
            r["margin" + n] = r["padding" + n] = e;
        return t && (r.opacity = r.width = e),
        r
    }
    function M(e, t, n) {
        for (var i, r = (q.tweeners[t] || []).concat(q.tweeners["*"]), o = 0, s = r.length; s > o; o++)
            if (i = r[o].call(n, t, e))
                return i
    }
    function H(e, t, n) {
        var i, r, o, s, a, l, c, u, p = this, h = {}, f = e.style, d = e.nodeType && Ae(e), m = Te.get(e, "fxshow");
        n.queue || (a = oe._queueHooks(e, "fx"),
        null == a.unqueued && (a.unqueued = 0,
        l = a.empty.fire,
        a.empty.fire = function() {
            a.unqueued || l()
        }
        ),
        a.unqueued++,
        p.always(function() {
            p.always(function() {
                a.unqueued--,
                oe.queue(e, "fx").length || a.empty.fire()
            })
        })),
        1 === e.nodeType && ("height"in t || "width"in t) && (n.overflow = [f.overflow, f.overflowX, f.overflowY],
        c = oe.css(e, "display"),
        u = "none" === c ? Te.get(e, "olddisplay") || T(e.nodeName) : c,
        "inline" === u && "none" === oe.css(e, "float") && (f.display = "inline-block")),
        n.overflow && (f.overflow = "hidden",
        p.always(function() {
            f.overflow = n.overflow[0],
            f.overflowX = n.overflow[1],
            f.overflowY = n.overflow[2]
        }));
        for (i in t)
            if (r = t[i],
            st.exec(r)) {
                if (delete t[i],
                o = o || "toggle" === r,
                r === (d ? "hide" : "show")) {
                    if ("show" !== r || !m || void 0 === m[i])
                        continue;
                    d = !0
                }
                h[i] = m && m[i] || oe.style(e, i)
            } else
                c = void 0;
        if (oe.isEmptyObject(h))
            "inline" === ("none" === c ? T(e.nodeName) : c) && (f.display = c);
        else {
            m ? "hidden"in m && (d = m.hidden) : m = Te.access(e, "fxshow", {}),
            o && (m.hidden = !d),
            d ? oe(e).show() : p.done(function() {
                oe(e).hide()
            }),
            p.done(function() {
                var t;
                Te.remove(e, "fxshow");
                for (t in h)
                    oe.style(e, t, h[t])
            });
            for (i in h)
                s = M(d ? m[i] : 0, i, p),
                i in m || (m[i] = s.start,
                d && (s.end = s.start,
                s.start = "width" === i || "height" === i ? 1 : 0))
        }
    }
    function F(e, t) {
        var n, i, r, o, s;
        for (n in e)
            if (i = oe.camelCase(n),
            r = t[i],
            o = e[n],
            oe.isArray(o) && (r = o[1],
            o = e[n] = o[0]),
            n !== i && (e[i] = o,
            delete e[n]),
            s = oe.cssHooks[i],
            s && "expand"in s) {
                o = s.expand(o),
                delete e[i];
                for (n in o)
                    n in e || (e[n] = o[n],
                    t[n] = r)
            } else
                t[i] = r
    }
    function q(e, t, n) {
        var i, r, o = 0, s = q.prefilters.length, a = oe.Deferred().always(function() {
            delete l.elem
        }), l = function() {
            if (r)
                return !1;
            for (var t = rt || D(), n = Math.max(0, c.startTime + c.duration - t), i = n / c.duration || 0, o = 1 - i, s = 0, l = c.tweens.length; l > s; s++)
                c.tweens[s].run(o);
            return a.notifyWith(e, [c, o, n]),
            1 > o && l ? n : (a.resolveWith(e, [c]),
            !1)
        }, c = a.promise({
            elem: e,
            props: oe.extend({}, t),
            opts: oe.extend(!0, {
                specialEasing: {},
                easing: oe.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: rt || D(),
            duration: n.duration,
            tweens: [],
            createTween: function(t, n) {
                var i = oe.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                return c.tweens.push(i),
                i
            },
            stop: function(t) {
                var n = 0
                  , i = t ? c.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; i > n; n++)
                    c.tweens[n].run(1);
                return t ? (a.notifyWith(e, [c, 1, 0]),
                a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]),
                this
            }
        }), u = c.props;
        for (F(u, c.opts.specialEasing); s > o; o++)
            if (i = q.prefilters[o].call(c, e, u, c.opts))
                return oe.isFunction(i.stop) && (oe._queueHooks(c.elem, c.opts.queue).stop = oe.proxy(i.stop, i)),
                i;
        return oe.map(u, M, c),
        oe.isFunction(c.opts.start) && c.opts.start.call(e, c),
        oe.fx.timer(oe.extend(l, {
            elem: e,
            anim: c,
            queue: c.opts.queue
        })),
        c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }
    function R(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function $(e) {
        return function(t, n) {
            "string" != typeof t && (n = t,
            t = "*");
            var i, r = 0, o = t.toLowerCase().match(we) || [];
            if (oe.isFunction(n))
                for (; i = o[r++]; )
                    "+" === i[0] ? (i = i.slice(1) || "*",
                    (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
        }
    }
    function z(e, t, n, i) {
        function r(a) {
            var l;
            return o[a] = !0,
            oe.each(e[a] || [], function(e, a) {
                var c = a(t, n, i);
                return "string" != typeof c || s || o[c] ? s ? !(l = c) : void 0 : (t.dataTypes.unshift(c),
                r(c),
                !1)
            }),
            l
        }
        var o = {}
          , s = e === Et;
        return r(t.dataTypes[0]) || !o["*"] && r("*")
    }
    function B(e, t) {
        var n, i, r = oe.ajaxSettings.flatOptions || {};
        for (n in t)
            void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        return i && oe.extend(!0, e, i),
        e
    }
    function W(e, t, n) {
        for (var i, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
            l.shift(),
            void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
        if (i)
            for (r in a)
                if (a[r] && a[r].test(i)) {
                    l.unshift(r);
                    break
                }
        if (l[0]in n)
            o = l[0];
        else {
            for (r in n) {
                if (!l[0] || e.converters[r + " " + l[0]]) {
                    o = r;
                    break
                }
                s || (s = r)
            }
            o = o || s
        }
        return o ? (o !== l[0] && l.unshift(o),
        n[o]) : void 0
    }
    function V(e, t, n, i) {
        var r, o, s, a, l, c = {}, u = e.dataTypes.slice();
        if (u[1])
            for (s in e.converters)
                c[s.toLowerCase()] = e.converters[s];
        for (o = u.shift(); o; )
            if (e.responseFields[o] && (n[e.responseFields[o]] = t),
            !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
            l = o,
            o = u.shift())
                if ("*" === o)
                    o = l;
                else if ("*" !== l && l !== o) {
                    if (s = c[l + " " + o] || c["* " + o],
                    !s)
                        for (r in c)
                            if (a = r.split(" "),
                            a[1] === o && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                s === !0 ? s = c[r] : c[r] !== !0 && (o = a[0],
                                u.unshift(a[1]));
                                break
                            }
                    if (s !== !0)
                        if (s && e.throws)
                            t = s(t);
                        else
                            try {
                                t = s(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: s ? e : "No conversion from " + l + " to " + o
                                }
                            }
                }
        return {
            state: "success",
            data: t
        }
    }
    function X(e, t, n, i) {
        var r;
        if (oe.isArray(t))
            oe.each(t, function(t, r) {
                n || It.test(e) ? i(e, r) : X(e + "[" + ("object" == typeof r && null != r ? t : "") + "]", r, n, i)
            });
        else if (n || "object" !== oe.type(t))
            i(e, t);
        else
            for (r in t)
                X(e + "[" + r + "]", t[r], n, i)
    }
    function U(e) {
        return oe.isWindow(e) ? e : 9 === e.nodeType && e.defaultView
    }
    var Y = []
      , G = e.document
      , Z = Y.slice
      , K = Y.concat
      , Q = Y.push
      , J = Y.indexOf
      , ee = {}
      , te = ee.toString
      , ne = ee.hasOwnProperty
      , ie = {}
      , re = "2.2.3"
      , oe = function(e, t) {
        return new oe.fn.init(e,t)
    }
      , se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
      , ae = /^-ms-/
      , le = /-([\da-z])/gi
      , ce = function(e, t) {
        return t.toUpperCase()
    };
    oe.fn = oe.prototype = {
        jquery: re,
        constructor: oe,
        selector: "",
        length: 0,
        toArray: function() {
            return Z.call(this)
        },
        get: function(e) {
            return null != e ? 0 > e ? this[e + this.length] : this[e] : Z.call(this)
        },
        pushStack: function(e) {
            var t = oe.merge(this.constructor(), e);
            return t.prevObject = this,
            t.context = this.context,
            t
        },
        each: function(e) {
            return oe.each(this, e)
        },
        map: function(e) {
            return this.pushStack(oe.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(Z.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length
              , n = +e + (0 > e ? t : 0);
            return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: Q,
        sort: Y.sort,
        splice: Y.splice
    },
    oe.extend = oe.fn.extend = function() {
        var e, t, n, i, r, o, s = arguments[0] || {}, a = 1, l = arguments.length, c = !1;
        for ("boolean" == typeof s && (c = s,
        s = arguments[a] || {},
        a++),
        "object" == typeof s || oe.isFunction(s) || (s = {}),
        a === l && (s = this,
        a--); l > a; a++)
            if (null != (e = arguments[a]))
                for (t in e)
                    n = s[t],
                    i = e[t],
                    s !== i && (c && i && (oe.isPlainObject(i) || (r = oe.isArray(i))) ? (r ? (r = !1,
                    o = n && oe.isArray(n) ? n : []) : o = n && oe.isPlainObject(n) ? n : {},
                    s[t] = oe.extend(c, o, i)) : void 0 !== i && (s[t] = i));
        return s
    }
    ,
    oe.extend({
        expando: "jQuery" + (re + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === oe.type(e)
        },
        isArray: Array.isArray,
        isWindow: function(e) {
            return null != e && e === e.window
        },
        isNumeric: function(e) {
            var t = e && e.toString();
            return !oe.isArray(e) && t - parseFloat(t) + 1 >= 0
        },
        isPlainObject: function(e) {
            var t;
            if ("object" !== oe.type(e) || e.nodeType || oe.isWindow(e))
                return !1;
            if (e.constructor && !ne.call(e, "constructor") && !ne.call(e.constructor.prototype || {}, "isPrototypeOf"))
                return !1;
            for (t in e)
                ;
            return void 0 === t || ne.call(e, t)
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? ee[te.call(e)] || "object" : typeof e
        },
        globalEval: function(e) {
            var t, n = eval;
            e = oe.trim(e),
            e && (1 === e.indexOf("use strict") ? (t = G.createElement("script"),
            t.text = e,
            G.head.appendChild(t).parentNode.removeChild(t)) : n(e))
        },
        camelCase: function(e) {
            return e.replace(ae, "ms-").replace(le, ce)
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        },
        each: function(e, t) {
            var i, r = 0;
            if (n(e))
                for (i = e.length; i > r && t.call(e[r], r, e[r]) !== !1; r++)
                    ;
            else
                for (r in e)
                    if (t.call(e[r], r, e[r]) === !1)
                        break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(se, "")
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (n(Object(e)) ? oe.merge(i, "string" == typeof e ? [e] : e) : Q.call(i, e)),
            i
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : J.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; n > i; i++)
                e[r++] = t[i];
            return e.length = r,
            e
        },
        grep: function(e, t, n) {
            for (var i, r = [], o = 0, s = e.length, a = !n; s > o; o++)
                i = !t(e[o], o),
                i !== a && r.push(e[o]);
            return r
        },
        map: function(e, t, i) {
            var r, o, s = 0, a = [];
            if (n(e))
                for (r = e.length; r > s; s++)
                    o = t(e[s], s, i),
                    null != o && a.push(o);
            else
                for (s in e)
                    o = t(e[s], s, i),
                    null != o && a.push(o);
            return K.apply([], a)
        },
        guid: 1,
        proxy: function(e, t) {
            var n, i, r;
            return "string" == typeof t && (n = e[t],
            t = e,
            e = n),
            oe.isFunction(e) ? (i = Z.call(arguments, 2),
            r = function() {
                return e.apply(t || this, i.concat(Z.call(arguments)))
            }
            ,
            r.guid = e.guid = e.guid || oe.guid++,
            r) : void 0
        },
        now: Date.now,
        support: ie
    }),
    "function" == typeof Symbol && (oe.fn[Symbol.iterator] = Y[Symbol.iterator]),
    oe.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        ee["[object " + t + "]"] = t.toLowerCase()
    });
    var ue = function(e) {
        function t(e, t, n, i) {
            var r, o, s, a, l, c, p, f, d = t && t.ownerDocument, m = t ? t.nodeType : 9;
            if (n = n || [],
            "string" != typeof e || !e || 1 !== m && 9 !== m && 11 !== m)
                return n;
            if (!i && ((t ? t.ownerDocument || t : R) !== A && O(t),
            t = t || A,
            D)) {
                if (11 !== m && (c = ge.exec(e)))
                    if (r = c[1]) {
                        if (9 === m) {
                            if (!(s = t.getElementById(r)))
                                return n;
                            if (s.id === r)
                                return n.push(s),
                                n
                        } else if (d && (s = d.getElementById(r)) && F(t, s) && s.id === r)
                            return n.push(s),
                            n
                    } else {
                        if (c[2])
                            return Q.apply(n, t.getElementsByTagName(e)),
                            n;
                        if ((r = c[3]) && w.getElementsByClassName && t.getElementsByClassName)
                            return Q.apply(n, t.getElementsByClassName(r)),
                            n
                    }
                if (w.qsa && !V[e + " "] && (!j || !j.test(e))) {
                    if (1 !== m)
                        d = t,
                        f = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((a = t.getAttribute("id")) ? a = a.replace(xe, "\\$&") : t.setAttribute("id", a = q),
                        p = T(e),
                        o = p.length,
                        l = he.test(a) ? "#" + a : "[id='" + a + "']"; o--; )
                            p[o] = l + " " + h(p[o]);
                        f = p.join(","),
                        d = ye.test(e) && u(t.parentNode) || t
                    }
                    if (f)
                        try {
                            return Q.apply(n, d.querySelectorAll(f)),
                            n
                        } catch (e) {} finally {
                            a === q && t.removeAttribute("id")
                        }
                }
            }
            return N(e.replace(ae, "$1"), t, n, i)
        }
        function n() {
            function e(n, i) {
                return t.push(n + " ") > S.cacheLength && delete e[t.shift()],
                e[n + " "] = i
            }
            var t = [];
            return e
        }
        function i(e) {
            return e[q] = !0,
            e
        }
        function r(e) {
            var t = A.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function o(e, t) {
            for (var n = e.split("|"), i = n.length; i--; )
                S.attrHandle[n[i]] = t
        }
        function s(e, t) {
            var n = t && e
              , i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || U) - (~e.sourceIndex || U);
            if (i)
                return i;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function a(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return "input" === n && t.type === e
            }
        }
        function l(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }
        function c(e) {
            return i(function(t) {
                return t = +t,
                i(function(n, i) {
                    for (var r, o = e([], n.length, t), s = o.length; s--; )
                        n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }
        function u(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e
        }
        function p() {}
        function h(e) {
            for (var t = 0, n = e.length, i = ""; n > t; t++)
                i += e[t].value;
            return i
        }
        function f(e, t, n) {
            var i = t.dir
              , r = n && "parentNode" === i
              , o = z++;
            return t.first ? function(t, n, o) {
                for (; t = t[i]; )
                    if (1 === t.nodeType || r)
                        return e(t, n, o)
            }
            : function(t, n, s) {
                var a, l, c, u = [$, o];
                if (s) {
                    for (; t = t[i]; )
                        if ((1 === t.nodeType || r) && e(t, n, s))
                            return !0
                } else
                    for (; t = t[i]; )
                        if (1 === t.nodeType || r) {
                            if (c = t[q] || (t[q] = {}),
                            l = c[t.uniqueID] || (c[t.uniqueID] = {}),
                            (a = l[i]) && a[0] === $ && a[1] === o)
                                return u[2] = a[2];
                            if (l[i] = u,
                            u[2] = e(t, n, s))
                                return !0
                        }
            }
        }
        function d(e) {
            return e.length > 1 ? function(t, n, i) {
                for (var r = e.length; r--; )
                    if (!e[r](t, n, i))
                        return !1;
                return !0
            }
            : e[0]
        }
        function m(e, n, i) {
            for (var r = 0, o = n.length; o > r; r++)
                t(e, n[r], i);
            return i
        }
        function v(e, t, n, i, r) {
            for (var o, s = [], a = 0, l = e.length, c = null != t; l > a; a++)
                (o = e[a]) && (n && !n(o, i, r) || (s.push(o),
                c && t.push(a)));
            return s
        }
        function g(e, t, n, r, o, s) {
            return r && !r[q] && (r = g(r)),
            o && !o[q] && (o = g(o, s)),
            i(function(i, s, a, l) {
                var c, u, p, h = [], f = [], d = s.length, g = i || m(t || "*", a.nodeType ? [a] : a, []), y = !e || !i && t ? g : v(g, h, e, a, l), x = n ? o || (i ? e : d || r) ? [] : s : y;
                if (n && n(y, x, a, l),
                r)
                    for (c = v(x, f),
                    r(c, [], a, l),
                    u = c.length; u--; )
                        (p = c[u]) && (x[f[u]] = !(y[f[u]] = p));
                if (i) {
                    if (o || e) {
                        if (o) {
                            for (c = [],
                            u = x.length; u--; )
                                (p = x[u]) && c.push(y[u] = p);
                            o(null, x = [], c, l)
                        }
                        for (u = x.length; u--; )
                            (p = x[u]) && (c = o ? ee(i, p) : h[u]) > -1 && (i[c] = !(s[c] = p))
                    }
                } else
                    x = v(x === s ? x.splice(d, x.length) : x),
                    o ? o(null, s, x, l) : Q.apply(s, x)
            })
        }
        function y(e) {
            for (var t, n, i, r = e.length, o = S.relative[e[0].type], s = o || S.relative[" "], a = o ? 1 : 0, l = f(function(e) {
                return e === t
            }, s, !0), c = f(function(e) {
                return ee(t, e) > -1
            }, s, !0), u = [function(e, n, i) {
                var r = !o && (i || n !== P) || ((t = n).nodeType ? l(e, n, i) : c(e, n, i));
                return t = null,
                r
            }
            ]; r > a; a++)
                if (n = S.relative[e[a].type])
                    u = [f(d(u), n)];
                else {
                    if (n = S.filter[e[a].type].apply(null, e[a].matches),
                    n[q]) {
                        for (i = ++a; r > i && !S.relative[e[i].type]; i++)
                            ;
                        return g(a > 1 && d(u), a > 1 && h(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(ae, "$1"), n, i > a && y(e.slice(a, i)), r > i && y(e = e.slice(i)), r > i && h(e))
                    }
                    u.push(n)
                }
            return d(u)
        }
        function x(e, n) {
            var r = n.length > 0
              , o = e.length > 0
              , s = function(i, s, a, l, c) {
                var u, p, h, f = 0, d = "0", m = i && [], g = [], y = P, x = i || o && S.find.TAG("*", c), b = $ += null == y ? 1 : Math.random() || .1, w = x.length;
                for (c && (P = s === A || s || c); d !== w && null != (u = x[d]); d++) {
                    if (o && u) {
                        for (p = 0,
                        s || u.ownerDocument === A || (O(u),
                        a = !D); h = e[p++]; )
                            if (h(u, s || A, a)) {
                                l.push(u);
                                break
                            }
                        c && ($ = b)
                    }
                    r && ((u = !h && u) && f--,
                    i && m.push(u))
                }
                if (f += d,
                r && d !== f) {
                    for (p = 0; h = n[p++]; )
                        h(m, g, s, a);
                    if (i) {
                        if (f > 0)
                            for (; d--; )
                                m[d] || g[d] || (g[d] = Z.call(l));
                        g = v(g)
                    }
                    Q.apply(l, g),
                    c && !i && g.length > 0 && f + n.length > 1 && t.uniqueSort(l)
                }
                return c && ($ = b,
                P = y),
                m
            };
            return r ? i(s) : s
        }
        var b, w, S, C, k, T, E, N, P, _, I, O, A, L, D, j, M, H, F, q = "sizzle" + 1 * new Date, R = e.document, $ = 0, z = 0, B = n(), W = n(), V = n(), X = function(e, t) {
            return e === t && (I = !0),
            0
        }, U = 1 << 31, Y = {}.hasOwnProperty, G = [], Z = G.pop, K = G.push, Q = G.push, J = G.slice, ee = function(e, t) {
            for (var n = 0, i = e.length; i > n; n++)
                if (e[n] === t)
                    return n;
            return -1
        }, te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", ne = "[\\x20\\t\\r\\n\\f]", ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", re = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ne + "*\\]", oe = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + re + ")*)|.*)\\)|)", se = new RegExp(ne + "+","g"), ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$","g"), le = new RegExp("^" + ne + "*," + ne + "*"), ce = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"), ue = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]","g"), pe = new RegExp(oe), he = new RegExp("^" + ie + "$"), fe = {
            ID: new RegExp("^#(" + ie + ")"),
            CLASS: new RegExp("^\\.(" + ie + ")"),
            TAG: new RegExp("^(" + ie + "|[*])"),
            ATTR: new RegExp("^" + re),
            PSEUDO: new RegExp("^" + oe),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)","i"),
            bool: new RegExp("^(?:" + te + ")$","i"),
            needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)","i")
        }, de = /^(?:input|select|textarea|button)$/i, me = /^h\d$/i, ve = /^[^{]+\{\s*\[native \w/, ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ye = /[+~]/, xe = /'|\\/g, be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)","ig"), we = function(e, t, n) {
            var i = "0x" + t - 65536;
            return i !== i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        }, Se = function() {
            O()
        };
        try {
            Q.apply(G = J.call(R.childNodes), R.childNodes),
            G[R.childNodes.length].nodeType
        } catch (e) {
            Q = {
                apply: G.length ? function(e, t) {
                    K.apply(e, J.call(t))
                }
                : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++]; )
                        ;
                    e.length = n - 1
                }
            }
        }
        w = t.support = {},
        k = t.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }
        ,
        O = t.setDocument = function(e) {
            var t, n, i = e ? e.ownerDocument || e : R;
            return i !== A && 9 === i.nodeType && i.documentElement ? (A = i,
            L = A.documentElement,
            D = !k(A),
            (n = A.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", Se, !1) : n.attachEvent && n.attachEvent("onunload", Se)),
            w.attributes = r(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            w.getElementsByTagName = r(function(e) {
                return e.appendChild(A.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            w.getElementsByClassName = ve.test(A.getElementsByClassName),
            w.getById = r(function(e) {
                return L.appendChild(e).id = q,
                !A.getElementsByName || !A.getElementsByName(q).length
            }),
            w.getById ? (S.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && D) {
                    var n = t.getElementById(e);
                    return n ? [n] : []
                }
            }
            ,
            S.filter.ID = function(e) {
                var t = e.replace(be, we);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ) : (delete S.find.ID,
            S.filter.ID = function(e) {
                var t = e.replace(be, we);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }
            ),
            S.find.TAG = w.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : w.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var n, i = [], r = 0, o = t.getElementsByTagName(e);
                if ("*" === e) {
                    for (; n = o[r++]; )
                        1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }
            ,
            S.find.CLASS = w.getElementsByClassName && function(e, t) {
                return "undefined" != typeof t.getElementsByClassName && D ? t.getElementsByClassName(e) : void 0
            }
            ,
            M = [],
            j = [],
            (w.qsa = ve.test(A.querySelectorAll)) && (r(function(e) {
                L.appendChild(e).innerHTML = "<a id='" + q + "'></a><select id='" + q + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && j.push("[*^$]=" + ne + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || j.push("\\[" + ne + "*(?:value|" + te + ")"),
                e.querySelectorAll("[id~=" + q + "-]").length || j.push("~="),
                e.querySelectorAll(":checked").length || j.push(":checked"),
                e.querySelectorAll("a#" + q + "+*").length || j.push(".#.+[+~]")
            }),
            r(function(e) {
                var t = A.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && j.push("name" + ne + "*[*^$|!~]?="),
                e.querySelectorAll(":enabled").length || j.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                j.push(",.*:")
            })),
            (w.matchesSelector = ve.test(H = L.matches || L.webkitMatchesSelector || L.mozMatchesSelector || L.oMatchesSelector || L.msMatchesSelector)) && r(function(e) {
                w.disconnectedMatch = H.call(e, "div"),
                H.call(e, "[s!='']:x"),
                M.push("!=", oe)
            }),
            j = j.length && new RegExp(j.join("|")),
            M = M.length && new RegExp(M.join("|")),
            t = ve.test(L.compareDocumentPosition),
            F = t || ve.test(L.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e
                  , i = t && t.parentNode;
                return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
            }
            : function(e, t) {
                if (t)
                    for (; t = t.parentNode; )
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            X = t ? function(e, t) {
                if (e === t)
                    return I = !0,
                    0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n ? n : (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1,
                1 & n || !w.sortDetached && t.compareDocumentPosition(e) === n ? e === A || e.ownerDocument === R && F(R, e) ? -1 : t === A || t.ownerDocument === R && F(R, t) ? 1 : _ ? ee(_, e) - ee(_, t) : 0 : 4 & n ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return I = !0,
                    0;
                var n, i = 0, r = e.parentNode, o = t.parentNode, a = [e], l = [t];
                if (!r || !o)
                    return e === A ? -1 : t === A ? 1 : r ? -1 : o ? 1 : _ ? ee(_, e) - ee(_, t) : 0;
                if (r === o)
                    return s(e, t);
                for (n = e; n = n.parentNode; )
                    a.unshift(n);
                for (n = t; n = n.parentNode; )
                    l.unshift(n);
                for (; a[i] === l[i]; )
                    i++;
                return i ? s(a[i], l[i]) : a[i] === R ? -1 : l[i] === R ? 1 : 0
            }
            ,
            A) : A
        }
        ,
        t.matches = function(e, n) {
            return t(e, null, null, n)
        }
        ,
        t.matchesSelector = function(e, n) {
            if ((e.ownerDocument || e) !== A && O(e),
            n = n.replace(ue, "='$1']"),
            w.matchesSelector && D && !V[n + " "] && (!M || !M.test(n)) && (!j || !j.test(n)))
                try {
                    var i = H.call(e, n);
                    if (i || w.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return i
                } catch (e) {}
            return t(n, A, null, [e]).length > 0
        }
        ,
        t.contains = function(e, t) {
            return (e.ownerDocument || e) !== A && O(e),
            F(e, t)
        }
        ,
        t.attr = function(e, t) {
            (e.ownerDocument || e) !== A && O(e);
            var n = S.attrHandle[t.toLowerCase()]
              , i = n && Y.call(S.attrHandle, t.toLowerCase()) ? n(e, t, !D) : void 0;
            return void 0 !== i ? i : w.attributes || !D ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }
        ,
        t.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        t.uniqueSort = function(e) {
            var t, n = [], i = 0, r = 0;
            if (I = !w.detectDuplicates,
            _ = !w.sortStable && e.slice(0),
            e.sort(X),
            I) {
                for (; t = e[r++]; )
                    t === e[r] && (i = n.push(r));
                for (; i--; )
                    e.splice(n[i], 1)
            }
            return _ = null,
            e
        }
        ,
        C = t.getText = function(e) {
            var t, n = "", i = 0, r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        n += C(e)
                } else if (3 === r || 4 === r)
                    return e.nodeValue
            } else
                for (; t = e[i++]; )
                    n += C(t);
            return n
        }
        ,
        S = t.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: fe,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(be, we),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(be, we),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && pe.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                    e[2] = n.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(be, we).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = B[e + " "];
                    return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && B(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(e, n, i) {
                    return function(r) {
                        var o = t.attr(r, e);
                        return null == o ? "!=" === n : !n || (o += "",
                        "=" === n ? o === i : "!=" === n ? o !== i : "^=" === n ? i && 0 === o.indexOf(i) : "*=" === n ? i && o.indexOf(i) > -1 : "$=" === n ? i && o.slice(-i.length) === i : "~=" === n ? (" " + o.replace(se, " ") + " ").indexOf(i) > -1 : "|=" === n && (o === i || o.slice(0, i.length + 1) === i + "-"))
                    }
                },
                CHILD: function(e, t, n, i, r) {
                    var o = "nth" !== e.slice(0, 3)
                      , s = "last" !== e.slice(-4)
                      , a = "of-type" === t;
                    return 1 === i && 0 === r ? function(e) {
                        return !!e.parentNode
                    }
                    : function(t, n, l) {
                        var c, u, p, h, f, d, m = o !== s ? "nextSibling" : "previousSibling", v = t.parentNode, g = a && t.nodeName.toLowerCase(), y = !l && !a, x = !1;
                        if (v) {
                            if (o) {
                                for (; m; ) {
                                    for (h = t; h = h[m]; )
                                        if (a ? h.nodeName.toLowerCase() === g : 1 === h.nodeType)
                                            return !1;
                                    d = m = "only" === e && !d && "nextSibling"
                                }
                                return !0
                            }
                            if (d = [s ? v.firstChild : v.lastChild],
                            s && y) {
                                for (h = v,
                                p = h[q] || (h[q] = {}),
                                u = p[h.uniqueID] || (p[h.uniqueID] = {}),
                                c = u[e] || [],
                                f = c[0] === $ && c[1],
                                x = f && c[2],
                                h = f && v.childNodes[f]; h = ++f && h && h[m] || (x = f = 0) || d.pop(); )
                                    if (1 === h.nodeType && ++x && h === t) {
                                        u[e] = [$, f, x];
                                        break
                                    }
                            } else if (y && (h = t,
                            p = h[q] || (h[q] = {}),
                            u = p[h.uniqueID] || (p[h.uniqueID] = {}),
                            c = u[e] || [],
                            f = c[0] === $ && c[1],
                            x = f),
                            x === !1)
                                for (; (h = ++f && h && h[m] || (x = f = 0) || d.pop()) && ((a ? h.nodeName.toLowerCase() !== g : 1 !== h.nodeType) || !++x || (y && (p = h[q] || (h[q] = {}),
                                u = p[h.uniqueID] || (p[h.uniqueID] = {}),
                                u[e] = [$, x]),
                                h !== t)); )
                                    ;
                            return x -= r,
                            x === i || x % i === 0 && x / i >= 0
                        }
                    }
                },
                PSEUDO: function(e, n) {
                    var r, o = S.pseudos[e] || S.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return o[q] ? o(n) : o.length > 1 ? (r = [e, e, "", n],
                    S.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
                        for (var i, r = o(e, n), s = r.length; s--; )
                            i = ee(e, r[s]),
                            e[i] = !(t[i] = r[s])
                    }) : function(e) {
                        return o(e, 0, r)
                    }
                    ) : o
                }
            },
            pseudos: {
                not: i(function(e) {
                    var t = []
                      , n = []
                      , r = E(e.replace(ae, "$1"));
                    return r[q] ? i(function(e, t, n, i) {
                        for (var o, s = r(e, null, i, []), a = e.length; a--; )
                            (o = s[a]) && (e[a] = !(t[a] = o))
                    }) : function(e, i, o) {
                        return t[0] = e,
                        r(t, null, o, n),
                        t[0] = null,
                        !n.pop()
                    }
                }),
                has: i(function(e) {
                    return function(n) {
                        return t(e, n).length > 0
                    }
                }),
                contains: i(function(e) {
                    return e = e.replace(be, we),
                    function(t) {
                        return (t.textContent || t.innerText || C(t)).indexOf(e) > -1
                    }
                }),
                lang: i(function(e) {
                    return he.test(e || "") || t.error("unsupported lang: " + e),
                    e = e.replace(be, we).toLowerCase(),
                    function(t) {
                        var n;
                        do
                            if (n = D ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                return n = n.toLowerCase(),
                                n === e || 0 === n.indexOf(e + "-");
                        while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                },
                root: function(e) {
                    return e === L
                },
                focus: function(e) {
                    return e === A.activeElement && (!A.hasFocus || A.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: function(e) {
                    return e.disabled === !1
                },
                disabled: function(e) {
                    return e.disabled === !0
                },
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    e.selected === !0
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !S.pseudos.empty(e)
                },
                header: function(e) {
                    return me.test(e.nodeName)
                },
                input: function(e) {
                    return de.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: c(function() {
                    return [0]
                }),
                last: c(function(e, t) {
                    return [t - 1]
                }),
                eq: c(function(e, t, n) {
                    return [0 > n ? n + t : n]
                }),
                even: c(function(e, t) {
                    for (var n = 0; t > n; n += 2)
                        e.push(n);
                    return e
                }),
                odd: c(function(e, t) {
                    for (var n = 1; t > n; n += 2)
                        e.push(n);
                    return e
                }),
                lt: c(function(e, t, n) {
                    for (var i = 0 > n ? n + t : n; --i >= 0; )
                        e.push(i);
                    return e
                }),
                gt: c(function(e, t, n) {
                    for (var i = 0 > n ? n + t : n; ++i < t; )
                        e.push(i);
                    return e
                })
            }
        },
        S.pseudos.nth = S.pseudos.eq;
        for (b in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            S.pseudos[b] = a(b);
        for (b in {
            submit: !0,
            reset: !0
        })
            S.pseudos[b] = l(b);
        return p.prototype = S.filters = S.pseudos,
        S.setFilters = new p,
        T = t.tokenize = function(e, n) {
            var i, r, o, s, a, l, c, u = W[e + " "];
            if (u)
                return n ? 0 : u.slice(0);
            for (a = e,
            l = [],
            c = S.preFilter; a; ) {
                i && !(r = le.exec(a)) || (r && (a = a.slice(r[0].length) || a),
                l.push(o = [])),
                i = !1,
                (r = ce.exec(a)) && (i = r.shift(),
                o.push({
                    value: i,
                    type: r[0].replace(ae, " ")
                }),
                a = a.slice(i.length));
                for (s in S.filter)
                    !(r = fe[s].exec(a)) || c[s] && !(r = c[s](r)) || (i = r.shift(),
                    o.push({
                        value: i,
                        type: s,
                        matches: r
                    }),
                    a = a.slice(i.length));
                if (!i)
                    break
            }
            return n ? a.length : a ? t.error(e) : W(e, l).slice(0)
        }
        ,
        E = t.compile = function(e, t) {
            var n, i = [], r = [], o = V[e + " "];
            if (!o) {
                for (t || (t = T(e)),
                n = t.length; n--; )
                    o = y(t[n]),
                    o[q] ? i.push(o) : r.push(o);
                o = V(e, x(r, i)),
                o.selector = e
            }
            return o
        }
        ,
        N = t.select = function(e, t, n, i) {
            var r, o, s, a, l, c = "function" == typeof e && e, p = !i && T(e = c.selector || e);
            if (n = n || [],
            1 === p.length) {
                if (o = p[0] = p[0].slice(0),
                o.length > 2 && "ID" === (s = o[0]).type && w.getById && 9 === t.nodeType && D && S.relative[o[1].type]) {
                    if (t = (S.find.ID(s.matches[0].replace(be, we), t) || [])[0],
                    !t)
                        return n;
                    c && (t = t.parentNode),
                    e = e.slice(o.shift().value.length)
                }
                for (r = fe.needsContext.test(e) ? 0 : o.length; r-- && (s = o[r],
                !S.relative[a = s.type]); )
                    if ((l = S.find[a]) && (i = l(s.matches[0].replace(be, we), ye.test(o[0].type) && u(t.parentNode) || t))) {
                        if (o.splice(r, 1),
                        e = i.length && h(o),
                        !e)
                            return Q.apply(n, i),
                            n;
                        break
                    }
            }
            return (c || E(e, p))(i, t, !D, n, !t || ye.test(e) && u(t.parentNode) || t),
            n
        }
        ,
        w.sortStable = q.split("").sort(X).join("") === q,
        w.detectDuplicates = !!I,
        O(),
        w.sortDetached = r(function(e) {
            return 1 & e.compareDocumentPosition(A.createElement("div"))
        }),
        r(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function(e, t, n) {
            return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        w.attributes && r(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || o("value", function(e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
        }),
        r(function(e) {
            return null == e.getAttribute("disabled")
        }) || o(te, function(e, t, n) {
            var i;
            return n ? void 0 : e[t] === !0 ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }),
        t
    }(e);
    oe.find = ue,
    oe.expr = ue.selectors,
    oe.expr[":"] = oe.expr.pseudos,
    oe.uniqueSort = oe.unique = ue.uniqueSort,
    oe.text = ue.getText,
    oe.isXMLDoc = ue.isXML,
    oe.contains = ue.contains;
    var pe = function(e, t, n) {
        for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
            if (1 === e.nodeType) {
                if (r && oe(e).is(n))
                    break;
                i.push(e)
            }
        return i
    }
      , he = function(e, t) {
        for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
        return n
    }
      , fe = oe.expr.match.needsContext
      , de = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/
      , me = /^.[^:#\[\.,]*$/;
    oe.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType ? oe.find.matchesSelector(i, e) ? [i] : [] : oe.find.matches(e, oe.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    oe.fn.extend({
        find: function(e) {
            var t, n = this.length, i = [], r = this;
            if ("string" != typeof e)
                return this.pushStack(oe(e).filter(function() {
                    for (t = 0; n > t; t++)
                        if (oe.contains(r[t], this))
                            return !0
                }));
            for (t = 0; n > t; t++)
                oe.find(e, r[t], i);
            return i = this.pushStack(n > 1 ? oe.unique(i) : i),
            i.selector = this.selector ? this.selector + " " + e : e,
            i
        },
        filter: function(e) {
            return this.pushStack(i(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(i(this, e || [], !0))
        },
        is: function(e) {
            return !!i(this, "string" == typeof e && fe.test(e) ? oe(e) : e || [], !1).length
        }
    });
    var ve, ge = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, ye = oe.fn.init = function(e, t, n) {
        var i, r;
        if (!e)
            return this;
        if (n = n || ve,
        "string" == typeof e) {
            if (i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : ge.exec(e),
            !i || !i[1] && t)
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof oe ? t[0] : t,
                oe.merge(this, oe.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : G, !0)),
                de.test(i[1]) && oe.isPlainObject(t))
                    for (i in t)
                        oe.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            return r = G.getElementById(i[2]),
            r && r.parentNode && (this.length = 1,
            this[0] = r),
            this.context = G,
            this.selector = e,
            this
        }
        return e.nodeType ? (this.context = this[0] = e,
        this.length = 1,
        this) : oe.isFunction(e) ? void 0 !== n.ready ? n.ready(e) : e(oe) : (void 0 !== e.selector && (this.selector = e.selector,
        this.context = e.context),
        oe.makeArray(e, this))
    }
    ;
    ye.prototype = oe.fn,
    ve = oe(G);
    var xe = /^(?:parents|prev(?:Until|All))/
      , be = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    oe.fn.extend({
        has: function(e) {
            var t = oe(e, this)
              , n = t.length;
            return this.filter(function() {
                for (var e = 0; n > e; e++)
                    if (oe.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            for (var n, i = 0, r = this.length, o = [], s = fe.test(e) || "string" != typeof e ? oe(e, t || this.context) : 0; r > i; i++)
                for (n = this[i]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && oe.find.matchesSelector(n, e))) {
                        o.push(n);
                        break
                    }
            return this.pushStack(o.length > 1 ? oe.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? J.call(oe(e), this[0]) : J.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(oe.uniqueSort(oe.merge(this.get(), oe(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }),
    oe.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return pe(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return pe(e, "parentNode", n)
        },
        next: function(e) {
            return r(e, "nextSibling")
        },
        prev: function(e) {
            return r(e, "previousSibling")
        },
        nextAll: function(e) {
            return pe(e, "nextSibling")
        },
        prevAll: function(e) {
            return pe(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return pe(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return pe(e, "previousSibling", n)
        },
        siblings: function(e) {
            return he((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return he(e.firstChild)
        },
        contents: function(e) {
            return e.contentDocument || oe.merge([], e.childNodes)
        }
    }, function(e, t) {
        oe.fn[e] = function(n, i) {
            var r = oe.map(this, t, n);
            return "Until" !== e.slice(-5) && (i = n),
            i && "string" == typeof i && (r = oe.filter(i, r)),
            this.length > 1 && (be[e] || oe.uniqueSort(r),
            xe.test(e) && r.reverse()),
            this.pushStack(r)
        }
    });
    var we = /\S+/g;
    oe.Callbacks = function(e) {
        e = "string" == typeof e ? o(e) : oe.extend({}, e);
        var t, n, i, r, s = [], a = [], l = -1, c = function() {
            for (r = e.once,
            i = t = !0; a.length; l = -1)
                for (n = a.shift(); ++l < s.length; )
                    s[l].apply(n[0], n[1]) === !1 && e.stopOnFalse && (l = s.length,
                    n = !1);
            e.memory || (n = !1),
            t = !1,
            r && (s = n ? [] : "")
        }, u = {
            add: function() {
                return s && (n && !t && (l = s.length - 1,
                a.push(n)),
                function t(n) {
                    oe.each(n, function(n, i) {
                        oe.isFunction(i) ? e.unique && u.has(i) || s.push(i) : i && i.length && "string" !== oe.type(i) && t(i)
                    })
                }(arguments),
                n && !t && c()),
                this
            },
            remove: function() {
                return oe.each(arguments, function(e, t) {
                    for (var n; (n = oe.inArray(t, s, n)) > -1; )
                        s.splice(n, 1),
                        l >= n && l--
                }),
                this
            },
            has: function(e) {
                return e ? oe.inArray(e, s) > -1 : s.length > 0
            },
            empty: function() {
                return s && (s = []),
                this
            },
            disable: function() {
                return r = a = [],
                s = n = "",
                this
            },
            disabled: function() {
                return !s
            },
            lock: function() {
                return r = a = [],
                n || (s = n = ""),
                this
            },
            locked: function() {
                return !!r
            },
            fireWith: function(e, n) {
                return r || (n = n || [],
                n = [e, n.slice ? n.slice() : n],
                a.push(n),
                t || c()),
                this
            },
            fire: function() {
                return u.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!i
            }
        };
        return u
    }
    ,
    oe.extend({
        Deferred: function(e) {
            var t = [["resolve", "done", oe.Callbacks("once memory"), "resolved"], ["reject", "fail", oe.Callbacks("once memory"), "rejected"], ["notify", "progress", oe.Callbacks("memory")]]
              , n = "pending"
              , i = {
                state: function() {
                    return n
                },
                always: function() {
                    return r.done(arguments).fail(arguments),
                    this
                },
                then: function() {
                    var e = arguments;
                    return oe.Deferred(function(n) {
                        oe.each(t, function(t, o) {
                            var s = oe.isFunction(e[t]) && e[t];
                            r[o[1]](function() {
                                var e = s && s.apply(this, arguments);
                                e && oe.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === i ? n.promise() : this, s ? [e] : arguments)
                            })
                        }),
                        e = null
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? oe.extend(e, i) : i
                }
            }
              , r = {};
            return i.pipe = i.then,
            oe.each(t, function(e, o) {
                var s = o[2]
                  , a = o[3];
                i[o[1]] = s.add,
                a && s.add(function() {
                    n = a
                }, t[1 ^ e][2].disable, t[2][2].lock),
                r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? i : this, arguments),
                    this
                }
                ,
                r[o[0] + "With"] = s.fireWith
            }),
            i.promise(r),
            e && e.call(r, r),
            r
        },
        when: function(e) {
            var t, n, i, r = 0, o = Z.call(arguments), s = o.length, a = 1 !== s || e && oe.isFunction(e.promise) ? s : 0, l = 1 === a ? e : oe.Deferred(), c = function(e, n, i) {
                return function(r) {
                    n[e] = this,
                    i[e] = arguments.length > 1 ? Z.call(arguments) : r,
                    i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i)
                }
            };
            if (s > 1)
                for (t = new Array(s),
                n = new Array(s),
                i = new Array(s); s > r; r++)
                    o[r] && oe.isFunction(o[r].promise) ? o[r].promise().progress(c(r, n, t)).done(c(r, i, o)).fail(l.reject) : --a;
            return a || l.resolveWith(i, o),
            l.promise()
        }
    });
    var Se;
    oe.fn.ready = function(e) {
        return oe.ready.promise().done(e),
        this
    }
    ,
    oe.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? oe.readyWait++ : oe.ready(!0)
        },
        ready: function(e) {
            (e === !0 ? --oe.readyWait : oe.isReady) || (oe.isReady = !0,
            e !== !0 && --oe.readyWait > 0 || (Se.resolveWith(G, [oe]),
            oe.fn.triggerHandler && (oe(G).triggerHandler("ready"),
            oe(G).off("ready"))))
        }
    }),
    oe.ready.promise = function(t) {
        return Se || (Se = oe.Deferred(),
        "complete" === G.readyState || "loading" !== G.readyState && !G.documentElement.doScroll ? e.setTimeout(oe.ready) : (G.addEventListener("DOMContentLoaded", s),
        e.addEventListener("load", s))),
        Se.promise(t)
    }
    ,
    oe.ready.promise();
    var Ce = function(e, t, n, i, r, o, s) {
        var a = 0
          , l = e.length
          , c = null == n;
        if ("object" === oe.type(n)) {
            r = !0;
            for (a in n)
                Ce(e, t, a, n[a], !0, o, s)
        } else if (void 0 !== i && (r = !0,
        oe.isFunction(i) || (s = !0),
        c && (s ? (t.call(e, i),
        t = null) : (c = t,
        t = function(e, t, n) {
            return c.call(oe(e), n)
        }
        )),
        t))
            for (; l > a; a++)
                t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return r ? e : c ? t.call(e) : l ? t(e[0], n) : o
    }
      , ke = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };
    a.uid = 1,
    a.prototype = {
        register: function(e, t) {
            var n = t || {};
            return e.nodeType ? e[this.expando] = n : Object.defineProperty(e, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }),
            e[this.expando]
        },
        cache: function(e) {
            if (!ke(e))
                return {};
            var t = e[this.expando];
            return t || (t = {},
            ke(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, n) {
            var i, r = this.cache(e);
            if ("string" == typeof t)
                r[t] = n;
            else
                for (i in t)
                    r[i] = t[i];
            return r
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t]
        },
        access: function(e, t, n) {
            var i;
            return void 0 === t || t && "string" == typeof t && void 0 === n ? (i = this.get(e, t),
            void 0 !== i ? i : this.get(e, oe.camelCase(t))) : (this.set(e, t, n),
            void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i, r, o = e[this.expando];
            if (void 0 !== o) {
                if (void 0 === t)
                    this.register(e);
                else {
                    oe.isArray(t) ? i = t.concat(t.map(oe.camelCase)) : (r = oe.camelCase(t),
                    t in o ? i = [t, r] : (i = r,
                    i = i in o ? [i] : i.match(we) || [])),
                    n = i.length;
                    for (; n--; )
                        delete o[i[n]]
                }
                (void 0 === t || oe.isEmptyObject(o)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !oe.isEmptyObject(t)
        }
    };
    var Te = new a
      , Ee = new a
      , Ne = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Pe = /[A-Z]/g;
    oe.extend({
        hasData: function(e) {
            return Ee.hasData(e) || Te.hasData(e)
        },
        data: function(e, t, n) {
            return Ee.access(e, t, n)
        },
        removeData: function(e, t) {
            Ee.remove(e, t)
        },
        _data: function(e, t, n) {
            return Te.access(e, t, n)
        },
        _removeData: function(e, t) {
            Te.remove(e, t)
        }
    }),
    oe.fn.extend({
        data: function(e, t) {
            var n, i, r, o = this[0], s = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (r = Ee.get(o),
                1 === o.nodeType && !Te.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--; )
                        s[n] && (i = s[n].name,
                        0 === i.indexOf("data-") && (i = oe.camelCase(i.slice(5)),
                        l(o, i, r[i])));
                    Te.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof e ? this.each(function() {
                Ee.set(this, e)
            }) : Ce(this, function(t) {
                var n, i;
                if (o && void 0 === t) {
                    if (n = Ee.get(o, e) || Ee.get(o, e.replace(Pe, "-$&").toLowerCase()),
                    void 0 !== n)
                        return n;
                    if (i = oe.camelCase(e),
                    n = Ee.get(o, i),
                    void 0 !== n)
                        return n;
                    if (n = l(o, i, void 0),
                    void 0 !== n)
                        return n
                } else
                    i = oe.camelCase(e),
                    this.each(function() {
                        var n = Ee.get(this, i);
                        Ee.set(this, i, t),
                        e.indexOf("-") > -1 && void 0 !== n && Ee.set(this, e, t)
                    })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                Ee.remove(this, e)
            })
        }
    }),
    oe.extend({
        queue: function(e, t, n) {
            var i;
            return e ? (t = (t || "fx") + "queue",
            i = Te.get(e, t),
            n && (!i || oe.isArray(n) ? i = Te.access(e, t, oe.makeArray(n)) : i.push(n)),
            i || []) : void 0
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = oe.queue(e, t)
              , i = n.length
              , r = n.shift()
              , o = oe._queueHooks(e, t)
              , s = function() {
                oe.dequeue(e, t)
            };
            "inprogress" === r && (r = n.shift(),
            i--),
            r && ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            r.call(e, s, o)),
            !i && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return Te.get(e, n) || Te.access(e, n, {
                empty: oe.Callbacks("once memory").add(function() {
                    Te.remove(e, [t + "queue", n])
                })
            })
        }
    }),
    oe.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e,
            e = "fx",
            n--),
            arguments.length < n ? oe.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = oe.queue(this, e, t);
                oe._queueHooks(this, e),
                "fx" === e && "inprogress" !== n[0] && oe.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                oe.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, i = 1, r = oe.Deferred(), o = this, s = this.length, a = function() {
                --i || r.resolveWith(o, [o])
            };
            for ("string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx"; s--; )
                n = Te.get(o[s], e + "queueHooks"),
                n && n.empty && (i++,
                n.empty.add(a));
            return a(),
            r.promise(t)
        }
    });
    var _e = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , Ie = new RegExp("^(?:([+-])=|)(" + _e + ")([a-z%]*)$","i")
      , Oe = ["Top", "Right", "Bottom", "Left"]
      , Ae = function(e, t) {
        return e = t || e,
        "none" === oe.css(e, "display") || !oe.contains(e.ownerDocument, e)
    }
      , Le = /^(?:checkbox|radio)$/i
      , De = /<([\w:-]+)/
      , je = /^$|\/(?:java|ecma)script/i
      , Me = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    Me.optgroup = Me.option,
    Me.tbody = Me.tfoot = Me.colgroup = Me.caption = Me.thead,
    Me.th = Me.td;
    var He = /<|&#?\w+;/;
    !function() {
        var e = G.createDocumentFragment()
          , t = e.appendChild(G.createElement("div"))
          , n = G.createElement("input");
        n.setAttribute("type", "radio"),
        n.setAttribute("checked", "checked"),
        n.setAttribute("name", "t"),
        t.appendChild(n),
        ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked,
        t.innerHTML = "<textarea>x</textarea>",
        ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
    }();
    var Fe = /^key/
      , qe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , Re = /^([^.]*)(?:\.(.+)|)/;
    oe.event = {
        global: {},
        add: function(e, t, n, i, r) {
            var o, s, a, l, c, u, p, h, f, d, m, v = Te.get(e);
            if (v)
                for (n.handler && (o = n,
                n = o.handler,
                r = o.selector),
                n.guid || (n.guid = oe.guid++),
                (l = v.events) || (l = v.events = {}),
                (s = v.handle) || (s = v.handle = function(t) {
                    return "undefined" != typeof oe && oe.event.triggered !== t.type ? oe.event.dispatch.apply(e, arguments) : void 0
                }
                ),
                t = (t || "").match(we) || [""],
                c = t.length; c--; )
                    a = Re.exec(t[c]) || [],
                    f = m = a[1],
                    d = (a[2] || "").split(".").sort(),
                    f && (p = oe.event.special[f] || {},
                    f = (r ? p.delegateType : p.bindType) || f,
                    p = oe.event.special[f] || {},
                    u = oe.extend({
                        type: f,
                        origType: m,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: r,
                        needsContext: r && oe.expr.match.needsContext.test(r),
                        namespace: d.join(".")
                    }, o),
                    (h = l[f]) || (h = l[f] = [],
                    h.delegateCount = 0,
                    p.setup && p.setup.call(e, i, d, s) !== !1 || e.addEventListener && e.addEventListener(f, s)),
                    p.add && (p.add.call(e, u),
                    u.handler.guid || (u.handler.guid = n.guid)),
                    r ? h.splice(h.delegateCount++, 0, u) : h.push(u),
                    oe.event.global[f] = !0)
        },
        remove: function(e, t, n, i, r) {
            var o, s, a, l, c, u, p, h, f, d, m, v = Te.hasData(e) && Te.get(e);
            if (v && (l = v.events)) {
                for (t = (t || "").match(we) || [""],
                c = t.length; c--; )
                    if (a = Re.exec(t[c]) || [],
                    f = m = a[1],
                    d = (a[2] || "").split(".").sort(),
                    f) {
                        for (p = oe.event.special[f] || {},
                        f = (i ? p.delegateType : p.bindType) || f,
                        h = l[f] || [],
                        a = a[2] && new RegExp("(^|\\.)" + d.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        s = o = h.length; o--; )
                            u = h[o],
                            !r && m !== u.origType || n && n.guid !== u.guid || a && !a.test(u.namespace) || i && i !== u.selector && ("**" !== i || !u.selector) || (h.splice(o, 1),
                            u.selector && h.delegateCount--,
                            p.remove && p.remove.call(e, u));
                        s && !h.length && (p.teardown && p.teardown.call(e, d, v.handle) !== !1 || oe.removeEvent(e, f, v.handle),
                        delete l[f])
                    } else
                        for (f in l)
                            oe.event.remove(e, f + t[c], n, i, !0);
                oe.isEmptyObject(l) && Te.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            e = oe.event.fix(e);
            var t, n, i, r, o, s = [], a = Z.call(arguments), l = (Te.get(this, "events") || {})[e.type] || [], c = oe.event.special[e.type] || {};
            if (a[0] = e,
            e.delegateTarget = this,
            !c.preDispatch || c.preDispatch.call(this, e) !== !1) {
                for (s = oe.event.handlers.call(this, e, l),
                t = 0; (r = s[t++]) && !e.isPropagationStopped(); )
                    for (e.currentTarget = r.elem,
                    n = 0; (o = r.handlers[n++]) && !e.isImmediatePropagationStopped(); )
                        e.rnamespace && !e.rnamespace.test(o.namespace) || (e.handleObj = o,
                        e.data = o.data,
                        i = ((oe.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, a),
                        void 0 !== i && (e.result = i) === !1 && (e.preventDefault(),
                        e.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, e),
                e.result
            }
        },
        handlers: function(e, t) {
            var n, i, r, o, s = [], a = t.delegateCount, l = e.target;
            if (a && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
                        for (i = [],
                        n = 0; a > n; n++)
                            o = t[n],
                            r = o.selector + " ",
                            void 0 === i[r] && (i[r] = o.needsContext ? oe(r, this).index(l) > -1 : oe.find(r, this, null, [l]).length),
                            i[r] && i.push(o);
                        i.length && s.push({
                            elem: l,
                            handlers: i
                        })
                    }
            return a < t.length && s.push({
                elem: this,
                handlers: t.slice(a)
            }),
            s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode),
                e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var n, i, r, o = t.button;
                return null == e.pageX && null != t.clientX && (n = e.target.ownerDocument || G,
                i = n.documentElement,
                r = n.body,
                e.pageX = t.clientX + (i && i.scrollLeft || r && r.scrollLeft || 0) - (i && i.clientLeft || r && r.clientLeft || 0),
                e.pageY = t.clientY + (i && i.scrollTop || r && r.scrollTop || 0) - (i && i.clientTop || r && r.clientTop || 0)),
                e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0),
                e
            }
        },
        fix: function(e) {
            if (e[oe.expando])
                return e;
            var t, n, i, r = e.type, o = e, s = this.fixHooks[r];
            for (s || (this.fixHooks[r] = s = qe.test(r) ? this.mouseHooks : Fe.test(r) ? this.keyHooks : {}),
            i = s.props ? this.props.concat(s.props) : this.props,
            e = new oe.Event(o),
            t = i.length; t--; )
                n = i[t],
                e[n] = o[n];
            return e.target || (e.target = G),
            3 === e.target.nodeType && (e.target = e.target.parentNode),
            s.filter ? s.filter(e, o) : e
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== m() && this.focus ? (this.focus(),
                    !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === m() && this.blur ? (this.blur(),
                    !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && oe.nodeName(this, "input") ? (this.click(),
                    !1) : void 0
                },
                _default: function(e) {
                    return oe.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    oe.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }
    ,
    oe.Event = function(e, t) {
        return this instanceof oe.Event ? (e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? f : d) : this.type = e,
        t && oe.extend(this, t),
        this.timeStamp = e && e.timeStamp || oe.now(),
        void (this[oe.expando] = !0)) : new oe.Event(e,t)
    }
    ,
    oe.Event.prototype = {
        constructor: oe.Event,
        isDefaultPrevented: d,
        isPropagationStopped: d,
        isImmediatePropagationStopped: d,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = f,
            e && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = f,
            e && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = f,
            e && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    oe.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        oe.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, i = this, r = e.relatedTarget, o = e.handleObj;
                return r && (r === i || oe.contains(i, r)) || (e.type = o.origType,
                n = o.handler.apply(this, arguments),
                e.type = t),
                n
            }
        }
    }),
    oe.fn.extend({
        on: function(e, t, n, i) {
            return v(this, e, t, n, i)
        },
        one: function(e, t, n, i) {
            return v(this, e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj)
                return i = e.handleObj,
                oe(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                this;
            if ("object" == typeof e) {
                for (r in e)
                    this.off(r, t, e[r]);
                return this
            }
            return t !== !1 && "function" != typeof t || (n = t,
            t = void 0),
            n === !1 && (n = d),
            this.each(function() {
                oe.event.remove(this, e, n, t)
            })
        }
    });
    var $e = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi
      , ze = /<script|<style|<link/i
      , Be = /checked\s*(?:[^=]|=\s*.checked.)/i
      , We = /^true\/(.*)/
      , Ve = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    oe.extend({
        htmlPrefilter: function(e) {
            return e.replace($e, "<$1></$2>")
        },
        clone: function(e, t, n) {
            var i, r, o, s, a = e.cloneNode(!0), l = oe.contains(e.ownerDocument, e);
            if (!(ie.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || oe.isXMLDoc(e)))
                for (s = u(a),
                o = u(e),
                i = 0,
                r = o.length; r > i; i++)
                    w(o[i], s[i]);
            if (t)
                if (n)
                    for (o = o || u(e),
                    s = s || u(a),
                    i = 0,
                    r = o.length; r > i; i++)
                        b(o[i], s[i]);
                else
                    b(e, a);
            return s = u(a, "script"),
            s.length > 0 && p(s, !l && u(e, "script")),
            a
        },
        cleanData: function(e) {
            for (var t, n, i, r = oe.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (ke(n)) {
                    if (t = n[Te.expando]) {
                        if (t.events)
                            for (i in t.events)
                                r[i] ? oe.event.remove(n, i) : oe.removeEvent(n, i, t.handle);
                        n[Te.expando] = void 0
                    }
                    n[Ee.expando] && (n[Ee.expando] = void 0)
                }
        }
    }),
    oe.fn.extend({
        domManip: S,
        detach: function(e) {
            return C(this, e, !0)
        },
        remove: function(e) {
            return C(this, e)
        },
        text: function(e) {
            return Ce(this, function(e) {
                return void 0 === e ? oe.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return S(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = g(this, e);
                    t.appendChild(e)
                }
            })
        },
        prepend: function() {
            return S(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = g(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return S(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return S(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (oe.cleanData(u(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return oe.clone(this, e, t)
            })
        },
        html: function(e) {
            return Ce(this, function(e) {
                var t = this[0] || {}
                  , n = 0
                  , i = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !ze.test(e) && !Me[(De.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = oe.htmlPrefilter(e);
                    try {
                        for (; i > n; n++)
                            t = this[n] || {},
                            1 === t.nodeType && (oe.cleanData(u(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return S(this, arguments, function(t) {
                var n = this.parentNode;
                oe.inArray(this, e) < 0 && (oe.cleanData(u(this)),
                n && n.replaceChild(t, this))
            }, e)
        }
    }),
    oe.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        oe.fn[e] = function(e) {
            for (var n, i = [], r = oe(e), o = r.length - 1, s = 0; o >= s; s++)
                n = s === o ? this : this.clone(!0),
                oe(r[s])[t](n),
                Q.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Xe, Ue = {
        HTML: "block",
        BODY: "block"
    }, Ye = /^margin/, Ge = new RegExp("^(" + _e + ")(?!px)[a-z%]+$","i"), Ze = function(t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = e),
        n.getComputedStyle(t)
    }, Ke = function(e, t, n, i) {
        var r, o, s = {};
        for (o in t)
            s[o] = e.style[o],
            e.style[o] = t[o];
        r = n.apply(e, i || []);
        for (o in t)
            e.style[o] = s[o];
        return r
    }, Qe = G.documentElement;
    !function() {
        function t() {
            a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",
            a.innerHTML = "",
            Qe.appendChild(s);
            var t = e.getComputedStyle(a);
            n = "1%" !== t.top,
            o = "2px" === t.marginLeft,
            i = "4px" === t.width,
            a.style.marginRight = "50%",
            r = "4px" === t.marginRight,
            Qe.removeChild(s)
        }
        var n, i, r, o, s = G.createElement("div"), a = G.createElement("div");
        a.style && (a.style.backgroundClip = "content-box",
        a.cloneNode(!0).style.backgroundClip = "",
        ie.clearCloneStyle = "content-box" === a.style.backgroundClip,
        s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",
        s.appendChild(a),
        oe.extend(ie, {
            pixelPosition: function() {
                return t(),
                n
            },
            boxSizingReliable: function() {
                return null == i && t(),
                i
            },
            pixelMarginRight: function() {
                return null == i && t(),
                r
            },
            reliableMarginLeft: function() {
                return null == i && t(),
                o
            },
            reliableMarginRight: function() {
                var t, n = a.appendChild(G.createElement("div"));
                return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",
                n.style.marginRight = n.style.width = "0",
                a.style.width = "1px",
                Qe.appendChild(s),
                t = !parseFloat(e.getComputedStyle(n).marginRight),
                Qe.removeChild(s),
                a.removeChild(n),
                t
            }
        }))
    }();
    var Je = /^(none|table(?!-c[ea]).+)/
      , et = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , tt = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , nt = ["Webkit", "O", "Moz", "ms"]
      , it = G.createElement("div").style;
    oe.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = E(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, o, s, a = oe.camelCase(t), l = e.style;
                return t = oe.cssProps[a] || (oe.cssProps[a] = P(a) || a),
                s = oe.cssHooks[t] || oe.cssHooks[a],
                void 0 === n ? s && "get"in s && void 0 !== (r = s.get(e, !1, i)) ? r : l[t] : (o = typeof n,
                "string" === o && (r = Ie.exec(n)) && r[1] && (n = c(e, t, r),
                o = "number"),
                void (null != n && n === n && ("number" === o && (n += r && r[3] || (oe.cssNumber[a] ? "" : "px")),
                ie.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                s && "set"in s && void 0 === (n = s.set(e, n, i)) || (l[t] = n))))
            }
        },
        css: function(e, t, n, i) {
            var r, o, s, a = oe.camelCase(t);
            return t = oe.cssProps[a] || (oe.cssProps[a] = P(a) || a),
            s = oe.cssHooks[t] || oe.cssHooks[a],
            s && "get"in s && (r = s.get(e, !0, n)),
            void 0 === r && (r = E(e, t, i)),
            "normal" === r && t in tt && (r = tt[t]),
            "" === n || n ? (o = parseFloat(r),
            n === !0 || isFinite(o) ? o || 0 : r) : r
        }
    }),
    oe.each(["height", "width"], function(e, t) {
        oe.cssHooks[t] = {
            get: function(e, n, i) {
                return n ? Je.test(oe.css(e, "display")) && 0 === e.offsetWidth ? Ke(e, et, function() {
                    return O(e, t, i)
                }) : O(e, t, i) : void 0
            },
            set: function(e, n, i) {
                var r, o = i && Ze(e), s = i && I(e, t, i, "border-box" === oe.css(e, "boxSizing", !1, o), o);
                return s && (r = Ie.exec(n)) && "px" !== (r[3] || "px") && (e.style[t] = n,
                n = oe.css(e, t)),
                _(e, n, s)
            }
        }
    }),
    oe.cssHooks.marginLeft = N(ie.reliableMarginLeft, function(e, t) {
        return t ? (parseFloat(E(e, "marginLeft")) || e.getBoundingClientRect().left - Ke(e, {
            marginLeft: 0
        }, function() {
            return e.getBoundingClientRect().left
        })) + "px" : void 0
    }),
    oe.cssHooks.marginRight = N(ie.reliableMarginRight, function(e, t) {
        return t ? Ke(e, {
            display: "inline-block"
        }, E, [e, "marginRight"]) : void 0
    }),
    oe.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        oe.cssHooks[e + t] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++)
                    r[e + Oe[i] + t] = o[i] || o[i - 2] || o[0];
                return r
            }
        },
        Ye.test(e) || (oe.cssHooks[e + t].set = _)
    }),
    oe.fn.extend({
        css: function(e, t) {
            return Ce(this, function(e, t, n) {
                var i, r, o = {}, s = 0;
                if (oe.isArray(t)) {
                    for (i = Ze(e),
                    r = t.length; r > s; s++)
                        o[t[s]] = oe.css(e, t[s], !1, i);
                    return o
                }
                return void 0 !== n ? oe.style(e, t, n) : oe.css(e, t)
            }, e, t, arguments.length > 1)
        },
        show: function() {
            return A(this, !0)
        },
        hide: function() {
            return A(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Ae(this) ? oe(this).show() : oe(this).hide()
            })
        }
    }),
    oe.Tween = L,
    L.prototype = {
        constructor: L,
        init: function(e, t, n, i, r, o) {
            this.elem = e,
            this.prop = n,
            this.easing = r || oe.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = i,
            this.unit = o || (oe.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = L.propHooks[this.prop];
            return e && e.get ? e.get(this) : L.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = L.propHooks[this.prop];
            return this.options.duration ? this.pos = t = oe.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : L.propHooks._default.set(this),
            this
        }
    },
    L.prototype.init.prototype = L.prototype,
    L.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = oe.css(e.elem, e.prop, ""),
                t && "auto" !== t ? t : 0)
            },
            set: function(e) {
                oe.fx.step[e.prop] ? oe.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[oe.cssProps[e.prop]] && !oe.cssHooks[e.prop] ? e.elem[e.prop] = e.now : oe.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    },
    L.propHooks.scrollTop = L.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    oe.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    oe.fx = L.prototype.init,
    oe.fx.step = {};
    var rt, ot, st = /^(?:toggle|show|hide)$/, at = /queueHooks$/;
    oe.Animation = oe.extend(q, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return c(n.elem, e, Ie.exec(t), n),
                n
            }
            ]
        },
        tweener: function(e, t) {
            oe.isFunction(e) ? (t = e,
            e = ["*"]) : e = e.match(we);
            for (var n, i = 0, r = e.length; r > i; i++)
                n = e[i],
                q.tweeners[n] = q.tweeners[n] || [],
                q.tweeners[n].unshift(t)
        },
        prefilters: [H],
        prefilter: function(e, t) {
            t ? q.prefilters.unshift(e) : q.prefilters.push(e)
        }
    }),
    oe.speed = function(e, t, n) {
        var i = e && "object" == typeof e ? oe.extend({}, e) : {
            complete: n || !n && t || oe.isFunction(e) && e,
            duration: e,
            easing: n && t || t && !oe.isFunction(t) && t
        };
        return i.duration = oe.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in oe.fx.speeds ? oe.fx.speeds[i.duration] : oe.fx.speeds._default,
        null != i.queue && i.queue !== !0 || (i.queue = "fx"),
        i.old = i.complete,
        i.complete = function() {
            oe.isFunction(i.old) && i.old.call(this),
            i.queue && oe.dequeue(this, i.queue)
        }
        ,
        i
    }
    ,
    oe.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(Ae).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i)
        },
        animate: function(e, t, n, i) {
            var r = oe.isEmptyObject(e)
              , o = oe.speed(t, n, i)
              , s = function() {
                var t = q(this, oe.extend({}, e), o);
                (r || Te.get(this, "finish")) && t.stop(!0)
            };
            return s.finish = s,
            r || o.queue === !1 ? this.each(s) : this.queue(o.queue, s)
        },
        stop: function(e, t, n) {
            var i = function(e) {
                var t = e.stop;
                delete e.stop,
                t(n)
            };
            return "string" != typeof e && (n = t,
            t = e,
            e = void 0),
            t && e !== !1 && this.queue(e || "fx", []),
            this.each(function() {
                var t = !0
                  , r = null != e && e + "queueHooks"
                  , o = oe.timers
                  , s = Te.get(this);
                if (r)
                    s[r] && s[r].stop && i(s[r]);
                else
                    for (r in s)
                        s[r] && s[r].stop && at.test(r) && i(s[r]);
                for (r = o.length; r--; )
                    o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(n),
                    t = !1,
                    o.splice(r, 1));
                !t && n || oe.dequeue(this, e)
            })
        },
        finish: function(e) {
            return e !== !1 && (e = e || "fx"),
            this.each(function() {
                var t, n = Te.get(this), i = n[e + "queue"], r = n[e + "queueHooks"], o = oe.timers, s = i ? i.length : 0;
                for (n.finish = !0,
                oe.queue(this, e, []),
                r && r.stop && r.stop.call(this, !0),
                t = o.length; t--; )
                    o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0),
                    o.splice(t, 1));
                for (t = 0; s > t; t++)
                    i[t] && i[t].finish && i[t].finish.call(this);
                delete n.finish
            })
        }
    }),
    oe.each(["toggle", "show", "hide"], function(e, t) {
        var n = oe.fn[t];
        oe.fn[t] = function(e, i, r) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(j(t, !0), e, i, r)
        }
    }),
    oe.each({
        slideDown: j("show"),
        slideUp: j("hide"),
        slideToggle: j("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        oe.fn[e] = function(e, n, i) {
            return this.animate(t, e, n, i)
        }
    }),
    oe.timers = [],
    oe.fx.tick = function() {
        var e, t = 0, n = oe.timers;
        for (rt = oe.now(); t < n.length; t++)
            e = n[t],
            e() || n[t] !== e || n.splice(t--, 1);
        n.length || oe.fx.stop(),
        rt = void 0
    }
    ,
    oe.fx.timer = function(e) {
        oe.timers.push(e),
        e() ? oe.fx.start() : oe.timers.pop()
    }
    ,
    oe.fx.interval = 13,
    oe.fx.start = function() {
        ot || (ot = e.setInterval(oe.fx.tick, oe.fx.interval))
    }
    ,
    oe.fx.stop = function() {
        e.clearInterval(ot),
        ot = null
    }
    ,
    oe.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    oe.fn.delay = function(t, n) {
        return t = oe.fx ? oe.fx.speeds[t] || t : t,
        n = n || "fx",
        this.queue(n, function(n, i) {
            var r = e.setTimeout(n, t);
            i.stop = function() {
                e.clearTimeout(r)
            }
        })
    }
    ,
    function() {
        var e = G.createElement("input")
          , t = G.createElement("select")
          , n = t.appendChild(G.createElement("option"));
        e.type = "checkbox",
        ie.checkOn = "" !== e.value,
        ie.optSelected = n.selected,
        t.disabled = !0,
        ie.optDisabled = !n.disabled,
        e = G.createElement("input"),
        e.value = "t",
        e.type = "radio",
        ie.radioValue = "t" === e.value
    }();
    var lt, ct = oe.expr.attrHandle;
    oe.fn.extend({
        attr: function(e, t) {
            return Ce(this, oe.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                oe.removeAttr(this, e)
            })
        }
    }),
    oe.extend({
        attr: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return "undefined" == typeof e.getAttribute ? oe.prop(e, t, n) : (1 === o && oe.isXMLDoc(e) || (t = t.toLowerCase(),
                r = oe.attrHooks[t] || (oe.expr.match.bool.test(t) ? lt : void 0)),
                void 0 !== n ? null === n ? void oe.removeAttr(e, t) : r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""),
                n) : r && "get"in r && null !== (i = r.get(e, t)) ? i : (i = oe.find.attr(e, t),
                null == i ? void 0 : i))
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!ie.radioValue && "radio" === t && oe.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t),
                        n && (e.value = n),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, i, r = 0, o = t && t.match(we);
            if (o && 1 === e.nodeType)
                for (; n = o[r++]; )
                    i = oe.propFix[n] || n,
                    oe.expr.match.bool.test(n) && (e[i] = !1),
                    e.removeAttribute(n)
        }
    }),
    lt = {
        set: function(e, t, n) {
            return t === !1 ? oe.removeAttr(e, n) : e.setAttribute(n, n),
            n
        }
    },
    oe.each(oe.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = ct[t] || oe.find.attr;
        ct[t] = function(e, t, i) {
            var r, o;
            return i || (o = ct[t],
            ct[t] = r,
            r = null != n(e, t, i) ? t.toLowerCase() : null,
            ct[t] = o),
            r
        }
    });
    var ut = /^(?:input|select|textarea|button)$/i
      , pt = /^(?:a|area)$/i;
    oe.fn.extend({
        prop: function(e, t) {
            return Ce(this, oe.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[oe.propFix[e] || e]
            })
        }
    }),
    oe.extend({
        prop: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && oe.isXMLDoc(e) || (t = oe.propFix[t] || t,
                r = oe.propHooks[t]),
                void 0 !== n ? r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get"in r && null !== (i = r.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = oe.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : ut.test(e.nodeName) || pt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    ie.optSelected || (oe.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex,
            t.parentNode && t.parentNode.selectedIndex)
        }
    }),
    oe.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        oe.propFix[this.toLowerCase()] = this
    });
    var ht = /[\t\r\n\f]/g;
    oe.fn.extend({
        addClass: function(e) {
            var t, n, i, r, o, s, a, l = 0;
            if (oe.isFunction(e))
                return this.each(function(t) {
                    oe(this).addClass(e.call(this, t, R(this)))
                });
            if ("string" == typeof e && e)
                for (t = e.match(we) || []; n = this[l++]; )
                    if (r = R(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(ht, " ")) {
                        for (s = 0; o = t[s++]; )
                            i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                        a = oe.trim(i),
                        r !== a && n.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(e) {
            var t, n, i, r, o, s, a, l = 0;
            if (oe.isFunction(e))
                return this.each(function(t) {
                    oe(this).removeClass(e.call(this, t, R(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ("string" == typeof e && e)
                for (t = e.match(we) || []; n = this[l++]; )
                    if (r = R(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(ht, " ")) {
                        for (s = 0; o = t[s++]; )
                            for (; i.indexOf(" " + o + " ") > -1; )
                                i = i.replace(" " + o + " ", " ");
                        a = oe.trim(i),
                        r !== a && n.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : oe.isFunction(e) ? this.each(function(n) {
                oe(this).toggleClass(e.call(this, n, R(this), t), t)
            }) : this.each(function() {
                var t, i, r, o;
                if ("string" === n)
                    for (i = 0,
                    r = oe(this),
                    o = e.match(we) || []; t = o[i++]; )
                        r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                else
                    void 0 !== e && "boolean" !== n || (t = R(this),
                    t && Te.set(this, "__className__", t),
                    this.setAttribute && this.setAttribute("class", t || e === !1 ? "" : Te.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, i = 0;
            for (t = " " + e + " "; n = this[i++]; )
                if (1 === n.nodeType && (" " + R(n) + " ").replace(ht, " ").indexOf(t) > -1)
                    return !0;
            return !1
        }
    });
    var ft = /\r/g
      , dt = /[\x20\t\r\n\f]+/g;
    oe.fn.extend({
        val: function(e) {
            var t, n, i, r = this[0];
            return arguments.length ? (i = oe.isFunction(e),
            this.each(function(n) {
                var r;
                1 === this.nodeType && (r = i ? e.call(this, n, oe(this).val()) : e,
                null == r ? r = "" : "number" == typeof r ? r += "" : oe.isArray(r) && (r = oe.map(r, function(e) {
                    return null == e ? "" : e + ""
                })),
                t = oe.valHooks[this.type] || oe.valHooks[this.nodeName.toLowerCase()],
                t && "set"in t && void 0 !== t.set(this, r, "value") || (this.value = r))
            })) : r ? (t = oe.valHooks[r.type] || oe.valHooks[r.nodeName.toLowerCase()],
            t && "get"in t && void 0 !== (n = t.get(r, "value")) ? n : (n = r.value,
            "string" == typeof n ? n.replace(ft, "") : null == n ? "" : n)) : void 0
        }
    }),
    oe.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = oe.find.attr(e, "value");
                    return null != t ? t : oe.trim(oe.text(e)).replace(dt, " ")
                }
            },
            select: {
                get: function(e) {
                    for (var t, n, i = e.options, r = e.selectedIndex, o = "select-one" === e.type || 0 > r, s = o ? null : [], a = o ? r + 1 : i.length, l = 0 > r ? a : o ? r : 0; a > l; l++)
                        if (n = i[l],
                        (n.selected || l === r) && (ie.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !oe.nodeName(n.parentNode, "optgroup"))) {
                            if (t = oe(n).val(),
                            o)
                                return t;
                            s.push(t)
                        }
                    return s
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, o = oe.makeArray(t), s = r.length; s--; )
                        i = r[s],
                        (i.selected = oe.inArray(oe.valHooks.option.get(i), o) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    oe.each(["radio", "checkbox"], function() {
        oe.valHooks[this] = {
            set: function(e, t) {
                return oe.isArray(t) ? e.checked = oe.inArray(oe(e).val(), t) > -1 : void 0
            }
        },
        ie.checkOn || (oe.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    });
    var mt = /^(?:focusinfocus|focusoutblur)$/;
    oe.extend(oe.event, {
        trigger: function(t, n, i, r) {
            var o, s, a, l, c, u, p, h = [i || G], f = ne.call(t, "type") ? t.type : t, d = ne.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = a = i = i || G,
            3 !== i.nodeType && 8 !== i.nodeType && !mt.test(f + oe.event.triggered) && (f.indexOf(".") > -1 && (d = f.split("."),
            f = d.shift(),
            d.sort()),
            c = f.indexOf(":") < 0 && "on" + f,
            t = t[oe.expando] ? t : new oe.Event(f,"object" == typeof t && t),
            t.isTrigger = r ? 2 : 3,
            t.namespace = d.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + d.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = i),
            n = null == n ? [t] : oe.makeArray(n, [t]),
            p = oe.event.special[f] || {},
            r || !p.trigger || p.trigger.apply(i, n) !== !1)) {
                if (!r && !p.noBubble && !oe.isWindow(i)) {
                    for (l = p.delegateType || f,
                    mt.test(l + f) || (s = s.parentNode); s; s = s.parentNode)
                        h.push(s),
                        a = s;
                    a === (i.ownerDocument || G) && h.push(a.defaultView || a.parentWindow || e)
                }
                for (o = 0; (s = h[o++]) && !t.isPropagationStopped(); )
                    t.type = o > 1 ? l : p.bindType || f,
                    u = (Te.get(s, "events") || {})[t.type] && Te.get(s, "handle"),
                    u && u.apply(s, n),
                    u = c && s[c],
                    u && u.apply && ke(s) && (t.result = u.apply(s, n),
                    t.result === !1 && t.preventDefault());
                return t.type = f,
                r || t.isDefaultPrevented() || p._default && p._default.apply(h.pop(), n) !== !1 || !ke(i) || c && oe.isFunction(i[f]) && !oe.isWindow(i) && (a = i[c],
                a && (i[c] = null),
                oe.event.triggered = f,
                i[f](),
                oe.event.triggered = void 0,
                a && (i[c] = a)),
                t.result
            }
        },
        simulate: function(e, t, n) {
            var i = oe.extend(new oe.Event, n, {
                type: e,
                isSimulated: !0
            });
            oe.event.trigger(i, null, t),
            i.isDefaultPrevented() && n.preventDefault()
        }
    }),
    oe.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                oe.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            return n ? oe.event.trigger(e, t, n, !0) : void 0
        }
    }),
    oe.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
        oe.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }),
    oe.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    ie.focusin = "onfocusin"in e,
    ie.focusin || oe.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            oe.event.simulate(t, e.target, oe.event.fix(e))
        };
        oe.event.special[t] = {
            setup: function() {
                var i = this.ownerDocument || this
                  , r = Te.access(i, t);
                r || i.addEventListener(e, n, !0),
                Te.access(i, t, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this
                  , r = Te.access(i, t) - 1;
                r ? Te.access(i, t, r) : (i.removeEventListener(e, n, !0),
                Te.remove(i, t))
            }
        }
    });
    var vt = e.location
      , gt = oe.now()
      , yt = /\?/;
    oe.parseJSON = function(e) {
        return JSON.parse(e + "")
    }
    ,
    oe.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t)
            return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || oe.error("Invalid XML: " + t),
        n
    }
    ;
    var xt = /#.*$/
      , bt = /([?&])_=[^&]*/
      , wt = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , St = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , Ct = /^(?:GET|HEAD)$/
      , kt = /^\/\//
      , Tt = {}
      , Et = {}
      , Nt = "*/".concat("*")
      , Pt = G.createElement("a");
    Pt.href = vt.href,
    oe.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: vt.href,
            type: "GET",
            isLocal: St.test(vt.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Nt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": oe.parseJSON,
                "text xml": oe.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? B(B(e, oe.ajaxSettings), t) : B(oe.ajaxSettings, e)
        },
        ajaxPrefilter: $(Tt),
        ajaxTransport: $(Et),
        ajax: function(t, n) {
            function i(t, n, i, a) {
                var c, p, y, x, w, C = n;
                2 !== b && (b = 2,
                l && e.clearTimeout(l),
                r = void 0,
                s = a || "",
                S.readyState = t > 0 ? 4 : 0,
                c = t >= 200 && 300 > t || 304 === t,
                i && (x = W(h, S, i)),
                x = V(h, x, S, c),
                c ? (h.ifModified && (w = S.getResponseHeader("Last-Modified"),
                w && (oe.lastModified[o] = w),
                w = S.getResponseHeader("etag"),
                w && (oe.etag[o] = w)),
                204 === t || "HEAD" === h.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = x.state,
                p = x.data,
                y = x.error,
                c = !y)) : (y = C,
                !t && C || (C = "error",
                0 > t && (t = 0))),
                S.status = t,
                S.statusText = (n || C) + "",
                c ? m.resolveWith(f, [p, C, S]) : m.rejectWith(f, [S, C, y]),
                S.statusCode(g),
                g = void 0,
                u && d.trigger(c ? "ajaxSuccess" : "ajaxError", [S, h, c ? p : y]),
                v.fireWith(f, [S, C]),
                u && (d.trigger("ajaxComplete", [S, h]),
                --oe.active || oe.event.trigger("ajaxStop")))
            }
            "object" == typeof t && (n = t,
            t = void 0),
            n = n || {};
            var r, o, s, a, l, c, u, p, h = oe.ajaxSetup({}, n), f = h.context || h, d = h.context && (f.nodeType || f.jquery) ? oe(f) : oe.event, m = oe.Deferred(), v = oe.Callbacks("once memory"), g = h.statusCode || {}, y = {}, x = {}, b = 0, w = "canceled", S = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (2 === b) {
                        if (!a)
                            for (a = {}; t = wt.exec(s); )
                                a[t[1].toLowerCase()] = t[2];
                        t = a[e.toLowerCase()]
                    }
                    return null == t ? null : t
                },
                getAllResponseHeaders: function() {
                    return 2 === b ? s : null
                },
                setRequestHeader: function(e, t) {
                    var n = e.toLowerCase();
                    return b || (e = x[n] = x[n] || e,
                    y[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return b || (h.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    var t;
                    if (e)
                        if (2 > b)
                            for (t in e)
                                g[t] = [g[t], e[t]];
                        else
                            S.always(e[S.status]);
                    return this
                },
                abort: function(e) {
                    var t = e || w;
                    return r && r.abort(t),
                    i(0, t),
                    this
                }
            };
            if (m.promise(S).complete = v.add,
            S.success = S.done,
            S.error = S.fail,
            h.url = ((t || h.url || vt.href) + "").replace(xt, "").replace(kt, vt.protocol + "//"),
            h.type = n.method || n.type || h.method || h.type,
            h.dataTypes = oe.trim(h.dataType || "*").toLowerCase().match(we) || [""],
            null == h.crossDomain) {
                c = G.createElement("a");
                try {
                    c.href = h.url,
                    c.href = c.href,
                    h.crossDomain = Pt.protocol + "//" + Pt.host != c.protocol + "//" + c.host
                } catch (e) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = oe.param(h.data, h.traditional)),
            z(Tt, h, n, S),
            2 === b)
                return S;
            u = oe.event && h.global,
            u && 0 === oe.active++ && oe.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !Ct.test(h.type),
            o = h.url,
            h.hasContent || (h.data && (o = h.url += (yt.test(o) ? "&" : "?") + h.data,
            delete h.data),
            h.cache === !1 && (h.url = bt.test(o) ? o.replace(bt, "$1_=" + gt++) : o + (yt.test(o) ? "&" : "?") + "_=" + gt++)),
            h.ifModified && (oe.lastModified[o] && S.setRequestHeader("If-Modified-Since", oe.lastModified[o]),
            oe.etag[o] && S.setRequestHeader("If-None-Match", oe.etag[o])),
            (h.data && h.hasContent && h.contentType !== !1 || n.contentType) && S.setRequestHeader("Content-Type", h.contentType),
            S.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Nt + "; q=0.01" : "") : h.accepts["*"]);
            for (p in h.headers)
                S.setRequestHeader(p, h.headers[p]);
            if (h.beforeSend && (h.beforeSend.call(f, S, h) === !1 || 2 === b))
                return S.abort();
            w = "abort";
            for (p in {
                success: 1,
                error: 1,
                complete: 1
            })
                S[p](h[p]);
            if (r = z(Et, h, n, S)) {
                if (S.readyState = 1,
                u && d.trigger("ajaxSend", [S, h]),
                2 === b)
                    return S;
                h.async && h.timeout > 0 && (l = e.setTimeout(function() {
                    S.abort("timeout")
                }, h.timeout));
                try {
                    b = 1,
                    r.send(y, i)
                } catch (e) {
                    if (!(2 > b))
                        throw e;
                    i(-1, e)
                }
            } else
                i(-1, "No Transport");
            return S
        },
        getJSON: function(e, t, n) {
            return oe.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return oe.get(e, void 0, t, "script")
        }
    }),
    oe.each(["get", "post"], function(e, t) {
        oe[t] = function(e, n, i, r) {
            return oe.isFunction(n) && (r = r || i,
            i = n,
            n = void 0),
            oe.ajax(oe.extend({
                url: e,
                type: t,
                dataType: r,
                data: n,
                success: i
            }, oe.isPlainObject(e) && e))
        }
    }),
    oe._evalUrl = function(e) {
        return oe.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }
    ,
    oe.fn.extend({
        wrapAll: function(e) {
            var t;
            return oe.isFunction(e) ? this.each(function(t) {
                oe(this).wrapAll(e.call(this, t))
            }) : (this[0] && (t = oe(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && t.insertBefore(this[0]),
            t.map(function() {
                for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this)
        },
        wrapInner: function(e) {
            return oe.isFunction(e) ? this.each(function(t) {
                oe(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = oe(this)
                  , n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = oe.isFunction(e);
            return this.each(function(n) {
                oe(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                oe.nodeName(this, "body") || oe(this).replaceWith(this.childNodes)
            }).end()
        }
    }),
    oe.expr.filters.hidden = function(e) {
        return !oe.expr.filters.visible(e)
    }
    ,
    oe.expr.filters.visible = function(e) {
        return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0
    }
    ;
    var _t = /%20/g
      , It = /\[\]$/
      , Ot = /\r?\n/g
      , At = /^(?:submit|button|image|reset|file)$/i
      , Lt = /^(?:input|select|textarea|keygen)/i;
    oe.param = function(e, t) {
        var n, i = [], r = function(e, t) {
            t = oe.isFunction(t) ? t() : null == t ? "" : t,
            i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
        };
        if (void 0 === t && (t = oe.ajaxSettings && oe.ajaxSettings.traditional),
        oe.isArray(e) || e.jquery && !oe.isPlainObject(e))
            oe.each(e, function() {
                r(this.name, this.value)
            });
        else
            for (n in e)
                X(n, e[n], t, r);
        return i.join("&").replace(_t, "+")
    }
    ,
    oe.fn.extend({
        serialize: function() {
            return oe.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = oe.prop(this, "elements");
                return e ? oe.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !oe(this).is(":disabled") && Lt.test(this.nodeName) && !At.test(e) && (this.checked || !Le.test(e))
            }).map(function(e, t) {
                var n = oe(this).val();
                return null == n ? null : oe.isArray(n) ? oe.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Ot, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Ot, "\r\n")
                }
            }).get()
        }
    }),
    oe.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Dt = {
        0: 200,
        1223: 204
    }
      , jt = oe.ajaxSettings.xhr();
    ie.cors = !!jt && "withCredentials"in jt,
    ie.ajax = jt = !!jt,
    oe.ajaxTransport(function(t) {
        var n, i;
        return ie.cors || jt && !t.crossDomain ? {
            send: function(r, o) {
                var s, a = t.xhr();
                if (a.open(t.type, t.url, t.async, t.username, t.password),
                t.xhrFields)
                    for (s in t.xhrFields)
                        a[s] = t.xhrFields[s];
                t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType),
                t.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest");
                for (s in r)
                    a.setRequestHeader(s, r[s]);
                n = function(e) {
                    return function() {
                        n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null,
                        "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Dt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }
                ,
                a.onload = n(),
                i = a.onerror = n("error"),
                void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                    4 === a.readyState && e.setTimeout(function() {
                        n && i()
                    })
                }
                ,
                n = n("abort");
                try {
                    a.send(t.hasContent && t.data || null)
                } catch (e) {
                    if (n)
                        throw e
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }),
    oe.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return oe.globalEval(e),
                e
            }
        }
    }),
    oe.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    oe.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function(i, r) {
                    t = oe("<script>").prop({
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(),
                        n = null,
                        e && r("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    G.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var Mt = []
      , Ht = /(=)\?(?=&|$)|\?\?/;
    oe.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Mt.pop() || oe.expando + "_" + gt++;
            return this[e] = !0,
            e
        }
    }),
    oe.ajaxPrefilter("json jsonp", function(t, n, i) {
        var r, o, s, a = t.jsonp !== !1 && (Ht.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Ht.test(t.data) && "data");
        return a || "jsonp" === t.dataTypes[0] ? (r = t.jsonpCallback = oe.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
        a ? t[a] = t[a].replace(Ht, "$1" + r) : t.jsonp !== !1 && (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + r),
        t.converters["script json"] = function() {
            return s || oe.error(r + " was not called"),
            s[0]
        }
        ,
        t.dataTypes[0] = "json",
        o = e[r],
        e[r] = function() {
            s = arguments
        }
        ,
        i.always(function() {
            void 0 === o ? oe(e).removeProp(r) : e[r] = o,
            t[r] && (t.jsonpCallback = n.jsonpCallback,
            Mt.push(r)),
            s && oe.isFunction(o) && o(s[0]),
            s = o = void 0
        }),
        "script") : void 0
    }),
    oe.parseHTML = function(e, t, n) {
        if (!e || "string" != typeof e)
            return null;
        "boolean" == typeof t && (n = t,
        t = !1),
        t = t || G;
        var i = de.exec(e)
          , r = !n && [];
        return i ? [t.createElement(i[1])] : (i = h([e], t, r),
        r && r.length && oe(r).remove(),
        oe.merge([], i.childNodes))
    }
    ;
    var Ft = oe.fn.load;
    oe.fn.load = function(e, t, n) {
        if ("string" != typeof e && Ft)
            return Ft.apply(this, arguments);
        var i, r, o, s = this, a = e.indexOf(" ");
        return a > -1 && (i = oe.trim(e.slice(a)),
        e = e.slice(0, a)),
        oe.isFunction(t) ? (n = t,
        t = void 0) : t && "object" == typeof t && (r = "POST"),
        s.length > 0 && oe.ajax({
            url: e,
            type: r || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments,
            s.html(i ? oe("<div>").append(oe.parseHTML(e)).find(i) : e)
        }).always(n && function(e, t) {
            s.each(function() {
                n.apply(this, o || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    oe.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        oe.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    oe.expr.filters.animated = function(e) {
        return oe.grep(oe.timers, function(t) {
            return e === t.elem
        }).length
    }
    ,
    oe.offset = {
        setOffset: function(e, t, n) {
            var i, r, o, s, a, l, c, u = oe.css(e, "position"), p = oe(e), h = {};
            "static" === u && (e.style.position = "relative"),
            a = p.offset(),
            o = oe.css(e, "top"),
            l = oe.css(e, "left"),
            c = ("absolute" === u || "fixed" === u) && (o + l).indexOf("auto") > -1,
            c ? (i = p.position(),
            s = i.top,
            r = i.left) : (s = parseFloat(o) || 0,
            r = parseFloat(l) || 0),
            oe.isFunction(t) && (t = t.call(e, n, oe.extend({}, a))),
            null != t.top && (h.top = t.top - a.top + s),
            null != t.left && (h.left = t.left - a.left + r),
            "using"in t ? t.using.call(e, h) : p.css(h)
        }
    },
    oe.fn.extend({
        offset: function(e) {
            if (arguments.length)
                return void 0 === e ? this : this.each(function(t) {
                    oe.offset.setOffset(this, e, t)
                });
            var t, n, i = this[0], r = {
                top: 0,
                left: 0
            }, o = i && i.ownerDocument;
            return o ? (t = o.documentElement,
            oe.contains(t, i) ? (r = i.getBoundingClientRect(),
            n = U(o),
            {
                top: r.top + n.pageYOffset - t.clientTop,
                left: r.left + n.pageXOffset - t.clientLeft
            }) : r) : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n = this[0], i = {
                    top: 0,
                    left: 0
                };
                return "fixed" === oe.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(),
                t = this.offset(),
                oe.nodeName(e[0], "html") || (i = e.offset()),
                i.top += oe.css(e[0], "borderTopWidth", !0),
                i.left += oe.css(e[0], "borderLeftWidth", !0)),
                {
                    top: t.top - i.top - oe.css(n, "marginTop", !0),
                    left: t.left - i.left - oe.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === oe.css(e, "position"); )
                    e = e.offsetParent;
                return e || Qe
            })
        }
    }),
    oe.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = "pageYOffset" === t;
        oe.fn[e] = function(i) {
            return Ce(this, function(e, i, r) {
                var o = U(e);
                return void 0 === r ? o ? o[t] : e[i] : void (o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : e[i] = r)
            }, e, i, arguments.length)
        }
    }),
    oe.each(["top", "left"], function(e, t) {
        oe.cssHooks[t] = N(ie.pixelPosition, function(e, n) {
            return n ? (n = E(e, t),
            Ge.test(n) ? oe(e).position()[t] + "px" : n) : void 0
        })
    }),
    oe.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        oe.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, i) {
            oe.fn[i] = function(i, r) {
                var o = arguments.length && (n || "boolean" != typeof i)
                  , s = n || (i === !0 || r === !0 ? "margin" : "border");
                return Ce(this, function(t, n, i) {
                    var r;
                    return oe.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement,
                    Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === i ? oe.css(t, n, s) : oe.style(t, n, i, s)
                }, t, o ? i : void 0, o, null)
            }
        })
    }),
    oe.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        },
        size: function() {
            return this.length
        }
    }),
    oe.fn.andSelf = oe.fn.addBack,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return oe
    });
    var qt = e.jQuery
      , Rt = e.$;
    return oe.noConflict = function(t) {
        return e.$ === oe && (e.$ = Rt),
        t && e.jQuery === oe && (e.jQuery = qt),
        oe
    }
    ,
    t || (e.jQuery = e.$ = oe),
    oe
}),
/*!
 * jquery.flexslider.min.js
 */
/*
 * jQuery FlexSlider v2.6.3
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function(e) {
    var t = !0;
    e.flexslider = function(n, i) {
        var r = e(n);
        r.vars = e.extend({}, e.flexslider.defaults, i);
        var o, s = r.vars.namespace, a = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, l = ("ontouchstart"in window || a || window.DocumentTouch && document instanceof DocumentTouch) && r.vars.touch, c = "click touchend MSPointerUp keyup", u = "", p = "vertical" === r.vars.direction, h = r.vars.reverse, f = r.vars.itemWidth > 0, d = "fade" === r.vars.animation, m = "" !== r.vars.asNavFor, v = {};
        e.data(n, "flexslider", r),
        v = {
            init: function() {
                r.animating = !1,
                r.currentSlide = parseInt(r.vars.startAt ? r.vars.startAt : 0, 10),
                isNaN(r.currentSlide) && (r.currentSlide = 0),
                r.animatingTo = r.currentSlide,
                r.atEnd = 0 === r.currentSlide || r.currentSlide === r.last,
                r.containerSelector = r.vars.selector.substr(0, r.vars.selector.search(" ")),
                r.slides = e(r.vars.selector, r),
                r.container = e(r.containerSelector, r),
                r.count = r.slides.length,
                r.syncExists = e(r.vars.sync).length > 0,
                "slide" === r.vars.animation && (r.vars.animation = "swing"),
                r.prop = p ? "top" : "marginLeft",
                r.args = {},
                r.manualPause = !1,
                r.stopped = !1,
                r.started = !1,
                r.startTimeout = null,
                r.transitions = !r.vars.video && !d && r.vars.useCSS && function() {
                    var e = document.createElement("div")
                      , t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                    for (var n in t)
                        if (void 0 !== e.style[t[n]])
                            return r.pfx = t[n].replace("Perspective", "").toLowerCase(),
                            r.prop = "-" + r.pfx + "-transform",
                            !0;
                    return !1
                }(),
                r.ensureAnimationEnd = "",
                "" !== r.vars.controlsContainer && (r.controlsContainer = e(r.vars.controlsContainer).length > 0 && e(r.vars.controlsContainer)),
                "" !== r.vars.manualControls && (r.manualControls = e(r.vars.manualControls).length > 0 && e(r.vars.manualControls)),
                "" !== r.vars.customDirectionNav && (r.customDirectionNav = 2 === e(r.vars.customDirectionNav).length && e(r.vars.customDirectionNav)),
                r.vars.randomize && (r.slides.sort(function() {
                    return Math.round(Math.random()) - .5
                }),
                r.container.empty().append(r.slides)),
                r.doMath(),
                r.setup("init"),
                r.vars.controlNav && v.controlNav.setup(),
                r.vars.directionNav && v.directionNav.setup(),
                r.vars.keyboard && (1 === e(r.containerSelector).length || r.vars.multipleKeyboard) && e(document).bind("keyup", function(e) {
                    var t = e.keyCode;
                    if (!r.animating && (39 === t || 37 === t)) {
                        var n = 39 === t ? r.getTarget("next") : 37 === t && r.getTarget("prev");
                        r.flexAnimate(n, r.vars.pauseOnAction)
                    }
                }),
                r.vars.mousewheel && r.bind("mousewheel", function(e, t, n, i) {
                    e.preventDefault();
                    var o = 0 > t ? r.getTarget("next") : r.getTarget("prev");
                    r.flexAnimate(o, r.vars.pauseOnAction)
                }),
                r.vars.pausePlay && v.pausePlay.setup(),
                r.vars.slideshow && r.vars.pauseInvisible && v.pauseInvisible.init(),
                r.vars.slideshow && (r.vars.pauseOnHover && r.hover(function() {
                    r.manualPlay || r.manualPause || r.pause()
                }, function() {
                    r.manualPause || r.manualPlay || r.stopped || r.play()
                }),
                r.vars.pauseInvisible && v.pauseInvisible.isHidden() || (r.vars.initDelay > 0 ? r.startTimeout = setTimeout(r.play, r.vars.initDelay) : r.play())),
                m && v.asNav.setup(),
                l && r.vars.touch && v.touch(),
                (!d || d && r.vars.smoothHeight) && e(window).bind("resize orientationchange focus", v.resize),
                r.find("img").attr("draggable", "false"),
                setTimeout(function() {
                    r.vars.start(r)
                }, 200)
            },
            asNav: {
                setup: function() {
                    r.asNav = !0,
                    r.animatingTo = Math.floor(r.currentSlide / r.move),
                    r.currentItem = r.currentSlide,
                    r.slides.removeClass(s + "active-slide").eq(r.currentItem).addClass(s + "active-slide"),
                    a ? (n._slider = r,
                    r.slides.each(function() {
                        var t = this;
                        t._gesture = new MSGesture,
                        t._gesture.target = t,
                        t.addEventListener("MSPointerDown", function(e) {
                            e.preventDefault(),
                            e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId)
                        }, !1),
                        t.addEventListener("MSGestureTap", function(t) {
                            t.preventDefault();
                            var n = e(this)
                              , i = n.index();
                            e(r.vars.asNavFor).data("flexslider").animating || n.hasClass("active") || (r.direction = r.currentItem < i ? "next" : "prev",
                            r.flexAnimate(i, r.vars.pauseOnAction, !1, !0, !0))
                        })
                    })) : r.slides.on(c, function(t) {
                        t.preventDefault();
                        var n = e(this)
                          , i = n.index()
                          , o = n.offset().left - e(r).scrollLeft();
                        0 >= o && n.hasClass(s + "active-slide") ? r.flexAnimate(r.getTarget("prev"), !0) : e(r.vars.asNavFor).data("flexslider").animating || n.hasClass(s + "active-slide") || (r.direction = r.currentItem < i ? "next" : "prev",
                        r.flexAnimate(i, r.vars.pauseOnAction, !1, !0, !0))
                    })
                }
            },
            controlNav: {
                setup: function() {
                    r.manualControls ? v.controlNav.setupManual() : v.controlNav.setupPaging()
                },
                setupPaging: function() {
                    var t, n, i = "thumbnails" === r.vars.controlNav ? "control-thumbs" : "control-paging", o = 1;
                    if (r.controlNavScaffold = e('<ol class="' + s + "control-nav " + s + i + '"></ol>'),
                    r.pagingCount > 1)
                        for (var a = 0; a < r.pagingCount; a++) {
                            n = r.slides.eq(a),
                            void 0 === n.attr("data-thumb-alt") && n.attr("data-thumb-alt", "");
                            var l = "" !== n.attr("data-thumb-alt") ? l = ' alt="' + n.attr("data-thumb-alt") + '"' : "";
                            if (t = "thumbnails" === r.vars.controlNav ? '<img src="' + n.attr("data-thumb") + '"' + l + "/>" : '<a href="#">' + o + "</a>",
                            "thumbnails" === r.vars.controlNav && !0 === r.vars.thumbCaptions) {
                                var p = n.attr("data-thumbcaption");
                                "" !== p && void 0 !== p && (t += '<span class="' + s + 'caption">' + p + "</span>")
                            }
                            r.controlNavScaffold.append("<li>" + t + "</li>"),
                            o++
                        }
                    r.controlsContainer ? e(r.controlsContainer).append(r.controlNavScaffold) : r.append(r.controlNavScaffold),
                    v.controlNav.set(),
                    v.controlNav.active(),
                    r.controlNavScaffold.delegate("a, img", c, function(t) {
                        if (t.preventDefault(),
                        "" === u || u === t.type) {
                            var n = e(this)
                              , i = r.controlNav.index(n);
                            n.hasClass(s + "active") || (r.direction = i > r.currentSlide ? "next" : "prev",
                            r.flexAnimate(i, r.vars.pauseOnAction))
                        }
                        "" === u && (u = t.type),
                        v.setToClearWatchedEvent()
                    })
                },
                setupManual: function() {
                    r.controlNav = r.manualControls,
                    v.controlNav.active(),
                    r.controlNav.bind(c, function(t) {
                        if (t.preventDefault(),
                        "" === u || u === t.type) {
                            var n = e(this)
                              , i = r.controlNav.index(n);
                            n.hasClass(s + "active") || (i > r.currentSlide ? r.direction = "next" : r.direction = "prev",
                            r.flexAnimate(i, r.vars.pauseOnAction))
                        }
                        "" === u && (u = t.type),
                        v.setToClearWatchedEvent()
                    })
                },
                set: function() {
                    var t = "thumbnails" === r.vars.controlNav ? "img" : "a";
                    r.controlNav = e("." + s + "control-nav li " + t, r.controlsContainer ? r.controlsContainer : r)
                },
                active: function() {
                    r.controlNav.removeClass(s + "active").eq(r.animatingTo).addClass(s + "active")
                },
                update: function(t, n) {
                    r.pagingCount > 1 && "add" === t ? r.controlNavScaffold.append(e('<li><a href="#">' + r.count + "</a></li>")) : 1 === r.pagingCount ? r.controlNavScaffold.find("li").remove() : r.controlNav.eq(n).closest("li").remove(),
                    v.controlNav.set(),
                    r.pagingCount > 1 && r.pagingCount !== r.controlNav.length ? r.update(n, t) : v.controlNav.active()
                }
            },
            directionNav: {
                setup: function() {
                    var t = e('<ul class="' + s + 'direction-nav"><li class="' + s + 'nav-prev"><a class="' + s + 'prev" href="#">' + r.vars.prevText + '</a></li><li class="' + s + 'nav-next"><a class="' + s + 'next" href="#">' + r.vars.nextText + "</a></li></ul>");
                    r.customDirectionNav ? r.directionNav = r.customDirectionNav : r.controlsContainer ? (e(r.controlsContainer).append(t),
                    r.directionNav = e("." + s + "direction-nav li a", r.controlsContainer)) : (r.append(t),
                    r.directionNav = e("." + s + "direction-nav li a", r)),
                    v.directionNav.update(),
                    r.directionNav.bind(c, function(t) {
                        t.preventDefault();
                        var n;
                        "" !== u && u !== t.type || (n = e(this).hasClass(s + "next") ? r.getTarget("next") : r.getTarget("prev"),
                        r.flexAnimate(n, r.vars.pauseOnAction)),
                        "" === u && (u = t.type),
                        v.setToClearWatchedEvent()
                    })
                },
                update: function() {
                    var e = s + "disabled";
                    1 === r.pagingCount ? r.directionNav.addClass(e).attr("tabindex", "-1") : r.vars.animationLoop ? r.directionNav.removeClass(e).removeAttr("tabindex") : 0 === r.animatingTo ? r.directionNav.removeClass(e).filter("." + s + "prev").addClass(e).attr("tabindex", "-1") : r.animatingTo === r.last ? r.directionNav.removeClass(e).filter("." + s + "next").addClass(e).attr("tabindex", "-1") : r.directionNav.removeClass(e).removeAttr("tabindex")
                }
            },
            pausePlay: {
                setup: function() {
                    var t = e('<div class="' + s + 'pauseplay"><a href="#"></a></div>');
                    r.controlsContainer ? (r.controlsContainer.append(t),
                    r.pausePlay = e("." + s + "pauseplay a", r.controlsContainer)) : (r.append(t),
                    r.pausePlay = e("." + s + "pauseplay a", r)),
                    v.pausePlay.update(r.vars.slideshow ? s + "pause" : s + "play"),
                    r.pausePlay.bind(c, function(t) {
                        t.preventDefault(),
                        "" !== u && u !== t.type || (e(this).hasClass(s + "pause") ? (r.manualPause = !0,
                        r.manualPlay = !1,
                        r.pause()) : (r.manualPause = !1,
                        r.manualPlay = !0,
                        r.play())),
                        "" === u && (u = t.type),
                        v.setToClearWatchedEvent()
                    })
                },
                update: function(e) {
                    "play" === e ? r.pausePlay.removeClass(s + "pause").addClass(s + "play").html(r.vars.playText) : r.pausePlay.removeClass(s + "play").addClass(s + "pause").html(r.vars.pauseText)
                }
            },
            touch: function() {
                function e(e) {
                    e.stopPropagation(),
                    r.animating ? e.preventDefault() : (r.pause(),
                    n._gesture.addPointer(e.pointerId),
                    S = 0,
                    c = p ? r.h : r.w,
                    m = Number(new Date),
                    l = f && h && r.animatingTo === r.last ? 0 : f && h ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : f && r.currentSlide === r.last ? r.limit : f ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : h ? (r.last - r.currentSlide + r.cloneOffset) * c : (r.currentSlide + r.cloneOffset) * c)
                }
                function t(e) {
                    e.stopPropagation();
                    var t = e.target._slider;
                    if (t) {
                        var i = -e.translationX
                          , r = -e.translationY;
                        return S += p ? r : i,
                        u = S,
                        x = p ? Math.abs(S) < Math.abs(-i) : Math.abs(S) < Math.abs(-r),
                        e.detail === e.MSGESTURE_FLAG_INERTIA ? void setImmediate(function() {
                            n._gesture.stop()
                        }) : void ((!x || Number(new Date) - m > 500) && (e.preventDefault(),
                        !d && t.transitions && (t.vars.animationLoop || (u = S / (0 === t.currentSlide && 0 > S || t.currentSlide === t.last && S > 0 ? Math.abs(S) / c + 2 : 1)),
                        t.setProps(l + u, "setTouch"))))
                    }
                }
                function i(e) {
                    e.stopPropagation();
                    var t = e.target._slider;
                    if (t) {
                        if (t.animatingTo === t.currentSlide && !x && null !== u) {
                            var n = h ? -u : u
                              , i = n > 0 ? t.getTarget("next") : t.getTarget("prev");
                            t.canAdvance(i) && (Number(new Date) - m < 550 && Math.abs(n) > 50 || Math.abs(n) > c / 2) ? t.flexAnimate(i, t.vars.pauseOnAction) : d || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0)
                        }
                        o = null,
                        s = null,
                        u = null,
                        l = null,
                        S = 0
                    }
                }
                var o, s, l, c, u, m, v, g, y, x = !1, b = 0, w = 0, S = 0;
                a ? (n.style.msTouchAction = "none",
                n._gesture = new MSGesture,
                n._gesture.target = n,
                n.addEventListener("MSPointerDown", e, !1),
                n._slider = r,
                n.addEventListener("MSGestureChange", t, !1),
                n.addEventListener("MSGestureEnd", i, !1)) : (v = function(e) {
                    r.animating ? e.preventDefault() : (window.navigator.msPointerEnabled || 1 === e.touches.length) && (r.pause(),
                    c = p ? r.h : r.w,
                    m = Number(new Date),
                    b = e.touches[0].pageX,
                    w = e.touches[0].pageY,
                    l = f && h && r.animatingTo === r.last ? 0 : f && h ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : f && r.currentSlide === r.last ? r.limit : f ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : h ? (r.last - r.currentSlide + r.cloneOffset) * c : (r.currentSlide + r.cloneOffset) * c,
                    o = p ? w : b,
                    s = p ? b : w,
                    n.addEventListener("touchmove", g, !1),
                    n.addEventListener("touchend", y, !1))
                }
                ,
                g = function(e) {
                    b = e.touches[0].pageX,
                    w = e.touches[0].pageY,
                    u = p ? o - w : o - b,
                    x = p ? Math.abs(u) < Math.abs(b - s) : Math.abs(u) < Math.abs(w - s);
                    var t = 500;
                    (!x || Number(new Date) - m > t) && (e.preventDefault(),
                    !d && r.transitions && (r.vars.animationLoop || (u /= 0 === r.currentSlide && 0 > u || r.currentSlide === r.last && u > 0 ? Math.abs(u) / c + 2 : 1),
                    r.setProps(l + u, "setTouch")))
                }
                ,
                y = function(e) {
                    if (n.removeEventListener("touchmove", g, !1),
                    r.animatingTo === r.currentSlide && !x && null !== u) {
                        var t = h ? -u : u
                          , i = t > 0 ? r.getTarget("next") : r.getTarget("prev");
                        r.canAdvance(i) && (Number(new Date) - m < 550 && Math.abs(t) > 50 || Math.abs(t) > c / 2) ? r.flexAnimate(i, r.vars.pauseOnAction) : d || r.flexAnimate(r.currentSlide, r.vars.pauseOnAction, !0)
                    }
                    n.removeEventListener("touchend", y, !1),
                    o = null,
                    s = null,
                    u = null,
                    l = null
                }
                ,
                n.addEventListener("touchstart", v, !1))
            },
            resize: function() {
                !r.animating && r.is(":visible") && (f || r.doMath(),
                d ? v.smoothHeight() : f ? (r.slides.width(r.computedW),
                r.update(r.pagingCount),
                r.setProps()) : p ? (r.viewport.height(r.h),
                r.setProps(r.h, "setTotal")) : (r.vars.smoothHeight && v.smoothHeight(),
                r.newSlides.width(r.computedW),
                r.setProps(r.computedW, "setTotal")))
            },
            smoothHeight: function(e) {
                if (!p || d) {
                    var t = d ? r : r.viewport;
                    e ? t.animate({
                        height: r.slides.eq(r.animatingTo).innerHeight()
                    }, e) : t.innerHeight(r.slides.eq(r.animatingTo).innerHeight())
                }
            },
            sync: function(t) {
                var n = e(r.vars.sync).data("flexslider")
                  , i = r.animatingTo;
                switch (t) {
                case "animate":
                    n.flexAnimate(i, r.vars.pauseOnAction, !1, !0);
                    break;
                case "play":
                    n.playing || n.asNav || n.play();
                    break;
                case "pause":
                    n.pause()
                }
            },
            uniqueID: function(t) {
                return t.filter("[id]").add(t.find("[id]")).each(function() {
                    var t = e(this);
                    t.attr("id", t.attr("id") + "_clone")
                }),
                t
            },
            pauseInvisible: {
                visProp: null,
                init: function() {
                    var e = v.pauseInvisible.getHiddenProp();
                    if (e) {
                        var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(t, function() {
                            v.pauseInvisible.isHidden() ? r.startTimeout ? clearTimeout(r.startTimeout) : r.pause() : r.started ? r.play() : r.vars.initDelay > 0 ? setTimeout(r.play, r.vars.initDelay) : r.play()
                        })
                    }
                },
                isHidden: function() {
                    var e = v.pauseInvisible.getHiddenProp();
                    return !!e && document[e]
                },
                getHiddenProp: function() {
                    var e = ["webkit", "moz", "ms", "o"];
                    if ("hidden"in document)
                        return "hidden";
                    for (var t = 0; t < e.length; t++)
                        if (e[t] + "Hidden"in document)
                            return e[t] + "Hidden";
                    return null
                }
            },
            setToClearWatchedEvent: function() {
                clearTimeout(o),
                o = setTimeout(function() {
                    u = ""
                }, 3e3)
            }
        },
        r.flexAnimate = function(t, n, i, o, a) {
            if (r.vars.animationLoop || t === r.currentSlide || (r.direction = t > r.currentSlide ? "next" : "prev"),
            m && 1 === r.pagingCount && (r.direction = r.currentItem < t ? "next" : "prev"),
            !r.animating && (r.canAdvance(t, a) || i) && r.is(":visible")) {
                if (m && o) {
                    var c = e(r.vars.asNavFor).data("flexslider");
                    if (r.atEnd = 0 === t || t === r.count - 1,
                    c.flexAnimate(t, !0, !1, !0, a),
                    r.direction = r.currentItem < t ? "next" : "prev",
                    c.direction = r.direction,
                    Math.ceil((t + 1) / r.visible) - 1 === r.currentSlide || 0 === t)
                        return r.currentItem = t,
                        r.slides.removeClass(s + "active-slide").eq(t).addClass(s + "active-slide"),
                        !1;
                    r.currentItem = t,
                    r.slides.removeClass(s + "active-slide").eq(t).addClass(s + "active-slide"),
                    t = Math.floor(t / r.visible)
                }
                if (r.animating = !0,
                r.animatingTo = t,
                n && r.pause(),
                r.vars.before(r),
                r.syncExists && !a && v.sync("animate"),
                r.vars.controlNav && v.controlNav.active(),
                f || r.slides.removeClass(s + "active-slide").eq(t).addClass(s + "active-slide"),
                r.atEnd = 0 === t || t === r.last,
                r.vars.directionNav && v.directionNav.update(),
                t === r.last && (r.vars.end(r),
                r.vars.animationLoop || r.pause()),
                d)
                    l ? (r.slides.eq(r.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    }),
                    r.slides.eq(t).css({
                        opacity: 1,
                        zIndex: 2
                    }),
                    r.wrapup(x)) : (r.slides.eq(r.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, r.vars.animationSpeed, r.vars.easing),
                    r.slides.eq(t).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, r.vars.animationSpeed, r.vars.easing, r.wrapup));
                else {
                    var u, g, y, x = p ? r.slides.filter(":first").height() : r.computedW;
                    f ? (u = r.vars.itemMargin,
                    y = (r.itemW + u) * r.move * r.animatingTo,
                    g = y > r.limit && 1 !== r.visible ? r.limit : y) : g = 0 === r.currentSlide && t === r.count - 1 && r.vars.animationLoop && "next" !== r.direction ? h ? (r.count + r.cloneOffset) * x : 0 : r.currentSlide === r.last && 0 === t && r.vars.animationLoop && "prev" !== r.direction ? h ? 0 : (r.count + 1) * x : h ? (r.count - 1 - t + r.cloneOffset) * x : (t + r.cloneOffset) * x,
                    r.setProps(g, "", r.vars.animationSpeed),
                    r.transitions ? (r.vars.animationLoop && r.atEnd || (r.animating = !1,
                    r.currentSlide = r.animatingTo),
                    r.container.unbind("webkitTransitionEnd transitionend"),
                    r.container.bind("webkitTransitionEnd transitionend", function() {
                        clearTimeout(r.ensureAnimationEnd),
                        r.wrapup(x)
                    }),
                    clearTimeout(r.ensureAnimationEnd),
                    r.ensureAnimationEnd = setTimeout(function() {
                        r.wrapup(x)
                    }, r.vars.animationSpeed + 100)) : r.container.animate(r.args, r.vars.animationSpeed, r.vars.easing, function() {
                        r.wrapup(x)
                    })
                }
                r.vars.smoothHeight && v.smoothHeight(r.vars.animationSpeed)
            }
        }
        ,
        r.wrapup = function(e) {
            d || f || (0 === r.currentSlide && r.animatingTo === r.last && r.vars.animationLoop ? r.setProps(e, "jumpEnd") : r.currentSlide === r.last && 0 === r.animatingTo && r.vars.animationLoop && r.setProps(e, "jumpStart")),
            r.animating = !1,
            r.currentSlide = r.animatingTo,
            r.vars.after(r)
        }
        ,
        r.animateSlides = function() {
            !r.animating && t && r.flexAnimate(r.getTarget("next"))
        }
        ,
        r.pause = function() {
            clearInterval(r.animatedSlides),
            r.animatedSlides = null,
            r.playing = !1,
            r.vars.pausePlay && v.pausePlay.update("play"),
            r.syncExists && v.sync("pause")
        }
        ,
        r.play = function() {
            r.playing && clearInterval(r.animatedSlides),
            r.animatedSlides = r.animatedSlides || setInterval(r.animateSlides, r.vars.slideshowSpeed),
            r.started = r.playing = !0,
            r.vars.pausePlay && v.pausePlay.update("pause"),
            r.syncExists && v.sync("play")
        }
        ,
        r.stop = function() {
            r.pause(),
            r.stopped = !0
        }
        ,
        r.canAdvance = function(e, t) {
            var n = m ? r.pagingCount - 1 : r.last;
            return !!t || (!(!m || r.currentItem !== r.count - 1 || 0 !== e || "prev" !== r.direction) || (!m || 0 !== r.currentItem || e !== r.pagingCount - 1 || "next" === r.direction) && (!(e === r.currentSlide && !m) && (!!r.vars.animationLoop || (!r.atEnd || 0 !== r.currentSlide || e !== n || "next" === r.direction) && (!r.atEnd || r.currentSlide !== n || 0 !== e || "next" !== r.direction))))
        }
        ,
        r.getTarget = function(e) {
            return r.direction = e,
            "next" === e ? r.currentSlide === r.last ? 0 : r.currentSlide + 1 : 0 === r.currentSlide ? r.last : r.currentSlide - 1
        }
        ,
        r.setProps = function(e, t, n) {
            var i = function() {
                var n = e ? e : (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo
                  , i = function() {
                    if (f)
                        return "setTouch" === t ? e : h && r.animatingTo === r.last ? 0 : h ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : r.animatingTo === r.last ? r.limit : n;
                    switch (t) {
                    case "setTotal":
                        return h ? (r.count - 1 - r.currentSlide + r.cloneOffset) * e : (r.currentSlide + r.cloneOffset) * e;
                    case "setTouch":
                        return h ? e : e;
                    case "jumpEnd":
                        return h ? e : r.count * e;
                    case "jumpStart":
                        return h ? r.count * e : e;
                    default:
                        return e
                    }
                }();
                return -1 * i + "px"
            }();
            r.transitions && (i = p ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)",
            n = void 0 !== n ? n / 1e3 + "s" : "0s",
            r.container.css("-" + r.pfx + "-transition-duration", n),
            r.container.css("transition-duration", n)),
            r.args[r.prop] = i,
            (r.transitions || void 0 === n) && r.container.css(r.args),
            r.container.css("transform", i)
        }
        ,
        r.setup = function(t) {
            if (d)
                r.slides.css({
                    width: "100%",
                    float: "left",
                    marginRight: "-100%",
                    position: "relative"
                }),
                "init" === t && (l ? r.slides.css({
                    opacity: 0,
                    display: "block",
                    webkitTransition: "opacity " + r.vars.animationSpeed / 1e3 + "s ease",
                    zIndex: 1
                }).eq(r.currentSlide).css({
                    opacity: 1,
                    zIndex: 2
                }) : 0 == r.vars.fadeFirstSlide ? r.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(r.currentSlide).css({
                    zIndex: 2
                }).css({
                    opacity: 1
                }) : r.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(r.currentSlide).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, r.vars.animationSpeed, r.vars.easing)),
                r.vars.smoothHeight && v.smoothHeight();
            else {
                var n, i;
                "init" === t && (r.viewport = e('<div class="' + s + 'viewport"></div>').css({
                    overflow: "hidden",
                    position: "relative"
                }).appendTo(r).append(r.container),
                r.cloneCount = 0,
                r.cloneOffset = 0,
                h && (i = e.makeArray(r.slides).reverse(),
                r.slides = e(i),
                r.container.empty().append(r.slides))),
                r.vars.animationLoop && !f && (r.cloneCount = 2,
                r.cloneOffset = 1,
                "init" !== t && r.container.find(".clone").remove(),
                r.container.append(v.uniqueID(r.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(v.uniqueID(r.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))),
                r.newSlides = e(r.vars.selector, r),
                n = h ? r.count - 1 - r.currentSlide + r.cloneOffset : r.currentSlide + r.cloneOffset,
                p && !f ? (r.container.height(200 * (r.count + r.cloneCount) + "%").css("position", "absolute").width("100%"),
                setTimeout(function() {
                    r.newSlides.css({
                        display: "block"
                    }),
                    r.doMath(),
                    r.viewport.height(r.h),
                    r.setProps(n * r.h, "init")
                }, "init" === t ? 100 : 0)) : (r.container.width(200 * (r.count + r.cloneCount) + "%"),
                r.setProps(n * r.computedW, "init"),
                setTimeout(function() {
                    r.doMath(),
                    r.newSlides.css({
                        width: r.computedW,
                        marginRight: r.computedM,
                        float: "left",
                        display: "block"
                    }),
                    r.vars.smoothHeight && v.smoothHeight()
                }, "init" === t ? 100 : 0))
            }
            f || r.slides.removeClass(s + "active-slide").eq(r.currentSlide).addClass(s + "active-slide"),
            r.vars.init(r)
        }
        ,
        r.doMath = function() {
            var e = r.slides.first()
              , t = r.vars.itemMargin
              , n = r.vars.minItems
              , i = r.vars.maxItems;
            r.w = void 0 === r.viewport ? r.width() : r.viewport.width(),
            r.h = e.height(),
            r.boxPadding = e.outerWidth() - e.width(),
            f ? (r.itemT = r.vars.itemWidth + t,
            r.itemM = t,
            r.minW = n ? n * r.itemT : r.w,
            r.maxW = i ? i * r.itemT - t : r.w,
            r.itemW = r.minW > r.w ? (r.w - t * (n - 1)) / n : r.maxW < r.w ? (r.w - t * (i - 1)) / i : r.vars.itemWidth > r.w ? r.w : r.vars.itemWidth,
            r.visible = Math.floor(r.w / r.itemW),
            r.move = r.vars.move > 0 && r.vars.move < r.visible ? r.vars.move : r.visible,
            r.pagingCount = Math.ceil((r.count - r.visible) / r.move + 1),
            r.last = r.pagingCount - 1,
            r.limit = 1 === r.pagingCount ? 0 : r.vars.itemWidth > r.w ? r.itemW * (r.count - 1) + t * (r.count - 1) : (r.itemW + t) * r.count - r.w - t) : (r.itemW = r.w,
            r.itemM = t,
            r.pagingCount = r.count,
            r.last = r.count - 1),
            r.computedW = r.itemW - r.boxPadding,
            r.computedM = r.itemM
        }
        ,
        r.update = function(e, t) {
            r.doMath(),
            f || (e < r.currentSlide ? r.currentSlide += 1 : e <= r.currentSlide && 0 !== e && (r.currentSlide -= 1),
            r.animatingTo = r.currentSlide),
            r.vars.controlNav && !r.manualControls && ("add" === t && !f || r.pagingCount > r.controlNav.length ? v.controlNav.update("add") : ("remove" === t && !f || r.pagingCount < r.controlNav.length) && (f && r.currentSlide > r.last && (r.currentSlide -= 1,
            r.animatingTo -= 1),
            v.controlNav.update("remove", r.last))),
            r.vars.directionNav && v.directionNav.update()
        }
        ,
        r.addSlide = function(t, n) {
            var i = e(t);
            r.count += 1,
            r.last = r.count - 1,
            p && h ? void 0 !== n ? r.slides.eq(r.count - n).after(i) : r.container.prepend(i) : void 0 !== n ? r.slides.eq(n).before(i) : r.container.append(i),
            r.update(n, "add"),
            r.slides = e(r.vars.selector + ":not(.clone)", r),
            r.setup(),
            r.vars.added(r)
        }
        ,
        r.removeSlide = function(t) {
            var n = isNaN(t) ? r.slides.index(e(t)) : t;
            r.count -= 1,
            r.last = r.count - 1,
            isNaN(t) ? e(t, r.slides).remove() : p && h ? r.slides.eq(r.last).remove() : r.slides.eq(t).remove(),
            r.doMath(),
            r.update(n, "remove"),
            r.slides = e(r.vars.selector + ":not(.clone)", r),
            r.setup(),
            r.vars.removed(r)
        }
        ,
        v.init()
    }
    ,
    e(window).blur(function(e) {
        t = !1
    }).focus(function(e) {
        t = !0
    }),
    e.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "Previous",
        nextText: "Next",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        start: function() {},
        before: function() {},
        after: function() {},
        end: function() {},
        added: function() {},
        removed: function() {},
        init: function() {}
    },
    e.fn.flexslider = function(t) {
        if (void 0 === t && (t = {}),
        "object" == typeof t)
            return this.each(function() {
                var n = e(this)
                  , i = t.selector ? t.selector : ".slides > li"
                  , r = n.find(i);
                1 === r.length && t.allowOneSlide === !1 || 0 === r.length ? (r.fadeIn(400),
                t.start && t.start(n)) : void 0 === n.data("flexslider") && new e.flexslider(this,t)
            });
        var n = e(this).data("flexslider");
        switch (t) {
        case "play":
            n.play();
            break;
        case "pause":
            n.pause();
            break;
        case "stop":
            n.stop();
            break;
        case "next":
            n.flexAnimate(n.getTarget("next"), !0);
            break;
        case "prev":
        case "previous":
            n.flexAnimate(n.getTarget("prev"), !0);
            break;
        default:
            "number" == typeof t && n.flexAnimate(t, !0)
        }
    }
}(jQuery),
/*!
 * jquery.zoom.min.js
 */
/*!
	Zoom 1.7.14
	license: MIT
	http://www.jacklmoore.com/zoom

	Modified to include fixes on 2015-09-14.
*/
!function(e) {
    var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    e.zoom = function(t, n, i, r) {
        var o, s, a, l, c, u, p, h = e(t), f = h.css("position"), d = e(n);
        return h.css("position", /(absolute|fixed)/.test(f) ? f : "relative"),
        h.css("overflow", "hidden"),
        i.style.width = i.style.height = "",
        e(i).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * r,
            height: i.height * r,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(t),
        {
            init: function() {
                s = h.outerWidth(),
                o = h.outerHeight(),
                n === h[0] ? (l = s,
                a = o) : (l = d.outerWidth(),
                a = d.outerHeight()),
                c = (i.width - s) / l,
                u = (i.height - o) / a,
                p = d.offset()
            },
            move: function(e) {
                var t = e.pageX - p.left
                  , n = e.pageY - p.top;
                n = Math.max(Math.min(n, a), 0),
                t = Math.max(Math.min(t, l), 0),
                i.style.left = t * -c + "px",
                i.style.top = n * -u + "px"
            }
        }
    }
    ,
    e.fn.zoom = function(n) {
        return this.each(function() {
            var i, r = e.extend({}, t, n || {}), o = r.target || this, s = this, a = e(s), l = e(o), c = document.createElement("img"), u = e(c), p = "mousemove.zoom", h = !1, f = !1;
            (r.url || (i = a.find("img"),
            i[0] && (r.url = i.data("src") || i.attr("src")),
            r.url)) && (!function() {
                var e = l.css("position")
                  , t = l.css("overflow");
                a.one("zoom.destroy", function() {
                    a.off(".zoom"),
                    l.css("position", e),
                    l.css("overflow", t),
                    u.remove(),
                    c.onload = null
                })
            }(),
            c.onload = function() {
                function t(t) {
                    i.init(),
                    i.move(t),
                    u.stop().fadeTo(e.support.opacity ? r.duration : 0, 1, !!e.isFunction(r.onZoomIn) && r.onZoomIn.call(c))
                }
                function n() {
                    u.stop().fadeTo(r.duration, 0, !!e.isFunction(r.onZoomOut) && r.onZoomOut.call(c))
                }
                var i = e.zoom(o, s, c, r.magnify);
                "grab" === r.on ? a.on("mousedown.zoom", function(r) {
                    1 === r.which && (e(document).one("mouseup.zoom", function() {
                        n(),
                        e(document).off(p, i.move)
                    }),
                    t(r),
                    e(document).on(p, i.move),
                    r.preventDefault())
                }) : "click" === r.on ? a.on("click.zoom", function(r) {
                    return h ? void 0 : (h = !0,
                    t(r),
                    e(document).on(p, i.move),
                    e(document).one("click.zoom", function() {
                        n(),
                        h = !1,
                        e(document).off(p, i.move)
                    }),
                    !1)
                }) : "toggle" === r.on ? a.on("click.zoom", function(e) {
                    h ? n() : t(e),
                    h = !h
                }) : "mouseover" === r.on && (i.init(),
                a.on("mouseover.zoom", t).on("mouseleave.zoom", n).on(p, i.move)),
                r.touch && a.on("touchstart.zoom", function(e) {
                    e.preventDefault(),
                    f ? (f = !1,
                    n()) : (f = !0,
                    t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(e) {
                    e.preventDefault(),
                    i.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                }),
                e.isFunction(r.callback) && r.callback.call(c)
            }
            ,
            c.src = r.url)
        })
    }
    ,
    e.fn.zoom.defaults = t
}(window.jQuery),
function() {
    function e(e, t) {
        for (var n = -1, i = t.length, r = e.length; ++n < i; )
            e[r + n] = t[n];
        return e
    }
    function t(e, t, n) {
        for (var i = -1, r = e.length; ++i < r; ) {
            var o = e[i]
              , s = t(o);
            if (null != s && (a === le ? s === s : n(s, a)))
                var a = s
                  , l = o
        }
        return l
    }
    function n(e, t, n) {
        var i;
        return n(e, function(e, n, r) {
            return t(e, n, r) ? (i = e,
            !1) : void 0
        }),
        i
    }
    function i(e, t, n, i, r) {
        return r(e, function(e, r, o) {
            n = i ? (i = !1,
            e) : t(n, e, r, o)
        }),
        n
    }
    function r(e, t) {
        return C(t, function(t) {
            return e[t]
        })
    }
    function o(e) {
        return e && e.Object === Object ? e : null
    }
    function s(e) {
        return fe[e]
    }
    function a(e) {
        var t = !1;
        if (null != e && "function" != typeof e.toString)
            try {
                t = !!(e + "")
            } catch (e) {}
        return t
    }
    function l(e, t) {
        return e = "number" == typeof e || he.test(e) ? +e : -1,
        e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
    }
    function c(e) {
        if (Q(e) && !ze(e)) {
            if (e instanceof u)
                return e;
            if (ke.call(e, "__wrapped__")) {
                var t = new u(e.__wrapped__,e.__chain__);
                return t.__actions__ = P(e.__actions__),
                t
            }
        }
        return new u(e)
    }
    function u(e, t) {
        this.__wrapped__ = e,
        this.__actions__ = [],
        this.__chain__ = !!t
    }
    function p(e, t, n, i) {
        var r;
        return (r = e === le) || (r = Ce[n],
        r = (e === r || e !== e && r !== r) && !ke.call(i, n)),
        r ? t : e
    }
    function h(e) {
        return K(e) ? Ie(e) : {}
    }
    function f(e, t, n) {
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return setTimeout(function() {
            e.apply(le, n)
        }, t)
    }
    function d(e, t) {
        var n = !0;
        return je(e, function(e, i, r) {
            return n = !!t(e, i, r)
        }),
        n
    }
    function m(e, t) {
        var n = [];
        return je(e, function(e, i, r) {
            t(e, i, r) && n.push(e)
        }),
        n
    }
    function v(t, n, i, r) {
        r || (r = []);
        for (var o = -1, s = t.length; ++o < s; ) {
            var a = t[o];
            n > 0 && Q(a) && Y(a) && (i || ze(a) || U(a)) ? n > 1 ? v(a, n - 1, i, r) : e(r, a) : i || (r[r.length] = a)
        }
        return r
    }
    function g(e, t) {
        return e && Me(e, t, ie)
    }
    function y(e, t) {
        return m(t, function(t) {
            return G(e[t])
        })
    }
    function x(e, t, n, i, r) {
        return e === t || (null == e || null == t || !K(e) && !Q(t) ? e !== e && t !== t : b(e, t, x, n, i, r))
    }
    function b(e, t, n, i, r, o) {
        var s = ze(e)
          , l = ze(t)
          , c = "[object Array]"
          , u = "[object Array]";
        s || (c = Ee.call(e),
        "[object Arguments]" == c && (c = "[object Object]")),
        l || (u = Ee.call(t),
        "[object Arguments]" == u && (u = "[object Object]"));
        var p = "[object Object]" == c && !a(e)
          , l = "[object Object]" == u && !a(t);
        return !(u = c == u) || s || p ? 2 & r || (c = p && ke.call(e, "__wrapped__"),
        l = l && ke.call(t, "__wrapped__"),
        !c && !l) ? !!u && (o || (o = []),
        (c = $(o, function(t) {
            return t[0] === e
        })) && c[1] ? c[1] == t : (o.push([e, t]),
        t = (s ? j : H)(e, t, n, i, r, o),
        o.pop(),
        t)) : n(c ? e.value() : e, l ? t.value() : t, i, r, o) : M(e, t, c)
    }
    function w(e) {
        var t = typeof e;
        return "function" == t ? e : null == e ? se : ("object" == t ? k : E)(e)
    }
    function S(e) {
        e = null == e ? e : Object(e);
        var t, n = [];
        for (t in e)
            n.push(t);
        return n
    }
    function C(e, t) {
        var n = -1
          , i = Y(e) ? Array(e.length) : [];
        return je(e, function(e, r, o) {
            i[++n] = t(e, r, o)
        }),
        i
    }
    function k(e) {
        var t = ie(e);
        return function(n) {
            var i = t.length;
            if (null == n)
                return !i;
            for (n = Object(n); i--; ) {
                var r = t[i];
                if (!(r in n && x(e[r], n[r], le, 3)))
                    return !1
            }
            return !0
        }
    }
    function T(e, t) {
        return e = Object(e),
        B(t, function(t, n) {
            return n in e && (t[n] = e[n]),
            t
        }, {})
    }
    function E(e) {
        return function(t) {
            return null == t ? le : t[e]
        }
    }
    function N(e, t, n) {
        var i = -1
          , r = e.length;
        for (0 > t && (t = -t > r ? 0 : r + t),
        n = n > r ? r : n,
        0 > n && (n += r),
        r = t > n ? 0 : n - t >>> 0,
        t >>>= 0,
        n = Array(r); ++i < r; )
            n[i] = e[i + t];
        return n
    }
    function P(e) {
        return N(e, 0, e.length)
    }
    function _(e, t) {
        var n;
        return je(e, function(e, i, r) {
            return n = t(e, i, r),
            !n
        }),
        !!n
    }
    function I(t, n) {
        return B(n, function(t, n) {
            return n.func.apply(n.thisArg, e([t], n.args))
        }, t)
    }
    function O(e, t, n, i) {
        n || (n = {});
        for (var r = -1, o = t.length; ++r < o; ) {
            var s = t[r]
              , a = i ? i(n[s], e[s], s, n, e) : e[s]
              , l = n
              , c = l[s];
            ke.call(l, s) && (c === a || c !== c && a !== a) && (a !== le || s in l) || (l[s] = a)
        }
        return n
    }
    function A(e) {
        return V(function(t, n) {
            var i = -1
              , r = n.length
              , o = r > 1 ? n[r - 1] : le
              , o = "function" == typeof o ? (r--,
            o) : le;
            for (t = Object(t); ++i < r; ) {
                var s = n[i];
                s && e(t, s, i, o)
            }
            return t
        })
    }
    function L(e) {
        return function() {
            var t = arguments
              , n = h(e.prototype)
              , t = e.apply(n, t);
            return K(t) ? t : n
        }
    }
    function D(e, t, n) {
        function i() {
            for (var o = -1, s = arguments.length, a = -1, l = n.length, c = Array(l + s), u = this && this !== we && this instanceof i ? r : e; ++a < l; )
                c[a] = n[a];
            for (; s--; )
                c[a++] = arguments[++o];
            return u.apply(t, c)
        }
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        var r = L(e);
        return i
    }
    function j(e, t, n, i, r, o) {
        var s = -1
          , a = 1 & r
          , l = e.length
          , c = t.length;
        if (l != c && !(2 & r && c > l))
            return !1;
        for (c = !0; ++s < l; ) {
            var u = e[s]
              , p = t[s];
            if (void 0 !== le) {
                c = !1;
                break
            }
            if (a) {
                if (!_(t, function(e) {
                    return u === e || n(u, e, i, r, o)
                })) {
                    c = !1;
                    break
                }
            } else if (u !== p && !n(u, p, i, r, o)) {
                c = !1;
                break
            }
        }
        return c
    }
    function M(e, t, n) {
        switch (n) {
        case "[object Boolean]":
        case "[object Date]":
            return +e == +t;
        case "[object Error]":
            return e.name == t.name && e.message == t.message;
        case "[object Number]":
            return e != +e ? t != +t : e == +t;
        case "[object RegExp]":
        case "[object String]":
            return e == t + ""
        }
        return !1
    }
    function H(e, t, n, i, r, o) {
        var s = 2 & r
          , a = ie(e)
          , l = a.length
          , c = ie(t).length;
        if (l != c && !s)
            return !1;
        for (var u = l; u--; ) {
            var p = a[u];
            if (!(s ? p in t : ke.call(t, p)))
                return !1
        }
        for (c = !0; ++u < l; ) {
            var p = a[u]
              , h = e[p]
              , f = t[p];
            if (void 0 !== le || h !== f && !n(h, f, i, r, o)) {
                c = !1;
                break
            }
            s || (s = "constructor" == p)
        }
        return c && !s && (n = e.constructor,
        i = t.constructor,
        n != i && "constructor"in e && "constructor"in t && !("function" == typeof n && n instanceof n && "function" == typeof i && i instanceof i) && (c = !1)),
        c
    }
    function F(e) {
        var t = e ? e.length : le;
        if (Z(t) && (ze(e) || ee(e) || U(e))) {
            e = String;
            for (var n = -1, i = Array(t); ++n < t; )
                i[n] = e(n);
            t = i
        } else
            t = null;
        return t
    }
    function q(e) {
        var t = e && e.constructor
          , t = G(t) && t.prototype || Ce;
        return e === t
    }
    function R(e) {
        return e ? e[0] : le
    }
    function $(e, t) {
        return n(e, w(t), je)
    }
    function z(e, t) {
        return je(e, "function" == typeof t ? t : se)
    }
    function B(e, t, n) {
        return i(e, w(t), n, 3 > arguments.length, je)
    }
    function W(e, t) {
        var n;
        if ("function" != typeof t)
            throw new TypeError("Expected a function");
        return e = Be(e),
        function() {
            return 0 < --e && (n = t.apply(this, arguments)),
            1 >= e && (t = le),
            n
        }
    }
    function V(e) {
        var t;
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return t = De(t === le ? e.length - 1 : Be(t), 0),
        function() {
            for (var n = arguments, i = -1, r = De(n.length - t, 0), o = Array(r); ++i < r; )
                o[i] = n[t + i];
            for (r = Array(t + 1),
            i = -1; ++i < t; )
                r[i] = n[i];
            return r[t] = o,
            e.apply(this, r)
        }
    }
    function X(e, t) {
        return e > t
    }
    function U(e) {
        return Q(e) && Y(e) && ke.call(e, "callee") && (!Oe.call(e, "callee") || "[object Arguments]" == Ee.call(e))
    }
    function Y(e) {
        return null != e && !("function" == typeof e && G(e)) && Z(He(e))
    }
    function G(e) {
        return e = K(e) ? Ee.call(e) : "",
        "[object Function]" == e || "[object GeneratorFunction]" == e
    }
    function Z(e) {
        return "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
    }
    function K(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t)
    }
    function Q(e) {
        return !!e && "object" == typeof e
    }
    function J(e) {
        return "number" == typeof e || Q(e) && "[object Number]" == Ee.call(e)
    }
    function ee(e) {
        return "string" == typeof e || !ze(e) && Q(e) && "[object String]" == Ee.call(e)
    }
    function te(e, t) {
        return t > e
    }
    function ne(e) {
        return "string" == typeof e ? e : null == e ? "" : e + ""
    }
    function ie(e) {
        var t = q(e);
        if (!t && !Y(e))
            return Le(Object(e));
        var n, i = F(e), r = !!i, i = i || [], o = i.length;
        for (n in e)
            !ke.call(e, n) || r && ("length" == n || l(n, o)) || t && "constructor" == n || i.push(n);
        return i
    }
    function re(e) {
        for (var t = -1, n = q(e), i = S(e), r = i.length, o = F(e), s = !!o, o = o || [], a = o.length; ++t < r; ) {
            var c = i[t];
            s && ("length" == c || l(c, a)) || "constructor" == c && (n || !ke.call(e, c)) || o.push(c)
        }
        return o
    }
    function oe(e) {
        return e ? r(e, ie(e)) : []
    }
    function se(e) {
        return e
    }
    function ae(t, n, i) {
        var r = ie(n)
          , o = y(n, r);
        null != i || K(n) && (o.length || !r.length) || (i = n,
        n = t,
        t = this,
        o = y(n, ie(n)));
        var s = !(K(i) && "chain"in i) || i.chain
          , a = G(t);
        return je(o, function(i) {
            var r = n[i];
            t[i] = r,
            a && (t.prototype[i] = function() {
                var n = this.__chain__;
                if (s || n) {
                    var i = t(this.__wrapped__);
                    return (i.__actions__ = P(this.__actions__)).push({
                        func: r,
                        args: arguments,
                        thisArg: t
                    }),
                    i.__chain__ = n,
                    i
                }
                return r.apply(t, e([this.value()], arguments))
            }
            )
        }),
        t
    }
    var le, ce = 1 / 0, ue = /[&<>"'`]/g, pe = RegExp(ue.source), he = /^(?:0|[1-9]\d*)$/, fe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;"
    }, de = {
        function: !0,
        object: !0
    }, me = de[typeof exports] && exports && !exports.nodeType ? exports : le, ve = de[typeof module] && module && !module.nodeType ? module : le, ge = ve && ve.exports === me ? me : le, ye = o(de[typeof self] && self), xe = o(de[typeof window] && window), be = o(de[typeof this] && this), we = o(me && ve && "object" == typeof global && global) || xe !== (be && be.window) && xe || ye || be || Function("return this")(), Se = Array.prototype, Ce = Object.prototype, ke = Ce.hasOwnProperty, Te = 0, Ee = Ce.toString, Ne = we._, Pe = we.Reflect, _e = Pe ? Pe.f : le, Ie = Object.create, Oe = Ce.propertyIsEnumerable, Ae = we.isFinite, Le = Object.keys, De = Math.max, je = function(e, t) {
        return function(n, i) {
            if (null == n)
                return n;
            if (!Y(n))
                return e(n, i);
            for (var r = n.length, o = t ? r : -1, s = Object(n); (t ? o-- : ++o < r) && !1 !== i(s[o], o, s); )
                ;
            return n
        }
    }(g), Me = function(e) {
        return function(t, n, i) {
            var r = -1
              , o = Object(t);
            i = i(t);
            for (var s = i.length; s--; ) {
                var a = i[e ? s : ++r];
                if (!1 === n(o[a], a, o))
                    break
            }
            return t
        }
    }();
    _e && !Oe.call({
        valueOf: 1
    }, "valueOf") && (S = function(e) {
        e = _e(e);
        for (var t, n = []; !(t = e.next()).done; )
            n.push(t.value);
        return n
    }
    );
    var He = E("length")
      , Fe = V(function(t, n) {
        return ze(t) || (t = null == t ? [] : [Object(t)]),
        v(n, 1),
        e(P(t), oe)
    })
      , qe = V(function(e, t, n) {
        return D(e, t, n)
    })
      , Re = V(function(e, t) {
        return f(e, 1, t)
    })
      , $e = V(function(e, t, n) {
        return f(e, We(t) || 0, n)
    })
      , ze = Array.isArray
      , Be = Number
      , We = Number
      , Ve = A(function(e, t) {
        O(t, ie(t), e)
    })
      , Xe = A(function(e, t) {
        O(t, re(t), e)
    })
      , Ue = A(function(e, t, n, i) {
        O(t, re(t), e, i)
    })
      , Ye = V(function(e) {
        return e.push(le, p),
        Ue.apply(le, e)
    })
      , Ge = V(function(e, t) {
        return null == e ? {} : T(e, v(t, 1))
    })
      , Ze = w;
    u.prototype = h(c.prototype),
    u.prototype.constructor = u,
    c.assignIn = Xe,
    c.before = W,
    c.bind = qe,
    c.chain = function(e) {
        return e = c(e),
        e.__chain__ = !0,
        e
    }
    ,
    c.compact = function(e) {
        return m(e, Boolean)
    }
    ,
    c.concat = Fe,
    c.create = function(e, t) {
        var n = h(e);
        return t ? Ve(n, t) : n
    }
    ,
    c.defaults = Ye,
    c.defer = Re,
    c.delay = $e,
    c.filter = function(e, t) {
        return m(e, w(t))
    }
    ,
    c.flatten = function(e) {
        return e && e.length ? v(e, 1) : []
    }
    ,
    c.flattenDeep = function(e) {
        return e && e.length ? v(e, ce) : []
    }
    ,
    c.iteratee = Ze,
    c.keys = ie,
    c.map = function(e, t) {
        return C(e, w(t))
    }
    ,
    c.matches = function(e) {
        return k(Ve({}, e))
    }
    ,
    c.mixin = ae,
    c.negate = function(e) {
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return function() {
            return !e.apply(this, arguments)
        }
    }
    ,
    c.once = function(e) {
        return W(2, e)
    }
    ,
    c.pick = Ge,
    c.slice = function(e, t, n) {
        var i = e ? e.length : 0;
        return n = n === le ? i : +n,
        i ? N(e, null == t ? 0 : +t, n) : []
    }
    ,
    c.sortBy = function(e, t) {
        var n = 0;
        return t = w(t),
        C(C(e, function(e, i, r) {
            return {
                c: e,
                b: n++,
                a: t(e, i, r)
            }
        }).sort(function(e, t) {
            var n;
            e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                    var r = null === n
                      , o = n === le
                      , s = n === n
                      , a = null === i
                      , l = i === le
                      , c = i === i;
                    if (n > i && !a || !s || r && !l && c || o && c) {
                        n = 1;
                        break e
                    }
                    if (i > n && !r || !c || a && !o && s || l && s) {
                        n = -1;
                        break e
                    }
                }
                n = 0
            }
            return n || e.b - t.b
        }), E("c"))
    }
    ,
    c.tap = function(e, t) {
        return t(e),
        e
    }
    ,
    c.thru = function(e, t) {
        return t(e)
    }
    ,
    c.toArray = function(e) {
        return Y(e) ? e.length ? P(e) : [] : oe(e)
    }
    ,
    c.values = oe,
    c.extend = Xe,
    ae(c, c),
    c.clone = function(e) {
        return K(e) ? ze(e) ? P(e) : O(e, ie(e)) : e
    }
    ,
    c.escape = function(e) {
        return (e = ne(e)) && pe.test(e) ? e.replace(ue, s) : e
    }
    ,
    c.every = function(e, t, n) {
        return t = n ? le : t,
        d(e, w(t))
    }
    ,
    c.find = $,
    c.forEach = z,
    c.has = function(e, t) {
        return null != e && ke.call(e, t)
    }
    ,
    c.head = R,
    c.identity = se,
    c.indexOf = function(e, t, n) {
        var i = e ? e.length : 0;
        n = "number" == typeof n ? 0 > n ? De(i + n, 0) : n : 0,
        n = (n || 0) - 1;
        for (var r = t === t; ++n < i; ) {
            var o = e[n];
            if (r ? o === t : o !== o)
                return n
        }
        return -1
    }
    ,
    c.isArguments = U,
    c.isArray = ze,
    c.isBoolean = function(e) {
        return !0 === e || !1 === e || Q(e) && "[object Boolean]" == Ee.call(e)
    }
    ,
    c.isDate = function(e) {
        return Q(e) && "[object Date]" == Ee.call(e)
    }
    ,
    c.isEmpty = function(e) {
        if (Y(e) && (ze(e) || ee(e) || G(e.splice) || U(e)))
            return !e.length;
        for (var t in e)
            if (ke.call(e, t))
                return !1;
        return !0
    }
    ,
    c.isEqual = function(e, t) {
        return x(e, t)
    }
    ,
    c.isFinite = function(e) {
        return "number" == typeof e && Ae(e)
    }
    ,
    c.isFunction = G,
    c.isNaN = function(e) {
        return J(e) && e != +e
    }
    ,
    c.isNull = function(e) {
        return null === e
    }
    ,
    c.isNumber = J,
    c.isObject = K,
    c.isRegExp = function(e) {
        return K(e) && "[object RegExp]" == Ee.call(e)
    }
    ,
    c.isString = ee,
    c.isUndefined = function(e) {
        return e === le
    }
    ,
    c.last = function(e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : le
    }
    ,
    c.max = function(e) {
        return e && e.length ? t(e, se, X) : le
    }
    ,
    c.min = function(e) {
        return e && e.length ? t(e, se, te) : le
    }
    ,
    c.noConflict = function() {
        return we._ === this && (we._ = Ne),
        this
    }
    ,
    c.noop = function() {}
    ,
    c.reduce = B,
    c.result = function(e, t, n) {
        return t = null == e ? le : e[t],
        t === le && (t = n),
        G(t) ? t.call(e) : t
    }
    ,
    c.size = function(e) {
        return null == e ? 0 : (e = Y(e) ? e : ie(e),
        e.length)
    }
    ,
    c.some = function(e, t, n) {
        return t = n ? le : t,
        _(e, w(t))
    }
    ,
    c.uniqueId = function(e) {
        var t = ++Te;
        return ne(e) + t
    }
    ,
    c.each = z,
    c.first = R,
    ae(c, function() {
        var e = {};
        return g(c, function(t, n) {
            ke.call(c.prototype, n) || (e[n] = t)
        }),
        e
    }(), {
        chain: !1
    }),
    c.VERSION = "4.5.1",
    je("pop join replace reverse split push shift sort splice unshift".split(" "), function(e) {
        var t = (/^(?:replace|split)$/.test(e) ? String.prototype : Se)[e]
          , n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru"
          , i = /^(?:pop|join|replace|shift)$/.test(e);
        c.prototype[e] = function() {
            var e = arguments;
            return i && !this.__chain__ ? t.apply(this.value(), e) : this[n](function(n) {
                return t.apply(n, e)
            })
        }
    }),
    c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = function() {
        return I(this.__wrapped__, this.__actions__)
    }
    ,
    (xe || ye || {})._ = c,
    "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return c
    }) : me && ve ? (ge && ((ve.exports = c)._ = c),
    me._ = c) : we._ = c
}
.call(this),
/*!
 * magnific-popup.min.js
 */
/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function(e) {
    var t, n, i, r, o, s, a = "Close", l = "BeforeClose", c = "AfterClose", u = "BeforeAppend", p = "MarkupParse", h = "Open", f = "Change", d = "mfp", m = "." + d, v = "mfp-ready", g = "mfp-removing", y = "mfp-prevent-close", x = function() {}, b = !!window.jQuery, w = e(window), S = function(e, n) {
        t.ev.on(d + e + m, n)
    }, C = function(t, n, i, r) {
        var o = document.createElement("div");
        return o.className = "mfp-" + t,
        i && (o.innerHTML = i),
        r ? n && n.appendChild(o) : (o = e(o),
        n && o.appendTo(n)),
        o
    }, k = function(n, i) {
        t.ev.triggerHandler(d + n, i),
        t.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1),
        t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]))
    }, T = function(n) {
        return n === s && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)),
        s = n),
        t.currTemplate.closeBtn
    }, E = function() {
        e.magnificPopup.instance || (t = new x,
        t.init(),
        e.magnificPopup.instance = t)
    }, N = function() {
        var e = document.createElement("p").style
          , t = ["ms", "O", "Moz", "Webkit"];
        if (void 0 !== e.transition)
            return !0;
        for (; t.length; )
            if (t.pop() + "Transition"in e)
                return !0;
        return !1
    };
    x.prototype = {
        constructor: x,
        init: function() {
            var n = navigator.appVersion;
            t.isIE7 = -1 !== n.indexOf("MSIE 7."),
            t.isIE8 = -1 !== n.indexOf("MSIE 8."),
            t.isLowIE = t.isIE7 || t.isIE8,
            t.isAndroid = /android/gi.test(n),
            t.isIOS = /iphone|ipad|ipod/gi.test(n),
            t.supportsTransition = N(),
            t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),
            i = e(document),
            t.popupsCache = {}
        },
        open: function(n) {
            var r;
            if (n.isObj === !1) {
                t.items = n.items.toArray(),
                t.index = 0;
                var s, a = n.items;
                for (r = 0; r < a.length; r++)
                    if (s = a[r],
                    s.parsed && (s = s.el[0]),
                    s === n.el[0]) {
                        t.index = r;
                        break
                    }
            } else
                t.items = e.isArray(n.items) ? n.items : [n.items],
                t.index = n.index || 0;
            if (t.isOpen)
                return void t.updateItemHTML();
            t.types = [],
            o = "",
            t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(0) : i,
            n.key ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}),
            t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {},
            t.st = e.extend(!0, {}, e.magnificPopup.defaults, n),
            t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos,
            t.st.modal && (t.st.closeOnContentClick = !1,
            t.st.closeOnBgClick = !1,
            t.st.showCloseBtn = !1,
            t.st.enableEscapeKey = !1),
            t.bgOverlay || (t.bgOverlay = C("bg").on("click" + m, function() {
                t.close()
            }),
            t.wrap = C("wrap").attr("tabindex", -1).on("click" + m, function(e) {
                t._checkIfClose(e.target) && t.close()
            }),
            t.container = C("container", t.wrap)),
            t.contentContainer = C("content"),
            t.st.preloader && (t.preloader = C("preloader", t.container, t.st.tLoading));
            var l = e.magnificPopup.modules;
            for (r = 0; r < l.length; r++) {
                var c = l[r];
                c = c.charAt(0).toUpperCase() + c.slice(1),
                t["init" + c].call(t)
            }
            k("BeforeOpen"),
            t.st.showCloseBtn && (t.st.closeBtnInside ? (S(p, function(e, t, n, i) {
                n.close_replaceWith = T(i.type)
            }),
            o += " mfp-close-btn-in") : t.wrap.append(T())),
            t.st.alignTop && (o += " mfp-align-top"),
            t.wrap.css(t.fixedContentPos ? {
                overflow: t.st.overflowY,
                overflowX: "hidden",
                overflowY: t.st.overflowY
            } : {
                top: w.scrollTop(),
                position: "absolute"
            }),
            (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
                height: i.height(),
                position: "absolute"
            }),
            t.st.enableEscapeKey && i.on("keyup" + m, function(e) {
                27 === e.keyCode && t.close()
            }),
            w.on("resize" + m, function() {
                t.updateSize()
            }),
            t.st.closeOnContentClick || (o += " mfp-auto-cursor"),
            o && t.wrap.addClass(o);
            var u = t.wH = w.height()
              , f = {};
            if (t.fixedContentPos && t._hasScrollBar(u)) {
                var d = t._getScrollbarSize();
                d && (f.marginRight = d)
            }
            t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : f.overflow = "hidden");
            var g = t.st.mainClass;
            return t.isIE7 && (g += " mfp-ie7"),
            g && t._addClassToMFP(g),
            t.updateItemHTML(),
            k("BuildControls"),
            e("html").css(f),
            t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || e(document.body)),
            t._lastFocusedEl = document.activeElement,
            setTimeout(function() {
                t.content ? (t._addClassToMFP(v),
                t._setFocus()) : t.bgOverlay.addClass(v),
                i.on("focusin" + m, t._onFocusIn)
            }, 16),
            t.isOpen = !0,
            t.updateSize(u),
            k(h),
            n
        },
        close: function() {
            t.isOpen && (k(l),
            t.isOpen = !1,
            t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(g),
            setTimeout(function() {
                t._close()
            }, t.st.removalDelay)) : t._close())
        },
        _close: function() {
            k(a);
            var n = g + " " + v + " ";
            if (t.bgOverlay.detach(),
            t.wrap.detach(),
            t.container.empty(),
            t.st.mainClass && (n += t.st.mainClass + " "),
            t._removeClassFromMFP(n),
            t.fixedContentPos) {
                var r = {
                    marginRight: ""
                };
                t.isIE7 ? e("body, html").css("overflow", "") : r.overflow = "",
                e("html").css(r)
            }
            i.off("keyup" + m + " focusin" + m),
            t.ev.off(m),
            t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
            t.bgOverlay.attr("class", "mfp-bg"),
            t.container.attr("class", "mfp-container"),
            !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(),
            t._lastFocusedEl && e(t._lastFocusedEl).focus(),
            t.currItem = null,
            t.content = null,
            t.currTemplate = null,
            t.prevHeight = 0,
            k(c)
        },
        updateSize: function(e) {
            if (t.isIOS) {
                var n = document.documentElement.clientWidth / window.innerWidth
                  , i = window.innerHeight * n;
                t.wrap.css("height", i),
                t.wH = i
            } else
                t.wH = e || w.height();
            t.fixedContentPos || t.wrap.css("height", t.wH),
            k("Resize")
        },
        updateItemHTML: function() {
            var n = t.items[t.index];
            t.contentContainer.detach(),
            t.content && t.content.detach(),
            n.parsed || (n = t.parseEl(t.index));
            var i = n.type;
            if (k("BeforeChange", [t.currItem ? t.currItem.type : "", i]),
            t.currItem = n,
            !t.currTemplate[i]) {
                var o = !!t.st[i] && t.st[i].markup;
                k("FirstMarkupParse", o),
                t.currTemplate[i] = !o || e(o)
            }
            r && r !== n.type && t.container.removeClass("mfp-" + r + "-holder");
            var s = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, t.currTemplate[i]);
            t.appendContent(s, i),
            n.preloaded = !0,
            k(f, n),
            r = n.type,
            t.container.prepend(t.contentContainer),
            k("AfterChange")
        },
        appendContent: function(e, n) {
            t.content = e,
            e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[n] === !0 ? t.content.find(".mfp-close").length || t.content.append(T()) : t.content = e : t.content = "",
            k(u),
            t.container.addClass("mfp-" + n + "-holder"),
            t.contentContainer.append(t.content)
        },
        parseEl: function(n) {
            var i, r = t.items[n];
            if (r.tagName ? r = {
                el: e(r)
            } : (i = r.type,
            r = {
                data: r,
                src: r.src
            }),
            r.el) {
                for (var o = t.types, s = 0; s < o.length; s++)
                    if (r.el.hasClass("mfp-" + o[s])) {
                        i = o[s];
                        break
                    }
                r.src = r.el.attr("data-mfp-src"),
                r.src || (r.src = r.el.attr("href"))
            }
            return r.type = i || t.st.type || "inline",
            r.index = n,
            r.parsed = !0,
            t.items[n] = r,
            k("ElementParse", r),
            t.items[n]
        },
        addGroup: function(e, n) {
            var i = function(i) {
                i.mfpEl = this,
                t._openClick(i, e, n)
            };
            n || (n = {});
            var r = "click.magnificPopup";
            n.mainEl = e,
            n.items ? (n.isObj = !0,
            e.off(r).on(r, i)) : (n.isObj = !1,
            n.delegate ? e.off(r).on(r, n.delegate, i) : (n.items = e,
            e.off(r).on(r, i)))
        },
        _openClick: function(n, i, r) {
            var o = void 0 !== r.midClick ? r.midClick : e.magnificPopup.defaults.midClick;
            if (o || 2 !== n.which && !n.ctrlKey && !n.metaKey) {
                var s = void 0 !== r.disableOn ? r.disableOn : e.magnificPopup.defaults.disableOn;
                if (s)
                    if (e.isFunction(s)) {
                        if (!s.call(t))
                            return !0
                    } else if (w.width() < s)
                        return !0;
                n.type && (n.preventDefault(),
                t.isOpen && n.stopPropagation()),
                r.el = e(n.mfpEl),
                r.delegate && (r.items = i.find(r.delegate)),
                t.open(r)
            }
        },
        updateStatus: function(e, i) {
            if (t.preloader) {
                n !== e && t.container.removeClass("mfp-s-" + n),
                i || "loading" !== e || (i = t.st.tLoading);
                var r = {
                    status: e,
                    text: i
                };
                k("UpdateStatus", r),
                e = r.status,
                i = r.text,
                t.preloader.html(i),
                t.preloader.find("a").on("click", function(e) {
                    e.stopImmediatePropagation()
                }),
                t.container.addClass("mfp-s-" + e),
                n = e
            }
        },
        _checkIfClose: function(n) {
            if (!e(n).hasClass(y)) {
                var i = t.st.closeOnContentClick
                  , r = t.st.closeOnBgClick;
                if (i && r)
                    return !0;
                if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n === t.preloader[0])
                    return !0;
                if (n === t.content[0] || e.contains(t.content[0], n)) {
                    if (i)
                        return !0
                } else if (r && e.contains(document, n))
                    return !0;
                return !1
            }
        },
        _addClassToMFP: function(e) {
            t.bgOverlay.addClass(e),
            t.wrap.addClass(e)
        },
        _removeClassFromMFP: function(e) {
            this.bgOverlay.removeClass(e),
            t.wrap.removeClass(e)
        },
        _hasScrollBar: function(e) {
            return (t.isIE7 ? i.height() : document.body.scrollHeight) > (e || w.height())
        },
        _setFocus: function() {
            (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
        },
        _onFocusIn: function(n) {
            return n.target === t.wrap[0] || e.contains(t.wrap[0], n.target) ? void 0 : (t._setFocus(),
            !1)
        },
        _parseMarkup: function(t, n, i) {
            var r;
            i.data && (n = e.extend(i.data, n)),
            k(p, [t, n, i]),
            e.each(n, function(e, n) {
                if (void 0 === n || n === !1)
                    return !0;
                if (r = e.split("_"),
                r.length > 1) {
                    var i = t.find(m + "-" + r[0]);
                    if (i.length > 0) {
                        var o = r[1];
                        "replaceWith" === o ? i[0] !== n[0] && i.replaceWith(n) : "img" === o ? i.is("img") ? i.attr("src", n) : i.replaceWith('<img src="' + n + '" class="' + i.attr("class") + '" />') : i.attr(r[1], n)
                    }
                } else
                    t.find(m + "-" + e).html(n)
            })
        },
        _getScrollbarSize: function() {
            if (void 0 === t.scrollbarSize) {
                var e = document.createElement("div");
                e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",
                document.body.appendChild(e),
                t.scrollbarSize = e.offsetWidth - e.clientWidth,
                document.body.removeChild(e)
            }
            return t.scrollbarSize
        }
    },
    e.magnificPopup = {
        instance: null,
        proto: x.prototype,
        modules: [],
        open: function(t, n) {
            return E(),
            t = t ? e.extend(!0, {}, t) : {},
            t.isObj = !0,
            t.index = n || 0,
            this.instance.open(t)
        },
        close: function() {
            return e.magnificPopup.instance && e.magnificPopup.instance.close()
        },
        registerModule: function(t, n) {
            n.options && (e.magnificPopup.defaults[t] = n.options),
            e.extend(this.proto, n.proto),
            this.modules.push(t)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading..."
        }
    },
    e.fn.magnificPopup = function(n) {
        E();
        var i = e(this);
        if ("string" == typeof n)
            if ("open" === n) {
                var r, o = b ? i.data("magnificPopup") : i[0].magnificPopup, s = parseInt(arguments[1], 10) || 0;
                o.items ? r = o.items[s] : (r = i,
                o.delegate && (r = r.find(o.delegate)),
                r = r.eq(s)),
                t._openClick({
                    mfpEl: r
                }, i, o)
            } else
                t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
        else
            n = e.extend(!0, {}, n),
            b ? i.data("magnificPopup", n) : i[0].magnificPopup = n,
            t.addGroup(i, n);
        return i
    }
    ;
    var P, _, I, O = "inline", A = function() {
        I && (_.after(I.addClass(P)).detach(),
        I = null)
    };
    e.magnificPopup.registerModule(O, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function() {
                t.types.push(O),
                S(a + "." + O, function() {
                    A()
                })
            },
            getInline: function(n, i) {
                if (A(),
                n.src) {
                    var r = t.st.inline
                      , o = e(n.src);
                    if (o.length) {
                        var s = o[0].parentNode;
                        s && s.tagName && (_ || (P = r.hiddenClass,
                        _ = C(P),
                        P = "mfp-" + P),
                        I = o.after(_).detach().removeClass(P)),
                        t.updateStatus("ready")
                    } else
                        t.updateStatus("error", r.tNotFound),
                        o = e("<div>");
                    return n.inlineElement = o,
                    o
                }
                return t.updateStatus("ready"),
                t._parseMarkup(i, {}, n),
                i
            }
        }
    });
    var L, D = "ajax", j = function() {
        L && e(document.body).removeClass(L)
    }, M = function() {
        j(),
        t.req && t.req.abort()
    };
    e.magnificPopup.registerModule(D, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                t.types.push(D),
                L = t.st.ajax.cursor,
                S(a + "." + D, M),
                S("BeforeChange." + D, M)
            },
            getAjax: function(n) {
                L && e(document.body).addClass(L),
                t.updateStatus("loading");
                var i = e.extend({
                    url: n.src,
                    success: function(i, r, o) {
                        var s = {
                            data: i,
                            xhr: o
                        };
                        k("ParseAjax", s),
                        t.appendContent(e(s.data), D),
                        n.finished = !0,
                        j(),
                        t._setFocus(),
                        setTimeout(function() {
                            t.wrap.addClass(v)
                        }, 16),
                        t.updateStatus("ready"),
                        k("AjaxContentAdded")
                    },
                    error: function() {
                        j(),
                        n.finished = n.loadError = !0,
                        t.updateStatus("error", t.st.ajax.tError.replace("%url%", n.src))
                    }
                }, t.st.ajax.settings);
                return t.req = e.ajax(i),
                ""
            }
        }
    });
    var H, F = function(n) {
        if (n.data && void 0 !== n.data.title)
            return n.data.title;
        var i = t.st.image.titleSrc;
        if (i) {
            if (e.isFunction(i))
                return i.call(t, n);
            if (n.el)
                return n.el.attr(i) || ""
        }
        return ""
    };
    e.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var n = t.st.image
                  , i = ".image";
                t.types.push("image"),
                S(h + i, function() {
                    "image" === t.currItem.type && n.cursor && e(document.body).addClass(n.cursor)
                }),
                S(a + i, function() {
                    n.cursor && e(document.body).removeClass(n.cursor),
                    w.off("resize" + m)
                }),
                S("Resize" + i, t.resizeImage),
                t.isLowIE && S("AfterChange", t.resizeImage)
            },
            resizeImage: function() {
                var e = t.currItem;
                if (e && e.img && t.st.image.verticalFit) {
                    var n = 0;
                    t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)),
                    e.img.css("max-height", t.wH - n)
                }
            },
            _onImageHasSize: function(e) {
                e.img && (e.hasSize = !0,
                H && clearInterval(H),
                e.isCheckingImgSize = !1,
                k("ImageHasSize", e),
                e.imgHidden && (t.content && t.content.removeClass("mfp-loading"),
                e.imgHidden = !1))
            },
            findImageSize: function(e) {
                var n = 0
                  , i = e.img[0]
                  , r = function(o) {
                    H && clearInterval(H),
                    H = setInterval(function() {
                        return i.naturalWidth > 0 ? void t._onImageHasSize(e) : (n > 200 && clearInterval(H),
                        n++,
                        void (3 === n ? r(10) : 40 === n ? r(50) : 100 === n && r(500)))
                    }, o)
                };
                r(1)
            },
            getImage: function(n, i) {
                var r = 0
                  , o = function() {
                    n && (n.img[0].complete ? (n.img.off(".mfploader"),
                    n === t.currItem && (t._onImageHasSize(n),
                    t.updateStatus("ready")),
                    n.hasSize = !0,
                    n.loaded = !0,
                    k("ImageLoadComplete")) : (r++,
                    200 > r ? setTimeout(o, 100) : s()))
                }
                  , s = function() {
                    n && (n.img.off(".mfploader"),
                    n === t.currItem && (t._onImageHasSize(n),
                    t.updateStatus("error", a.tError.replace("%url%", n.src))),
                    n.hasSize = !0,
                    n.loaded = !0,
                    n.loadError = !0)
                }
                  , a = t.st.image
                  , l = i.find(".mfp-img");
                if (l.length) {
                    var c = document.createElement("img");
                    c.className = "mfp-img",
                    n.el && n.el.find("img").length && (c.alt = n.el.find("img").attr("alt")),
                    n.img = e(c).on("load.mfploader", o).on("error.mfploader", s),
                    c.src = n.src,
                    l.is("img") && (n.img = n.img.clone()),
                    c = n.img[0],
                    c.naturalWidth > 0 ? n.hasSize = !0 : c.width || (n.hasSize = !1)
                }
                return t._parseMarkup(i, {
                    title: F(n),
                    img_replaceWith: n.img
                }, n),
                t.resizeImage(),
                n.hasSize ? (H && clearInterval(H),
                n.loadError ? (i.addClass("mfp-loading"),
                t.updateStatus("error", a.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"),
                t.updateStatus("ready")),
                i) : (t.updateStatus("loading"),
                n.loading = !0,
                n.hasSize || (n.imgHidden = !0,
                i.addClass("mfp-loading"),
                t.findImageSize(n)),
                i)
            }
        }
    });
    var q, R = function() {
        return void 0 === q && (q = void 0 !== document.createElement("p").style.MozTransform),
        q
    };
    e.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function(e) {
                return e.is("img") ? e : e.find("img")
            }
        },
        proto: {
            initZoom: function() {
                var e, n = t.st.zoom, i = ".zoom";
                if (n.enabled && t.supportsTransition) {
                    var r, o, s = n.duration, c = function(e) {
                        var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image")
                          , i = "all " + n.duration / 1e3 + "s " + n.easing
                          , r = {
                            position: "fixed",
                            zIndex: 9999,
                            left: 0,
                            top: 0,
                            "-webkit-backface-visibility": "hidden"
                        }
                          , o = "transition";
                        return r["-webkit-" + o] = r["-moz-" + o] = r["-o-" + o] = r[o] = i,
                        t.css(r),
                        t
                    }, u = function() {
                        t.content.css("visibility", "visible")
                    };
                    S("BuildControls" + i, function() {
                        if (t._allowZoom()) {
                            if (clearTimeout(r),
                            t.content.css("visibility", "hidden"),
                            e = t._getItemToZoom(),
                            !e)
                                return void u();
                            o = c(e),
                            o.css(t._getOffset()),
                            t.wrap.append(o),
                            r = setTimeout(function() {
                                o.css(t._getOffset(!0)),
                                r = setTimeout(function() {
                                    u(),
                                    setTimeout(function() {
                                        o.remove(),
                                        e = o = null,
                                        k("ZoomAnimationEnded")
                                    }, 16)
                                }, s)
                            }, 16)
                        }
                    }),
                    S(l + i, function() {
                        if (t._allowZoom()) {
                            if (clearTimeout(r),
                            t.st.removalDelay = s,
                            !e) {
                                if (e = t._getItemToZoom(),
                                !e)
                                    return;
                                o = c(e)
                            }
                            o.css(t._getOffset(!0)),
                            t.wrap.append(o),
                            t.content.css("visibility", "hidden"),
                            setTimeout(function() {
                                o.css(t._getOffset())
                            }, 16)
                        }
                    }),
                    S(a + i, function() {
                        t._allowZoom() && (u(),
                        o && o.remove(),
                        e = null)
                    })
                }
            },
            _allowZoom: function() {
                return "image" === t.currItem.type
            },
            _getItemToZoom: function() {
                return !!t.currItem.hasSize && t.currItem.img
            },
            _getOffset: function(n) {
                var i;
                i = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
                var r = i.offset()
                  , o = parseInt(i.css("padding-top"), 10)
                  , s = parseInt(i.css("padding-bottom"), 10);
                r.top -= e(window).scrollTop() - o;
                var a = {
                    width: i.width(),
                    height: (b ? i.innerHeight() : i[0].offsetHeight) - s - o
                };
                return R() ? a["-moz-transform"] = a.transform = "translate(" + r.left + "px," + r.top + "px)" : (a.left = r.left,
                a.top = r.top),
                a
            }
        }
    });
    var $ = "iframe"
      , z = "//about:blank"
      , B = function(e) {
        if (t.currTemplate[$]) {
            var n = t.currTemplate[$].find("iframe");
            n.length && (e || (n[0].src = z),
            t.isIE8 && n.css("display", e ? "block" : "none"))
        }
    };
    e.magnificPopup.registerModule($, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function() {
                t.types.push($),
                S("BeforeChange", function(e, t, n) {
                    t !== n && (t === $ ? B() : n === $ && B(!0))
                }),
                S(a + "." + $, function() {
                    B()
                })
            },
            getIframe: function(n, i) {
                var r = n.src
                  , o = t.st.iframe;
                e.each(o.patterns, function() {
                    return r.indexOf(this.index) > -1 ? (this.id && (r = "string" == typeof this.id ? r.substr(r.lastIndexOf(this.id) + this.id.length, r.length) : this.id.call(this, r)),
                    r = this.src.replace("%id%", r),
                    !1) : void 0
                });
                var s = {};
                return o.srcAction && (s[o.srcAction] = r),
                t._parseMarkup(i, s, n),
                t.updateStatus("ready"),
                i
            }
        }
    });
    var W = function(e) {
        var n = t.items.length;
        return e > n - 1 ? e - n : 0 > e ? n + e : e
    }
      , V = function(e, t, n) {
        return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n)
    };
    e.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function() {
                var n = t.st.gallery
                  , r = ".mfp-gallery"
                  , s = Boolean(e.fn.mfpFastClick);
                return t.direction = !0,
                !(!n || !n.enabled) && (o += " mfp-gallery",
                S(h + r, function() {
                    n.navigateByImgClick && t.wrap.on("click" + r, ".mfp-img", function() {
                        return t.items.length > 1 ? (t.next(),
                        !1) : void 0
                    }),
                    i.on("keydown" + r, function(e) {
                        37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
                    })
                }),
                S("UpdateStatus" + r, function(e, n) {
                    n.text && (n.text = V(n.text, t.currItem.index, t.items.length))
                }),
                S(p + r, function(e, i, r, o) {
                    var s = t.items.length;
                    r.counter = s > 1 ? V(n.tCounter, o.index, s) : ""
                }),
                S("BuildControls" + r, function() {
                    if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
                        var i = n.arrowMarkup
                          , r = t.arrowLeft = e(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(y)
                          , o = t.arrowRight = e(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(y)
                          , a = s ? "mfpFastClick" : "click";
                        r[a](function() {
                            t.prev()
                        }),
                        o[a](function() {
                            t.next()
                        }),
                        t.isIE7 && (C("b", r[0], !1, !0),
                        C("a", r[0], !1, !0),
                        C("b", o[0], !1, !0),
                        C("a", o[0], !1, !0)),
                        t.container.append(r.add(o))
                    }
                }),
                S(f + r, function() {
                    t._preloadTimeout && clearTimeout(t._preloadTimeout),
                    t._preloadTimeout = setTimeout(function() {
                        t.preloadNearbyImages(),
                        t._preloadTimeout = null
                    }, 16)
                }),
                void S(a + r, function() {
                    i.off(r),
                    t.wrap.off("click" + r),
                    t.arrowLeft && s && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(),
                    t.arrowRight = t.arrowLeft = null
                }))
            },
            next: function() {
                t.direction = !0,
                t.index = W(t.index + 1),
                t.updateItemHTML()
            },
            prev: function() {
                t.direction = !1,
                t.index = W(t.index - 1),
                t.updateItemHTML()
            },
            goTo: function(e) {
                t.direction = e >= t.index,
                t.index = e,
                t.updateItemHTML()
            },
            preloadNearbyImages: function() {
                var e, n = t.st.gallery.preload, i = Math.min(n[0], t.items.length), r = Math.min(n[1], t.items.length);
                for (e = 1; e <= (t.direction ? r : i); e++)
                    t._preloadItem(t.index + e);
                for (e = 1; e <= (t.direction ? i : r); e++)
                    t._preloadItem(t.index - e)
            },
            _preloadItem: function(n) {
                if (n = W(n),
                !t.items[n].preloaded) {
                    var i = t.items[n];
                    i.parsed || (i = t.parseEl(n)),
                    k("LazyLoad", i),
                    "image" === i.type && (i.img = e('<img class="mfp-img" />').on("load.mfploader", function() {
                        i.hasSize = !0
                    }).on("error.mfploader", function() {
                        i.hasSize = !0,
                        i.loadError = !0,
                        k("LazyLoadError", i)
                    }).attr("src", i.src)),
                    i.preloaded = !0
                }
            }
        }
    });
    var X = "retina";
    e.magnificPopup.registerModule(X, {
        options: {
            replaceSrc: function(e) {
                return e.src.replace(/\.\w+$/, function(e) {
                    return "@2x" + e
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                if (window.devicePixelRatio > 1) {
                    var e = t.st.retina
                      , n = e.ratio;
                    n = isNaN(n) ? n() : n,
                    n > 1 && (S("ImageHasSize." + X, function(e, t) {
                        t.img.css({
                            "max-width": t.img[0].naturalWidth / n,
                            width: "100%"
                        })
                    }),
                    S("ElementParse." + X, function(t, i) {
                        i.src = e.replaceSrc(i, n)
                    }))
                }
            }
        }
    }),
    function() {
        var t = 1e3
          , n = "ontouchstart"in window
          , i = function() {
            w.off("touchmove" + o + " touchend" + o)
        }
          , r = "mfpFastClick"
          , o = "." + r;
        e.fn.mfpFastClick = function(r) {
            return e(this).each(function() {
                var s, a = e(this);
                if (n) {
                    var l, c, u, p, h, f;
                    a.on("touchstart" + o, function(e) {
                        p = !1,
                        f = 1,
                        h = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0],
                        c = h.clientX,
                        u = h.clientY,
                        w.on("touchmove" + o, function(e) {
                            h = e.originalEvent ? e.originalEvent.touches : e.touches,
                            f = h.length,
                            h = h[0],
                            (Math.abs(h.clientX - c) > 10 || Math.abs(h.clientY - u) > 10) && (p = !0,
                            i())
                        }).on("touchend" + o, function(e) {
                            i(),
                            p || f > 1 || (s = !0,
                            e.preventDefault(),
                            clearTimeout(l),
                            l = setTimeout(function() {
                                s = !1
                            }, t),
                            r())
                        })
                    })
                }
                a.on("click" + o, function() {
                    s || r()
                })
            })
        }
        ,
        e.fn.destroyMfpFastClick = function() {
            e(this).off("touchstart" + o + " click" + o),
            n && w.off("touchmove" + o + " touchend" + o)
        }
    }(),
    E()
}),
/*!
 * match-media.min.js
 */
/* MediaMatch v.2.0.2 - Testing css media queries in Javascript. Authors & copyright (c) 2013: WebLinc, David Knight. */
window.matchMedia || (window.matchMedia = function(e) {
    var t = e.document
      , n = t.documentElement
      , i = []
      , r = 0
      , o = ""
      , s = {}
      , a = /\s*(only|not)?\s*(screen|print|[a-z\-]+)\s*(and)?\s*/i
      , l = /^\s*\(\s*(-[a-z]+-)?(min-|max-)?([a-z\-]+)\s*(:?\s*([0-9]+(\.[0-9]+)?|portrait|landscape)(px|em|dppx|dpcm|rem|%|in|cm|mm|ex|pt|pc|\/([0-9]+(\.[0-9]+)?))?)?\s*\)\s*$/
      , c = 0
      , u = function(e) {
        var t = -1 !== e.indexOf(",") && e.split(",") || [e]
          , n = t.length - 1
          , i = n
          , r = null
          , c = null
          , u = ""
          , p = 0
          , h = !1
          , f = ""
          , d = ""
          , r = null
          , c = 0
          , d = null
          , m = ""
          , v = ""
          , g = ""
          , y = ""
          , x = ""
          , m = !1;
        if ("" === e)
            return !0;
        do
            if (r = t[i - n],
            h = !1,
            (c = r.match(a)) && (u = c[0],
            p = c.index),
            !c || -1 === r.substring(0, p).indexOf("(") && (p || !c[3] && u !== c.input))
                m = !1;
            else {
                if (d = r,
                h = "not" === c[1],
                p || (f = c[2],
                d = r.substring(u.length)),
                m = f === o || "all" === f || "" === f,
                r = -1 !== d.indexOf(" and ") && d.split(" and ") || [d],
                c = r.length - 1,
                m && 0 <= c && "" !== d)
                    do {
                        if (d = r[c].match(l),
                        !d || !s[d[3]]) {
                            m = !1;
                            break
                        }
                        if (m = d[2],
                        y = v = d[5],
                        g = d[7],
                        x = s[d[3]],
                        g && (y = "px" === g ? Number(v) : "em" === g || "rem" === g ? 16 * v : d[8] ? (v / d[8]).toFixed(2) : "dppx" === g ? 96 * v : "dpcm" === g ? .3937 * v : Number(v)),
                        m = "min-" === m && y ? x >= y : "max-" === m && y ? x <= y : y ? x === y : !!x,
                        !m)
                            break
                    } while (c--);
                if (m)
                    break
            }
        while (n--);
        return h ? !m : m
    }
      , p = function() {
        var t = e.innerWidth || n.clientWidth
          , i = e.innerHeight || n.clientHeight
          , r = e.screen.width
          , o = e.screen.height
          , a = e.screen.colorDepth
          , l = e.devicePixelRatio;
        s.width = t,
        s.height = i,
        s["aspect-ratio"] = (t / i).toFixed(2),
        s["device-width"] = r,
        s["device-height"] = o,
        s["device-aspect-ratio"] = (r / o).toFixed(2),
        s.color = a,
        s["color-index"] = Math.pow(2, a),
        s.orientation = i >= t ? "portrait" : "landscape",
        s.resolution = l && 96 * l || e.screen.deviceXDPI || 96,
        s["device-pixel-ratio"] = l || 1
    }
      , h = function() {
        clearTimeout(c),
        c = setTimeout(function() {
            var t = null
              , n = r - 1
              , o = n
              , s = !1;
            if (0 <= n) {
                p();
                do
                    if ((t = i[o - n]) && ((s = u(t.mql.media)) && !t.mql.matches || !s && t.mql.matches) && (t.mql.matches = s,
                    t.listeners))
                        for (var s = 0, a = t.listeners.length; s < a; s++)
                            t.listeners[s] && t.listeners[s].call(e, t.mql);
                while (n--)
            }
        }, 10)
    }
      , f = t.getElementsByTagName("head")[0]
      , t = t.createElement("style")
      , d = null
      , m = "screen print speech projection handheld tv braille embossed tty".split(" ")
      , v = 0
      , g = m.length
      , y = "#mediamatchjs { position: relative; z-index: 0; }"
      , x = ""
      , b = e.addEventListener || (x = "on") && e.attachEvent;
    for (t.type = "text/css",
    t.id = "mediamatchjs",
    f.appendChild(t),
    d = e.getComputedStyle && e.getComputedStyle(t) || t.currentStyle; v < g; v++)
        y += "@media " + m[v] + " { #mediamatchjs { position: relative; z-index: " + v + " } }";
    return t.styleSheet ? t.styleSheet.cssText = y : t.textContent = y,
    o = m[1 * d.zIndex || 0],
    f.removeChild(t),
    p(),
    b(x + "resize", h),
    b(x + "orientationchange", h),
    function(e) {
        var t = r
          , n = {
            matches: !1,
            media: e,
            addListener: function(e) {
                i[t].listeners || (i[t].listeners = []),
                e && i[t].listeners.push(e)
            },
            removeListener: function(e) {
                var n = i[t]
                  , r = 0
                  , o = 0;
                if (n)
                    for (o = n.listeners.length; r < o; r++)
                        n.listeners[r] === e && n.listeners.splice(r, 1)
            }
        };
        return "" === e ? (n.matches = !0,
        n) : (n.matches = u(e),
        r = i.push({
            mql: n,
            listeners: null
        }),
        n)
    }
}(window)),
window.Modernizr = function(e, t, n) {
    function i(e) {
        y.cssText = e
    }
    function r(e, t) {
        return typeof e === t
    }
    function o(e, t) {
        return !!~("" + e).indexOf(t)
    }
    function s(e, t) {
        for (var i in e) {
            var r = e[i];
            if (!o(r, "-") && y[r] !== n)
                return "pfx" != t || r
        }
        return !1
    }
    function a(e, t, i) {
        for (var o in e) {
            var s = t[e[o]];
            if (s !== n)
                return i === !1 ? e[o] : r(s, "function") ? s.bind(i || t) : s
        }
        return !1
    }
    function l(e, t, n) {
        var i = e.charAt(0).toUpperCase() + e.slice(1)
          , o = (e + " " + w.join(i + " ") + i).split(" ");
        return r(t, "string") || r(t, "undefined") ? s(o, t) : (o = (e + " " + S.join(i + " ") + i).split(" "),
        a(o, t, n))
    }
    var c, u, p, h = "2.8.2", f = {}, d = !0, m = t.documentElement, v = "modernizr", g = t.createElement(v), y = g.style, x = ({}.toString,
    " -webkit- -moz- -o- -ms- ".split(" ")), b = "Webkit Moz O ms", w = b.split(" "), S = b.toLowerCase().split(" "), C = {}, k = [], T = k.slice, E = function(e, n, i, r) {
        var o, s, a, l, c = t.createElement("div"), u = t.body, p = u || t.createElement("body");
        if (parseInt(i, 10))
            for (; i--; )
                a = t.createElement("div"),
                a.id = r ? r[i] : v + (i + 1),
                c.appendChild(a);
        return o = ["&#173;", '<style id="s', v, '">', e, "</style>"].join(""),
        c.id = v,
        (u ? c : p).innerHTML += o,
        p.appendChild(c),
        u || (p.style.background = "",
        p.style.overflow = "hidden",
        l = m.style.overflow,
        m.style.overflow = "hidden",
        m.appendChild(p)),
        s = n(c, e),
        u ? c.parentNode.removeChild(c) : (p.parentNode.removeChild(p),
        m.style.overflow = l),
        !!s
    }, N = {}.hasOwnProperty;
    p = r(N, "undefined") || r(N.call, "undefined") ? function(e, t) {
        return t in e && r(e.constructor.prototype[t], "undefined")
    }
    : function(e, t) {
        return N.call(e, t)
    }
    ,
    Function.prototype.bind || (Function.prototype.bind = function(e) {
        var t = this;
        if ("function" != typeof t)
            throw new TypeError;
        var n = T.call(arguments, 1)
          , i = function() {
            if (this instanceof i) {
                var r = function() {};
                r.prototype = t.prototype;
                var o = new r
                  , s = t.apply(o, n.concat(T.call(arguments)));
                return Object(s) === s ? s : o
            }
            return t.apply(e, n.concat(T.call(arguments)))
        };
        return i
    }
    ),
    C.touch = function() {
        var n;
        return "ontouchstart"in e || e.DocumentTouch && t instanceof DocumentTouch ? n = !0 : E(["@media (", x.join("touch-enabled),("), v, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function(e) {
            n = 9 === e.offsetTop
        }),
        n
    }
    ,
    C.csstransforms = function() {
        return !!l("transform")
    }
    ,
    C.csstransforms3d = function() {
        var e = !!l("perspective");
        return e && "webkitPerspective"in m.style && E("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function(t, n) {
            e = 9 === t.offsetLeft && 3 === t.offsetHeight
        }),
        e
    }
    ,
    C.fontface = function() {
        var e;
        return E('@font-face {font-family:"font";src:url("https://")}', function(n, i) {
            var r = t.getElementById("smodernizr")
              , o = r.sheet || r.styleSheet
              , s = o ? o.cssRules && o.cssRules[0] ? o.cssRules[0].cssText : o.cssText || "" : "";
            e = /src/i.test(s) && 0 === s.indexOf(i.split(" ")[0])
        }),
        e
    }
    ;
    for (var P in C)
        p(C, P) && (u = P.toLowerCase(),
        f[u] = C[P](),
        k.push((f[u] ? "" : "no-") + u));
    return f.addTest = function(e, t) {
        if ("object" == typeof e)
            for (var i in e)
                p(e, i) && f.addTest(i, e[i]);
        else {
            if (e = e.toLowerCase(),
            f[e] !== n)
                return f;
            t = "function" == typeof t ? t() : t,
            "undefined" != typeof d && d && (m.className += " supports-" + (t ? "" : "no-") + e),
            f[e] = t
        }
        return f
    }
    ,
    i(""),
    g = c = null,
    f._version = h,
    f._prefixes = x,
    f._domPrefixes = S,
    f._cssomPrefixes = w,
    f.testProp = function(e) {
        return s([e])
    }
    ,
    f.testAllProps = l,
    f.testStyles = E,
    m.className = m.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (d ? " supports-js supports-" + k.join(" supports-") : ""),
    f
}(this, this.document),
/*!
* option_selector.js
*/
function() {
    "undefined" == typeof window.Shopify && (window.Shopify = {}),
    Shopify.each = function(e, t) {
        for (var n = 0; n < e.length; n++)
            t(e[n], n)
    }
    ,
    Shopify.map = function(e, t) {
        for (var n = [], i = 0; i < e.length; i++)
            n.push(t(e[i], i));
        return n
    }
    ,
    Shopify.arrayIncludes = function(e, t) {
        for (var n = 0; n < e.length; n++)
            if (e[n] == t)
                return !0;
        return !1
    }
    ,
    Shopify.uniq = function(e) {
        for (var t = [], n = 0; n < e.length; n++)
            Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t
    }
    ,
    Shopify.isDefined = function(e) {
        return "undefined" != typeof e
    }
    ,
    Shopify.getClass = function(e) {
        return Object.prototype.toString.call(e).slice(8, -1)
    }
    ,
    Shopify.extend = function(e, t) {
        function n() {}
        n.prototype = t.prototype,
        e.prototype = new n,
        e.prototype.constructor = e,
        e.baseConstructor = t,
        e.superClass = t.prototype
    }
    ,
    Shopify.locationSearch = function() {
        return window.location.search
    }
    ,
    Shopify.locationHash = function() {
        return window.location.hash
    }
    ,
    Shopify.replaceState = function(e) {
        window.history.replaceState({}, document.title, e)
    }
    ,
    Shopify.urlParam = function(e) {
        var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
        return t && decodeURIComponent(t[1].replace(/\+/g, " "))
    }
    ,
    Shopify.newState = function(e, t) {
        var n;
        return n = Shopify.urlParam(e) ? Shopify.locationSearch().replace(RegExp("(" + e + "=)[^&#]+"), "$1" + t) : "" === Shopify.locationSearch() ? "?" + e + "=" + t : Shopify.locationSearch() + "&" + e + "=" + t,
        n + Shopify.locationHash()
    }
    ,
    Shopify.setParam = function(e, t) {
        Shopify.replaceState(Shopify.newState(e, t))
    }
    ,
    Shopify.Product = function(e) {
        Shopify.isDefined(e) && this.update(e)
    }
    ,
    Shopify.Product.prototype.update = function(e) {
        for (property in e)
            this[property] = e[property]
    }
    ,
    Shopify.Product.prototype.optionNames = function() {
        return "Array" == Shopify.getClass(this.options) ? this.options : []
    }
    ,
    Shopify.Product.prototype.optionValues = function(e) {
        if (!Shopify.isDefined(this.variants))
            return null;
        var t = Shopify.map(this.variants, function(t) {
            var n = "option" + (e + 1);
            return void 0 == t[n] ? null : t[n]
        });
        return null == t[0] ? null : Shopify.uniq(t)
    }
    ,
    Shopify.Product.prototype.getVariant = function(e) {
        var t = null;
        return e.length != this.options.length ? t : (Shopify.each(this.variants, function(n) {
            for (var i = !0, r = 0; r < e.length; r++) {
                var o = "option" + (r + 1);
                n[o] != e[r] && (i = !1)
            }
            if (1 == i)
                return void (t = n)
        }),
        t)
    }
    ,
    Shopify.Product.prototype.getVariantById = function(e) {
        for (var t = 0; t < this.variants.length; t++) {
            var n = this.variants[t];
            if (e == n.id)
                return n
        }
        return null
    }
    ,
    Shopify.money_format = "${{amount}}",
    Shopify.formatMoney = function(e, t) {
        function n(e, t) {
            return "undefined" == typeof e ? t : e
        }
        function i(e, t, i, r) {
            if (t = n(t, 2),
            i = n(i, ","),
            r = n(r, "."),
            isNaN(e) || null == e)
                return 0;
            e = (e / 100).toFixed(t);
            var o = e.split(".")
              , s = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i)
              , a = o[1] ? r + o[1] : "";
            return s + a
        }
        "string" == typeof e && (e = e.replace(".", ""));
        var r = ""
          , o = /\{\{\s*(\w+)\s*\}\}/
          , s = t || this.money_format;
        switch (s.match(o)[1]) {
        case "amount":
            r = i(e, 2);
            break;
        case "amount_no_decimals":
            r = i(e, 0);
            break;
        case "amount_with_comma_separator":
            r = i(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            r = i(e, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            r = i(e, 0, " ")
        }
        return s.replace(o, r)
    }
    ,
    Shopify.OptionSelectors = function(e, t) {
        return this.selectorDivClass = "selector-wrapper",
        this.selectorClass = "single-option-selector",
        this.variantIdFieldIdSuffix = "-variant-id",
        this.variantIdField = null,
        this.historyState = null,
        this.selectors = [],
        this.domIdPrefix = e,
        this.product = new Shopify.Product(t.product),
        this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function() {}
        ,
        this.setActiveThumbnail = t.setActiveThumbnail,
        this.switchProductImage = t.switchProductImage,
        this.settings = t.settings,
        this.replaceSelector(e),
        this.initDropdown(),
        t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
        !0
    }
    ,
    Shopify.OptionSelectors.prototype.initDropdown = function() {
        var e = {
            initialLoad: !0
        }
          , t = this.selectVariantFromDropdown(e);
        if (!t) {
            var n = this;
            setTimeout(function() {
                n.selectVariantFromParams(e) || n.fireOnChangeForFirstDropdown.call(n, e)
            })
        }
    }
    ,
    Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(e) {
        this.selectors[0].element.onchange(e)
    }
    ,
    Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(e) {
        var t = this.selectVariantFromParams(e);
        t || this.selectVariantFromDropdown(e)
    }
    ,
    Shopify.OptionSelectors.prototype.replaceSelector = function(e) {
        var t = document.getElementById(e)
          , n = t.parentNode;
        Shopify.each(this.buildSelectors(), function(e) {
            n.insertBefore(e, t)
        }),
        t.style.display = "none",
        this.variantIdField = t
    }
    ,
    Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(e) {
        var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if (t || (t = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
        !t)
            return !1;
        var n = t.value;
        return this.selectVariant(n, e)
    }
    ,
    Shopify.OptionSelectors.prototype.selectVariantFromParams = function(e) {
        var t = Shopify.urlParam("variant");
        return this.selectVariant(t, e)
    }
    ,
    Shopify.OptionSelectors.prototype.selectVariant = function(e, t) {
        var n = this.product.getVariantById(e);
        if (null == n)
            return !1;
        for (var i = 0; i < this.selectors.length; i++) {
            var r = this.selectors[i].element
              , o = r.getAttribute("data-option")
              , s = n[o];
            null != s && this.optionExistInSelect(r, s) && (r.value = s)
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t),
        !0
    }
    ,
    Shopify.OptionSelectors.prototype.optionExistInSelect = function(e, t) {
        for (var n = 0; n < e.options.length; n++)
            if (e.options[n].value == t)
                return !0
    }
    ,
    Shopify.OptionSelectors.prototype.insertSelectors = function(e, t) {
        Shopify.isDefined(t) && this.setMessageElement(t),
        this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
        var n = document.getElementById(e);
        Shopify.each(this.buildSelectors(), function(e) {
            n.appendChild(e)
        })
    }
    ,
    Shopify.OptionSelectors.prototype.buildSelectors = function() {
        for (var e = 0; e < this.product.optionNames().length; e++) {
            var t = new Shopify.SingleOptionSelector(this,e,this.product.optionNames()[e],this.product.optionValues(e));
            t.element.disabled = !1,
            this.selectors.push(t)
        }
        var n = this.selectorDivClass
          , i = this.product.optionNames()
          , r = Shopify.map(this.selectors, function(e) {
            var t = document.createElement("div");
            if (t.setAttribute("class", n),
            i.length >= 1 && "Title" !== i[0]) {
                var r = document.createElement("label");
                r.htmlFor = e.element.id,
                r.innerHTML = e.name,
                t.appendChild(r)
            }
            return t.appendChild(e.element),
            t
        });
        return r
    }
    ,
    Shopify.OptionSelectors.prototype.selectedValues = function() {
        for (var e = [], t = 0; t < this.selectors.length; t++) {
            var n = this.selectors[t].element.value;
            e.push(n)
        }
        return e
    }
    ,
    Shopify.OptionSelectors.prototype.updateSelectors = function(e, t) {
        var n = this.selectedValues()
          , i = this.product.getVariant(n);
        i ? (this.variantIdField.disabled = !1,
        this.variantIdField.value = i.id) : this.variantIdField.disabled = !0,
        this.onVariantSelected(i, this, t),
        null != this.historyState && this.historyState.onVariantChange(i, this, t)
    }
    ,
    Shopify.OptionSelectorsFromDOM = function(e, t) {
        var n = t.optionNames || []
          , i = t.priceFieldExists || !0
          , r = t.delimiter || "/"
          , o = this.createProductFromSelector(e, n, i, r);
        t.product = o,
        Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t)
    }
    ,
    Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
    Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(e, t, n, i) {
        if (!Shopify.isDefined(n))
            var n = !0;
        if (!Shopify.isDefined(i))
            var i = "/";
        var r = document.getElementById(e)
          , o = r.childNodes
          , s = (r.parentNode,
        t.length)
          , a = [];
        Shopify.each(o, function(e, r) {
            if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
                var o = e.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
                0 == t.length && (s = o.length - (n ? 1 : 0));
                var l = o.slice(0, s)
                  , c = n ? o[s] : ""
                  , u = (e.getAttribute("value"),
                {
                    available: !e.disabled,
                    id: parseFloat(e.value),
                    price: c,
                    option1: l[0],
                    option2: l[1],
                    option3: l[2]
                });
                a.push(u)
            }
        });
        var l = {
            variants: a
        };
        if (0 == t.length) {
            l.options = [];
            for (var c = 0; c < s; c++)
                l.options[c] = "option " + (c + 1)
        } else
            l.options = t;
        return l
    }
    ,
    Shopify.SingleOptionSelector = function(e, t, n, i) {
        this.multiSelector = e,
        this.values = i,
        this.index = t,
        this.name = n,
        this.element = document.createElement("select");
        for (var r = 0; r < i.length; r++) {
            var o = document.createElement("option");
            o.value = i[r],
            o.innerHTML = i[r],
            this.element.appendChild(o)
        }
        return this.element.setAttribute("class", this.multiSelector.selectorClass),
        this.element.setAttribute("data-option", "option" + (t + 1)),
        this.element.id = e.domIdPrefix + "-option-" + t,
        this.element.onchange = function(n, i) {
            i = i || {},
            e.updateSelectors(t, i)
        }
        ,
        !0
    }
    ,
    Shopify.Image = {
        preload: function(e, t) {
            for (var n = 0; n < e.length; n++) {
                var i = e[n];
                this.loadImage(this.getSizedImageUrl(i, t))
            }
        },
        loadImage: function(e) {
            (new Image).src = e
        },
        switchImage: function(e, t, n) {
            if (e && t) {
                var i = this.imageSize(t.src)
                  , r = this.getSizedImageUrl(e.src, i);
                n ? n(r, e, t) : t.src = r
            }
        },
        imageSize: function(e) {
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return null !== t ? t[1] : null
        },
        getSizedImageUrl: function(e, t) {
            if (null == t)
                return e;
            if ("master" == t)
                return this.removeProtocol(e);
            var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null != n) {
                var i = e.split(n[0])
                  , r = n[0];
                return this.removeProtocol(i[0] + "_" + t + r)
            }
            return null
        },
        removeProtocol: function(e) {
            return e.replace(/http(s)?:/, "")
        }
    },
    Shopify.OptionSelectors.HistoryState = function(e) {
        this.browserSupports() && this.register(e)
    }
    ,
    Shopify.OptionSelectors.HistoryState.prototype.register = function(e) {
        window.addEventListener("popstate", function(t) {
            e.selectVariantFromParamsOrDropdown({
                popStateCall: !0
            })
        })
    }
    ,
    Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(e, t, n) {
        this.browserSupports() && (!e || n.initialLoad || n.popStateCall || Shopify.setParam("variant", e.id))
    }
    ,
    Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
        return window.history && window.history.replaceState
    }
}(),
/*!
* respond.min.js
*/
/*! Respond.js v1.4.2: min/max-width media query polyfill
 * Copyright 2014 Scott Jehl
 * Licensed under MIT
 * http://j.mp/respondjs */
!function(e) {
    "use strict";
    e.matchMedia = e.matchMedia || function(e) {
        var t, n = e.documentElement, i = n.firstElementChild || n.firstChild, r = e.createElement("body"), o = e.createElement("div");
        return o.id = "mq-test-1",
        o.style.cssText = "position:absolute;top:-100em",
        r.style.background = "none",
        r.appendChild(o),
        function(e) {
            return o.innerHTML = '&shy;<style media="' + e + '"> #mq-test-1 { width: 42px; }</style>',
            n.insertBefore(r, i),
            t = 42 === o.offsetWidth,
            n.removeChild(r),
            {
                matches: t,
                media: e
            }
        }
    }(e.document)
}(this),
function(e) {
    "use strict";
    function t() {
        w(!0)
    }
    var n = {};
    e.respond = n,
    n.update = function() {}
    ;
    var i = []
      , r = function() {
        var t = !1;
        try {
            t = new e.XMLHttpRequest
        } catch (n) {
            t = new e.ActiveXObject("Microsoft.XMLHTTP")
        }
        return function() {
            return t
        }
    }()
      , o = function(e, t) {
        var n = r();
        n && (n.open("GET", e, !0),
        n.onreadystatechange = function() {
            4 !== n.readyState || 200 !== n.status && 304 !== n.status || t(n.responseText)
        }
        ,
        4 !== n.readyState && n.send(null))
    }
      , s = function(e) {
        return e.replace(n.regex.minmaxwh, "").match(n.regex.other)
    };
    if (n.ajax = o,
    n.queue = i,
    n.unsupportedmq = s,
    n.regex = {
        media: /@media[^\{]+\{([^\{\}]*\{[^\}\{]*\})+/gi,
        keyframes: /@(?:\-(?:o|moz|webkit)\-)?keyframes[^\{]+\{(?:[^\{\}]*\{[^\}\{]*\})+[^\}]*\}/gi,
        comments: /\/\*[^*]*\*+([^\/][^*]*\*+)*\//gi,
        urls: /(url\()['"]?([^\/\)'"][^:\)'"]+)['"]?(\))/g,
        findStyles: /@media *([^\{]+)\{([\S\s]+?)$/,
        only: /(only\s+)?([a-zA-Z]+)\s?/,
        minw: /\(\s*min\-width\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/,
        maxw: /\(\s*max\-width\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/,
        minmaxwh: /\(\s*m(in|ax)\-(height|width)\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/gi,
        other: /\([^\)]*\)/g
    },
    n.mediaQueriesSupported = e.matchMedia && null !== e.matchMedia("only all") && e.matchMedia("only all").matches,
    !n.mediaQueriesSupported) {
        var a, l, c, u = e.document, p = u.documentElement, h = [], f = [], d = [], m = {}, v = 30, g = u.getElementsByTagName("head")[0] || p, y = u.getElementsByTagName("base")[0], x = g.getElementsByTagName("link"), b = function() {
            var e, t = u.createElement("div"), n = u.body, i = p.style.fontSize, r = n && n.style.fontSize, o = !1;
            return t.style.cssText = "position:absolute;font-size:1em;width:1em",
            n || (n = o = u.createElement("body"),
            n.style.background = "none"),
            p.style.fontSize = "100%",
            n.style.fontSize = "100%",
            n.appendChild(t),
            o && p.insertBefore(n, p.firstChild),
            e = t.offsetWidth,
            o ? p.removeChild(n) : n.removeChild(t),
            p.style.fontSize = i,
            r && (n.style.fontSize = r),
            e = c = parseFloat(e)
        }, w = function(t) {
            var n = "clientWidth"
              , i = p[n]
              , r = "CSS1Compat" === u.compatMode && i || u.body[n] || i
              , o = {}
              , s = x[x.length - 1]
              , m = (new Date).getTime();
            if (t && a && v > m - a)
                return e.clearTimeout(l),
                void (l = e.setTimeout(w, v));
            a = m;
            for (var y in h)
                if (h.hasOwnProperty(y)) {
                    var S = h[y]
                      , C = S.minw
                      , k = S.maxw
                      , T = null === C
                      , E = null === k
                      , N = "em";
                    C && (C = parseFloat(C) * (C.indexOf(N) > -1 ? c || b() : 1)),
                    k && (k = parseFloat(k) * (k.indexOf(N) > -1 ? c || b() : 1)),
                    S.hasquery && (T && E || !(T || r >= C) || !(E || k >= r)) || (o[S.media] || (o[S.media] = []),
                    o[S.media].push(f[S.rules]))
                }
            for (var P in d)
                d.hasOwnProperty(P) && d[P] && d[P].parentNode === g && g.removeChild(d[P]);
            d.length = 0;
            for (var _ in o)
                if (o.hasOwnProperty(_)) {
                    var I = u.createElement("style")
                      , O = o[_].join("\n");
                    I.type = "text/css",
                    I.media = _,
                    g.insertBefore(I, s.nextSibling),
                    I.styleSheet ? I.styleSheet.cssText = O : I.appendChild(u.createTextNode(O)),
                    d.push(I)
                }
        }, S = function(e, t, i) {
            var r = e.replace(n.regex.comments, "").replace(n.regex.keyframes, "").match(n.regex.media)
              , o = r && r.length || 0;
            t = t.substring(0, t.lastIndexOf("/"));
            var a = function(e) {
                return e.replace(n.regex.urls, "$1" + t + "$2$3")
            }
              , l = !o && i;
            t.length && (t += "/"),
            l && (o = 1);
            for (var c = 0; o > c; c++) {
                var u, p, d, m;
                l ? (u = i,
                f.push(a(e))) : (u = r[c].match(n.regex.findStyles) && RegExp.$1,
                f.push(RegExp.$2 && a(RegExp.$2))),
                d = u.split(","),
                m = d.length;
                for (var v = 0; m > v; v++)
                    p = d[v],
                    s(p) || h.push({
                        media: p.split("(")[0].match(n.regex.only) && RegExp.$2 || "all",
                        rules: f.length - 1,
                        hasquery: p.indexOf("(") > -1,
                        minw: p.match(n.regex.minw) && parseFloat(RegExp.$1) + (RegExp.$2 || ""),
                        maxw: p.match(n.regex.maxw) && parseFloat(RegExp.$1) + (RegExp.$2 || "")
                    })
            }
            w()
        }, C = function() {
            if (i.length) {
                var t = i.shift();
                o(t.href, function(n) {
                    S(n, t.href, t.media),
                    m[t.href] = !0,
                    e.setTimeout(function() {
                        C()
                    }, 0)
                })
            }
        }, k = function() {
            for (var t = 0; t < x.length; t++) {
                var n = x[t]
                  , r = n.href
                  , o = n.media
                  , s = n.rel && "stylesheet" === n.rel.toLowerCase();
                r && s && !m[r] && (n.styleSheet && n.styleSheet.rawCssText ? (S(n.styleSheet.rawCssText, r, o),
                m[r] = !0) : (!/^([a-zA-Z:]*\/\/)/.test(r) && !y || r.replace(RegExp.$1, "").split("/")[0] === e.location.host) && ("//" === r.substring(0, 2) && (r = e.location.protocol + r),
                i.push({
                    href: r,
                    media: o
                })))
            }
            C()
        };
        k(),
        n.update = k,
        n.getEmValue = b,
        e.addEventListener ? e.addEventListener("resize", t, !1) : e.attachEvent && e.attachEvent("onresize", t)
    }
}(this);
